var enroller;
(function (enroller) {
    let ViewModalSize;
    (function (ViewModalSize) {
        ViewModalSize[ViewModalSize["Default"] = 0] = "Default";
        ViewModalSize[ViewModalSize["Large"] = 1] = "Large";
        ViewModalSize[ViewModalSize["Small"] = 2] = "Small";
        ViewModalSize[ViewModalSize["Full"] = 3] = "Full";
    })(ViewModalSize = enroller.ViewModalSize || (enroller.ViewModalSize = {}));
    class ModalView extends kendo.View {
        constructor(element, options) {
            super(element, options);
            if (options?.shown) {
                this.bind("shown", options.shown);
            }
            if (options?.hidden) {
                this.bind("hidden", options.hidden);
            }
        }
    }
    enroller.ModalView = ModalView;
    class ModalSubLayout extends kendo.Layout {
        constructor(element, options) {
            super(element, options);
            if (options?.shown) {
                this.bind("shown", options.shown);
            }
            if (options?.hidden) {
                this.bind("hidden", options.hidden);
            }
        }
    }
    enroller.ModalSubLayout = ModalSubLayout;
    class ViewModal {
        get views() {
            return this._views;
        }
        get layout() {
            return this._layout.layout;
        }
        constructor(config) {
            if (!config) {
                config = {};
            }
            if (!config.modal) {
                config.modal = "Enroller-ViewModal";
            }
            this._views = {};
            this._defaultModalSize = config.modalSize || ViewModalSize.Default;
            this._contentSelector = config.contentSelector || '.modal-dialog';
            this._layoutId = '#' + config.modal.replace('#', '');
            this._layout = this.getOrCreateLayout(config);
            this.activeView = null;
        }
        getOrCreateLayout(config) {
            if (ViewModal._layouts[this._layoutId]) {
                return ViewModal._layouts[this._layoutId];
            }
            this.modal = $(this._layoutId);
            let isDefault = false;
            if (this.modal.length == 0) {
                var dom = '<div class="modal fade" id="' + this._layoutId.replace('#', '') + '" tabindex= "-1" role="dialog" aria-labelledby="' + config.modal + 'Label" >' +
                    '<div data-bind="attr: { class: modalSizeClass }" class="modal-dialog" role="document"></div>' +
                    '</div>';
                this.modal = $(dom).appendTo('main');
                isDefault = true;
            }
            this.modal.on("hidden.bs.modal", (e) => {
                if (window.location.hash !== "#/") {
                    if (config?.events?.cancel != undefined) {
                        config.events.cancel(e);
                    }
                    if (!e.isDefaultPrevented()) {
                        this.activeView.trigger("hidden", {
                            sender: this.activeView,
                        });
                    }
                }
                if (config?.events?.close != undefined) {
                    config.events.close(e);
                }
            });
            this.modal.on("show.bs.modal", (e) => {
                if (config?.events?.opening != undefined) {
                    config.events.opening(e);
                }
                if (this.activeView instanceof ModalView) {
                }
            });
            this.modal.on("shown.bs.modal", (e) => {
                if (config?.events?.open != undefined) {
                    config.events.open(e);
                }
                if (!e.isDefaultPrevented()) {
                    $(e.target).find('[autofocus]').focus();
                    this.activeView.trigger("shown", {
                        sender: this.activeView
                    });
                }
            });
            let that = this;
            let layoutOptions = $.extend(true, {}, {
                model: {
                    modalSize: config.modalSize,
                    modalSizeClass: function () {
                        let size = this.get("modalSize") || that._defaultModalSize;
                        return size === ViewModalSize.Large
                            ? "modal-dialog modal-lg"
                            : size === ViewModalSize.Small
                                ? "modal-dialog modal-sm"
                                : size === ViewModalSize.Full
                                    ? "modal-dialog modal-full"
                                    : "modal-dialog";
                    }
                }
            }, config.layoutOptions);
            layoutOptions.model = kendo.observable(layoutOptions.model);
            ViewModal._layouts[this._layoutId] = {
                layout: new kendo.Layout(this._layoutId, layoutOptions),
                isDefault: isDefault,
                modal: this.modal
            };
            return ViewModal._layouts[this._layoutId];
        }
        setLayoutModel(model) {
            model = model || {};
            if (model["modalSize"] === undefined) {
                model["modalSize"] = this._defaultModalSize;
            }
            var layoutModel = this._layout.layout.model;
            for (var property in model) {
                if (model.hasOwnProperty(property)) {
                    layoutModel.set(property, model[property]);
                }
            }
        }
        show(view, { animation = null, selector = null, open = true, model = null, size = ViewModalSize.Default } = {}) {
            if (view == null) {
                throw "View is null.";
            }
            this.activeView = view;
            model = model || {};
            model["modalSize"] = size || model["modalSize"] || this._defaultModalSize;
            this.setLayoutModel(model);
            if (!selector) {
                selector = '#' + this._layout.modal[0].id + ' ' + this._contentSelector;
            }
            this._layout.layout.showIn(selector, view, animation);
            if (open) {
                this._layout.modal.modal('show');
            }
            if (this._layout.isDefault) {
                view.element.addClass("modal-content");
            }
        }
        close() {
            this._layout.modal.modal("hide");
        }
    }
    ViewModal._layouts = {};
    ViewModal._emptyView = new kendo.View($('<div></div>')[0], { wrap: false });
    enroller.ViewModal = ViewModal;
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class SourceViewModal extends enroller.ViewModal {
        constructor(options) {
            let prefix = options.templatePrefix || "SourceModal-" + options.route;
            super({
                modal: prefix,
                modalSize: options.size || enroller.ViewModalSize.Default,
                events: {
                    cancel: () => {
                        this.source.cancelChanges();
                    },
                    close: () => {
                        this.source.cancelChanges();
                    }
                }
            });
            this.options = options;
            this.itemModelKey = options.itemModelKey || "item";
            if (options.source instanceof kendo.data.DataSource) {
                this.source = options.source;
            }
            else {
                let grid = $(options.source).data("kendoGrid");
                this.source = grid.dataSource;
            }
            this.source.bind("error", this.handleError.bind(this));
            this.views.create = this.initCreateView(options);
            this.views.update = this.initUpdateView(options);
            this.views.remove = this.initRemoveView(options);
            this.initRoot(options, prefix);
        }
        handleError(e) {
            let errors = enroller.util.extractModelStateErrors(e.xhr);
            if (this.activeView) {
                this.activeView.model.set("errors", errors);
            }
        }
        initCreateView(config) {
            let element = this._getTemplateElement("create", config, (config.templates || {}).create, "Create", "Form");
            if (element == null) {
                return;
            }
            return new kendo.View(element, {
                model: this.initCreateModel(config),
                init: (e) => {
                    if (e.sender.element.length == 0) {
                        this.error("SourceModal: Attempting to initialize view. Could not find root element of '" + e.sender.content + "'");
                        return;
                    }
                    this.initValidator(e);
                    if (config.events && config.events.initView && config.events.initView.create) {
                        config.events.initView.create(e);
                    }
                },
                show: (e) => {
                    e.sender.element.data('kendoValidator').hideMessages();
                    if (config.events && config.events.show && config.events.show.create) {
                        config.events.show.create(e);
                    }
                }
            });
        }
        error(message) {
            if (location.hostname === "localhost") {
                console.error(message);
            }
        }
        warn(message) {
            if (location.hostname === "localhost") {
                console.warn(message);
            }
        }
        initUpdateView(config) {
            let element = this._getTemplateElement("update", config, (config.templates || {}).update, "Update", "Form");
            if (element == null) {
                return;
            }
            return new kendo.View(element, {
                model: this.initUpdateModel(config),
                init: (e) => {
                    if (e.sender.element.length == 0) {
                        this.error(`SourceModal: Attempting to initialize view. Could not find root element of '${e.sender.content}'`);
                        return;
                    }
                    this.initValidator(e);
                    if (config.events?.initView?.update) {
                        config.events.initView.update(e);
                    }
                },
                show: (e) => {
                    e.sender.element.data('kendoValidator').hideMessages();
                    if (config.events?.show?.update) {
                        config.events.show.update(e);
                    }
                }
            });
        }
        initRemoveView(config) {
            let element = this._getTemplateElement("remove", config, (config.templates || {}).remove, "Remove");
            if (element == null) {
                return;
            }
            return new kendo.View(element, {
                model: this.initRemoveModel(config),
                init: (e) => {
                    if (config.events?.initView?.remove) {
                        config.events.initView.remove(e);
                    }
                },
                show: (e) => {
                    if (config.events?.show?.remove) {
                        config.events.show.remove(e);
                    }
                }
            });
        }
        _getTemplateElement(transport, config, ...args) {
            let prefix = config.templatePrefix || "SourceModal-" + config.route;
            let missedIds = [];
            for (let i = 0; i < args.length; i++) {
                if (args[i]) {
                    let id = i == 0
                        ? args[i]
                        : `#${prefix}-${args[i]}`;
                    let el = $(id);
                    if (el.length > 0) {
                        return el[0];
                    }
                    else {
                        missedIds.push(id);
                    }
                }
            }
            if (this.source.options.transport && this.source.options.transport[transport]) {
                this.warn(`SourceModal: No element found for '${transport}' matching ${missedIds}`);
            }
            return null;
        }
        initRoot(config, prefix) {
            let rootId = (config.templates || {}).root
                || `#${prefix}-Root`;
            let el = $(rootId);
            if (el.length == 0 && (config.templates || {}).root) {
                this.error(`SourceModal: Attempted to bind root '${(config.templates || {}).root}' but none found.`);
            }
            else if (el.length > 0) {
                kendo.bind(el, {
                    items: this.source,
                });
            }
        }
        create(item, modelProps) {
            if (this.views.create == null) {
                this.error("SourceModal: Routing to create, but no view initialized.");
                return;
            }
            let model = this.views.create.model;
            let itemModel = this.source.add(item ?? {});
            model.set(this.itemModelKey, itemModel);
            if (modelProps) {
                for (let k in modelProps) {
                    if (modelProps.hasOwnProperty(k) && k != this.itemModelKey) {
                        model.set(k, modelProps[k]);
                    }
                }
            }
            this.show(this.views.create);
        }
        update(id) {
            if (this.views.update == null) {
                this.error("SourceModal: Routing to update, but no view initialized.");
                return;
            }
            let model = this.views.update.model;
            let item = this.source.get(id);
            model.set(this.itemModelKey, item);
            this.show(this.views.update);
        }
        remove(id) {
            if (this.views.remove == null) {
                this.error("SourceModal: Routing to remove, but no view initialized.");
                return;
            }
            let model = this.views.remove.model;
            let item = this.source.get(id);
            model.set(this.itemModelKey, item);
            this.show(this.views.remove);
        }
        initCreateModel(config) {
            this.source.bind("requestEnd", (e) => {
                if (e.type == "create") {
                    let rData = e.response.Data || e.response;
                    if ($.isArray(rData) && rData.length > 1) {
                        for (let i = 1; i < rData.length; i++) {
                            e.sender.pushCreate(rData[i]);
                        }
                    }
                }
            });
            return this.initUpdateModel(config, "create", (config.models || {}).create);
        }
        initUpdateModel(config, view = "update", customModel = (config.models || {}).update) {
            let that = this;
            let model = {
                isSaving: false,
                action: view,
                save: function (e) {
                    e.preventDefault();
                    if (that.options.events?.save) {
                        that.options.events.save({ sender: that, action: view, item: this.get(that.itemModelKey), source: that.source });
                    }
                    this.set("isSaving", true);
                    this.set("errors", []);
                    let validator = that.activeView.element.data("kendoValidator");
                    validator.hideMessages();
                    if (validator.validate()) {
                        that.source.sync()
                            .done(r => {
                            that.source.pushUpdate(this.get(that.itemModelKey));
                            if (that.options.events?.saved) {
                                that.options.events.saved({ sender: that, action: view, item: this.get(that.itemModelKey), response: r, source: that.source });
                            }
                            that.close();
                        })
                            .always(() => {
                            that.views[view].model.set("isSaving", false);
                        });
                    }
                }
            };
            model[this.itemModelKey] = null;
            if (customModel != null) {
                $.extend(true, model, customModel);
            }
            return kendo.observable(model);
        }
        initRemoveModel(config) {
            let that = this;
            let model = {
                remove: function (e) {
                    let item = this.get(that.itemModelKey);
                    if (that.options.events?.remove) {
                        that.options.events.remove({ sender: that, action: "remove", item: item, source: that.source });
                    }
                    that.source.remove(item);
                    that.source.sync().done(() => { that.close(); });
                },
            };
            model[this.itemModelKey] = null;
            if (config.models != null) {
                $.extend(true, model, config.models.remove || {});
            }
            return kendo.observable(model);
        }
        initValidator(e) {
            e.sender.element.kendoValidator(this.options.validator || {});
        }
    }
    enroller.SourceViewModal = SourceViewModal;
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class SpaBase {
        get router() {
            return this._router;
        }
        go(...action) {
            var route = $.map(action, this.trimSlashes).join("/");
            this.router.navigate("/" + route);
        }
        trimSlashes(action) {
            if (action === undefined || action === null) {
                return "";
            }
            action = action.toString();
            return action.indexOf('/') === 0
                ? action.substr(1)
                : action;
        }
        constructor(options) {
            this._router = options.router || enroller.router.init(options.routerOptions);
            if (options.resetHash !== false) {
                window.location.hash = '';
            }
            this.router.bind("routeMissing", options.routeMissing || this.defaultRouteMissing);
        }
        defaultRouteMissing(e) {
            if (location.hostname === "localhost") {
                console.log("Route not found: " + e.url, e.params);
            }
        }
    }
    enroller.SpaBase = SpaBase;
    class ModalSpaBase extends SpaBase {
        get viewModal() {
            return this._viewModal;
        }
        get activeView() {
            return this._viewModal.activeView;
        }
        get views() {
            return this._viewModal.views;
        }
        constructor(viewModal, options) {
            super(options);
            this._viewModal = viewModal;
            this._viewModal.modal.on("hidden.bs.modal", (e) => {
                this.router.replace('/');
            });
        }
        show(view, { animation = null, selector = null, open = true, model = null, size = enroller.ViewModalSize.Default } = {}) {
            this._viewModal.show(view, { animation, selector, open, model, size });
        }
        close(navigate = true) {
            this._viewModal.close();
            if (navigate) {
                this.router.navigate("/");
            }
        }
    }
    enroller.ModalSpaBase = ModalSpaBase;
    class ModalSpa extends ModalSpaBase {
        constructor(config) {
            super(new enroller.ViewModal(config), config);
        }
    }
    enroller.ModalSpa = ModalSpa;
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class SourceModal extends enroller.ModalSpaBase {
        get source() {
            return this._viewModal.source;
        }
        constructor(options) {
            let prefix = options.templatePrefix || "SourceModal-" + options.route;
            super(new enroller.SourceViewModal(options), options);
            this.router.route(`/${options.route}`, () => {
                this._viewModal.create();
            });
            this.router.route(`/${options.route}/:id`, (id) => {
                this._viewModal.update(id);
            });
            this.router.route(`/${options.route}/:id/remove`, (id) => {
                this._viewModal.remove(id);
            });
        }
    }
    enroller.SourceModal = SourceModal;
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class PageSpa extends enroller.SpaBase {
        get layout() {
            return this._layout;
        }
        get activeView() {
            return this._activeView;
        }
        constructor(options) {
            super(options);
            let layoutElement = options.layoutElement.trim().replace("#", "");
            this._viewElement = options.viewElement?.trim()?.replace("#", "") || layoutElement;
            this._layout = new kendo.Layout(document.getElementById(layoutElement), $.extend({
                wrap: false,
            }, options.layoutOptions));
        }
        show(view) {
            this._activeView = view;
            this._layout.showIn(`#${this._viewElement}`, view, "none");
        }
    }
    enroller.PageSpa = PageSpa;
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var cache;
    (function (cache_1) {
        const cacheName = "enr.cache";
        var cacheCallbacks = [];
        function init() {
            if (cacheCallbacks.length > 0) {
                Promise.all(cacheCallbacks);
            }
        }
        cache_1.init = init;
        function load(p) {
            cacheCallbacks.push(p);
        }
        cache_1.load = load;
        async function clear(name) {
            if (!window.caches) {
                return;
            }
            await caches.delete(name || cacheName);
        }
        cache_1.clear = clear;
        async function get(url) {
            if (!window.caches) {
                return await _get(url);
            }
            let cache = await caches.open(cacheName);
            let request = new Request(url);
            let resp = await cache.match(request);
            if (resp === undefined) {
                await cache.add(request);
                resp = await cache.match(request);
            }
            return resp?.json() || [];
        }
        cache_1.get = get;
        var _cache = {};
        async function _get(url) {
            let key = `${cacheName}.${url}`;
            let storage = window.sessionStorage;
            if (_cache[key] === undefined) {
                var value = storage.getItem(key);
                if (value == null) {
                    await fetch(url)
                        .then(async (r) => {
                        _cache[key] = await r.json();
                        storage.setItem(key, JSON.stringify(_cache[key]));
                    });
                }
                else {
                    _cache[key] = JSON.parse(value);
                }
            }
            return _cache[key];
        }
        function organizations() {
            return get(enroller.core.urls.api("organizations/all"));
        }
        cache_1.organizations = organizations;
    })(cache = enroller.cache || (enroller.cache = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var constants;
    (function (constants) {
        constants.emailTest = /^[a-zA-Z0-9'_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$/;
        constants.csrfHeader = "x-enr-csrf-token";
        constants.orgHeader = "x-enr-org";
    })(constants = enroller.constants || (enroller.constants = {}));
})(enroller || (enroller = {}));
(function (enroller) {
    var constants;
    (function (constants) {
        var organizations;
        (function (organizations) {
            organizations.systemId = -1;
            organizations.testId = -2;
            organizations.otherId = 312;
            organizations.noneId = 313;
            organizations.others = [organizations.otherId, organizations.noneId];
            function isOther(value) {
                return organizations.others.indexOf(value || 0) != -1;
            }
            organizations.isOther = isOther;
        })(organizations = constants.organizations || (constants.organizations = {}));
    })(constants = enroller.constants || (enroller.constants = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class EnrollerHttp {
        get(path, data) {
            let request = this.request(this.url(path, data), "GET");
            return fetch(request);
        }
        post(path, data) {
            let request = this.request(this.url(path), "POST", {
                body: enroller.util.stringify(data)
            });
            return fetch(request);
        }
        put(path, data) {
            let request = this.request(this.url(path), "PUT", {
                body: enroller.util.stringify(data)
            });
            return fetch(request);
        }
        delete(url) {
            let request = this.request(url, "DELETE");
            return fetch(request);
        }
        url(path, data) {
            var u = new URL(path, document.location.toString());
            if (data && typeof data == "object") {
                Object.keys(data)
                    .forEach(key => {
                    if (data[key] !== undefined && data[key] !== null) {
                        u.searchParams.append(key, data[key]);
                    }
                });
            }
            return u;
        }
        request(url, method, options) {
            const headers = {
                accepts: "application/json, text/javascript, */*; q=0.01",
            };
            if (options?.body) {
                headers["content-type"] = "application/json";
            }
            headers[enroller.constants.csrfHeader] = enroller.core.csrf;
            headers["x-requested-with"] = "XMLHttpRequest";
            if (enroller.core.org) {
                headers[enroller.constants.orgHeader] = enroller.core.org;
            }
            const request = new Request(url.toString(), {
                method: method,
                headers: headers,
                mode: "cors",
                credentials: "include",
                ...options
            });
            return request;
        }
        _getErrors(errors, results) {
            if (errors == null) {
                return results;
            }
            if (typeof errors == 'string') {
                results.push(errors);
            }
            else if (Array.isArray(errors)) {
                for (const value of errors) {
                    this._getErrors(value, results);
                }
            }
            else if (typeof errors === 'object') {
                if (errors['type']?.startsWith('https://httpstatuses.io')) {
                    if (errors['errors'] != undefined) {
                        this._getErrors(errors['errors'], results);
                    }
                }
                else {
                    for (const key of Object.values(errors)) {
                        this._getErrors(key, results);
                    }
                }
            }
            return results;
        }
        async getErrors(response, errors) {
            const text = await response.text();
            errors ?? (errors = []);
            if (text.startsWith("{") || text.startsWith("[")) {
                const obj = JSON.parse(text);
                return this._getErrors(obj, errors);
            }
            else {
                errors.push(text);
            }
            return errors;
        }
    }
    enroller.EnrollerHttp = EnrollerHttp;
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var signalr;
    (function (signalr) {
        signalr.general = "general";
        signalr.methods = {
            attendanceEventStatus: "Attendance:EventStatus",
            attendanceSpaceStatus: "Attendance:SpaceStatus",
            eventsWaitlistUpdated: "Events:WaitlistUpdated",
            eventsSessionCapacity: "Events:SessionCapacity",
            notification: "Notification",
            reportsQueryRunStatus: "Reports:QueryRunStatus",
        };
        class SignalRManager {
            connection() {
                return this._connection;
            }
            hub() {
                return this._hub;
            }
            constructor(config, url) {
                config = $.extend(true, {
                    hub: enroller.signalr.general,
                    debug: enroller.core.isLocalHost() ? signalR.LogLevel.Information : signalR.LogLevel.Error
                }, config);
                this._hub = config.hub;
                let headers = {};
                if (enroller.core.csrf) {
                    headers[enroller.constants.csrfHeader] = enroller.core.csrf;
                }
                this._connection = new signalR.HubConnectionBuilder()
                    .withUrl(url || enroller.core.urls.globalApi('hubs', config.hub), {
                    headers: headers,
                    withCredentials: true
                })
                    .withAutomaticReconnect()
                    .configureLogging(config.debug)
                    .build();
                this._connection.onreconnecting(error => {
                    console.assert(this._connection.state === signalR.HubConnectionState.Reconnecting);
                });
                this._connection.onclose(error => {
                    console.assert(this._connection.state === signalR.HubConnectionState.Disconnected);
                });
            }
            joinEventGroup(eventId, group) {
                if (!eventId) {
                    console.error("No event id specified.");
                }
                if (!group) {
                    console.error("No group specified.");
                }
                return this.connection().invoke("JoinEventGroup", eventId, group);
            }
            async start() {
                if (this._connection.state == "Disconnected") {
                    await this._connection.start();
                }
                return Promise.resolve();
            }
            on(method, newMethod) {
                if (typeof (method) !== "string") {
                    this._connection.on(method(signalr.methods), newMethod);
                }
                else {
                    this._connection.on(method, newMethod);
                }
            }
            off(methodName, method) {
                this._connection.off(methodName, method);
            }
            onNotification(notificationId, handler) {
                const func = (notification, log) => {
                    if (notificationId !== notification.Id) {
                        return;
                    }
                    handler(notification, log);
                };
                this.on(m => m.notification, func);
                return func;
            }
            offNotification(func) {
                this.off(signalr.methods.notification, func);
            }
        }
        signalr.SignalRManager = SignalRManager;
        const _cache = {};
        function connect(config, url) {
            config ?? (config = {});
            config.hub ?? (config.hub = enroller.signalr.general);
            if (_cache[config.hub] === undefined) {
                _cache[config.hub] = new SignalRManager(config, url);
            }
            return _cache[config.hub];
        }
        signalr.connect = connect;
        function error() {
            return (error) => {
                console.error(error.message);
                esd.toast.error("An error occurred connecting to SignalR", error.message);
            };
        }
        signalr.error = error;
    })(signalr = enroller.signalr || (enroller.signalr = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class Urls {
        constructor(config) {
            this._org = config.org?.toLowerCase() || null;
            this._api = "/api/";
            this._orgApi = config.org ? `${this._api}${config.org}/` : null;
            this._url = "/";
            this._orgUrl = config.org ? `${this._url}${config.org}` : null;
            this._organizationId = config.organizationId || null;
        }
        get org() {
            return this._org;
        }
        get organizationId() {
            return this._organizationId;
        }
        globalApi(...actions) {
            const segments = this.buildUrl(this._url, actions);
            if (window.location.hostname == "localhost") {
                return `https://localhost:44306${segments}`;
            }
            else if (window.location.hostname.endsWith("test.pdenroller.org")) {
                return `https://api.test.pdenroller.org${segments}`;
            }
            else if (window.location.hostname.endsWith("pdenroller.org")) {
                return `https://api.pdenroller.org${segments}`;
            }
            console.error(`Invalid Host: ${window.location.host}`);
            return null;
        }
        api(...actions) {
            return this.buildUrl(this._api, actions);
        }
        orgApi(...actions) {
            return this._orgApi
                ? this.buildUrl(this._orgApi, actions)
                : this.buildUrl(this._api, actions);
        }
        url(...actions) {
            return this.buildUrl(this._url, actions);
        }
        orgUrl(...actions) {
            return this._orgUrl
                ? this.buildUrl(this._orgUrl, actions)
                : this.buildUrl(this._url, actions);
        }
        absolute(...actions) {
            return `/${this.join.apply(this, actions)}`;
        }
        join(...actions) {
            return actions.map(this.trimSlashes).filter(s => s !== "" && s !== null).join("/");
        }
        buildUrl(base, actions) {
            var cleanedBase = `/${this.trimSlashes(base)}`;
            var cleanedActions = this.join.apply(this, actions);
            if (cleanedBase == "/" && cleanedActions.length > 0) {
                return cleanedBase + cleanedActions;
            }
            return cleanedActions.length > 0
                ? cleanedBase + "/" + cleanedActions
                : cleanedBase;
        }
        trimSlashes(action) {
            return action?.toString()?.trim()?.replace(/^\/+|\/+$/g, "") || "";
        }
    }
    enroller.Urls = Urls;
})(enroller || (enroller = {}));
(function () {
    if (kendo.ui.Editor === undefined) {
        var Editor = kendo.ui.Widget.extend({
            init: function (element, options) {
                kendo.ui.Widget.fn.init.call(this, element, options);
            },
            options: {
                name: "Editor"
            }
        });
        kendo.ui.plugin(Editor);
    }
}());
(function () {
    if (kendo.data.ObservableArray.prototype.findIndex === undefined) {
        kendo.data.ObservableArray.prototype["findIndex"] = function (callback, thisArg) {
            var idx = 0;
            var item;
            var length = this.length;
            var context = thisArg || window;
            for (; idx < length; idx++) {
                item = this[idx];
                if (callback.call(context, item, idx, this)) {
                    return idx;
                }
            }
            return -1;
        };
    }
}());
(function () {
    if (kendo.data.ObservableObject.prototype.getOrSet === undefined) {
        kendo.data.ObservableObject.prototype["getOrSet"] = function (name, defaultValueGetter) {
            let val = this.get(name);
            if (!val) {
                this.set(name, defaultValueGetter());
                val = this.get(name);
            }
            return val;
        };
    }
}());
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        let data;
        (function (data_1) {
            data_1.ParsedModel = kendo.data.Model.define({
                init: function (data) {
                    if (data !== null && data !== undefined && typeof data === 'object') {
                        $.each(Object.keys(data), (index, key) => {
                            if ($.type(this.fields[key]) === 'object') {
                                data[key] = this._parse(key, data[key]);
                            }
                        });
                        data = $.extend({}, this.defaults, data);
                        for (var key in this.defaults) {
                            if (typeof this.defaults[key] === 'function' && data[key] == this.defaults[key]) {
                                data[key] = this.defaults[key](data);
                            }
                        }
                    }
                    kendo.data.Model.fn.init.call(this, data || {});
                    if (this.events !== undefined) {
                        for (var key in this.events) {
                            this.bind(key, this.events[key]);
                        }
                    }
                }
            });
            data_1.ParsedModel.define = function (options) {
                return kendo.data.Model.define(data_1.ParsedModel, options);
            };
            function filterHierarchy(dataSource, query) {
                var hasVisibleChildren = false;
                var data = dataSource instanceof kendo.data.HierarchicalDataSource && dataSource.data();
                for (var i = 0; i < data.length; i++) {
                    var item = data[i];
                    var text = item.text.toLowerCase();
                    var itemVisible = query === true
                        || query === ""
                        || text.indexOf(query) >= 0;
                    var anyVisibleChildren = filterHierarchy(item.children, itemVisible || query);
                    hasVisibleChildren = hasVisibleChildren || anyVisibleChildren || itemVisible;
                    item.hidden = !itemVisible && !anyVisibleChildren;
                }
                if (data) {
                    dataSource.filter({ field: "hidden", operator: "neq", value: true });
                }
                return hasVisibleChildren;
            }
            data_1.filterHierarchy = filterHierarchy;
        })(data = kendoui.data || (kendoui.data = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var notifications;
    (function (notifications) {
        class NotificationChannelBase {
            get key() {
                return `${this._key}.${this._channel}`;
            }
            get center() {
                return this._center;
            }
            constructor(center, config) {
                this._key = "enr.ntf";
                this._timers = {
                    fiveMinutes: 300000,
                    tenMinutes: 600000,
                };
                this._element = $(config.element);
                if (this._element.length == 0) {
                    return;
                }
                this._config = config;
                this._channel = config.channel || this._element?.data("channel");
                this._cache = this.storage();
                this._pageSize = config.pageSize || 5;
                this._source = this.getSource();
                this._model = this.getModel();
                kendo.bind(this._element, this._model);
                if (window.setInterval) {
                    this._timer = setInterval(() => {
                        this.update();
                    }, this._timers.fiveMinutes);
                }
            }
            update() {
                this._source?.query({ filter: this._config.filter, page: 1, pageSize: this._pageSize });
            }
            getModel(model) {
                return kendo.observable({
                    ...model,
                    ...{
                        total: this._cache?.total,
                        notifications: this._source
                    }
                });
            }
            storage(data) {
                let storage = window.sessionStorage;
                if (data === undefined) {
                    let raw = storage.getItem(this.key);
                    let parsed = raw ? JSON.parse(raw) : {};
                    return Date.now() - (parsed?.date || 0) > this._timers.tenMinutes
                        ? {}
                        : parsed;
                }
                data.date = new Date().getTime();
                storage.setItem(this.key, JSON.stringify(data));
                return data;
            }
            getSource() {
                let first = true;
                let source = enroller.util.getDataSource({
                    model: notifications.Notification,
                    url: enroller.core.urls.api("notifications", this._channel, "summary"),
                    error: () => clearInterval(this._timer),
                    options: {
                        pageSize: this._pageSize,
                        page: 1,
                        transport: {
                            destroy: enroller.core.urls.api("notifications/{0}")
                        },
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                        requestStart: (e) => {
                            if (first) {
                                if (this._cache?.total !== undefined) {
                                    source.data(this._cache.data || []);
                                    this._model.set("total", this._cache.total);
                                    e.preventDefault();
                                }
                                first = false;
                            }
                        },
                        requestEnd: (e) => {
                            if (e.type == "read") {
                                this._cache = this.storage({
                                    data: e.response.Data,
                                    total: e.response.Total !== undefined
                                        ? e.response.Total
                                        : this._cache?.total || e.response.Data?.length
                                });
                                this._model.set("total", this._cache.total);
                            }
                        },
                        filter: this._config.filter,
                        sort: [{ field: "Date", dir: "desc" }]
                    }
                });
                return source;
            }
        }
        class BannerNotificationChannel extends NotificationChannelBase {
            constructor(center) {
                super(center, {
                    element: "#Enroller-Notifications-Banner",
                    channel: "CatalogBanner",
                    pageSize: 1,
                    filter: [{ field: "Status", operator: "eq", value: "New" }]
                });
                this.bannerTemplate = `<div class="alert #=alert()# alert-dismissible fade show" role="alert">
            <div class="h6 mb-0"><a href='#:Link#'>#:Title#</a></div>
            #=Body#
            <button type="button" class="btn-close k-delete-button" data-dismiss="alert" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>`;
                let t = kendo.template(this.bannerTemplate);
                this._element?.kendoListView({
                    dataSource: this._source,
                    template: t
                });
            }
            getModel() {
                return super.getModel({
                    dismiss: function (e) {
                        console.log(e);
                    }
                });
            }
            listen(signalr) { }
        }
        class MenuNotificationChannel extends NotificationChannelBase {
            constructor(center) {
                super(center, {
                    element: "#Enroller-Notifications-Menu",
                    channel: "Web",
                    pageSize: 5,
                    filter: [{ field: "Status", operator: "eq", value: "New" }]
                });
                this._listening = false;
                this._source?.bind("requestEnd", (e) => {
                    if (e.type == "read") {
                        this.updateBadges(e.response.Total);
                        if (e.response.Listen == true) {
                        }
                    }
                });
                if (this._cache?.total) {
                    $("#Enroller-Notifications-Menu-Count").find(".badge").text(this._cache?.total || "-");
                }
            }
            getModel() {
                return super.getModel({
                    icon: function () {
                        return this.get("notifications").total() ? "fa-bell " : "fal-bell";
                    }
                });
            }
            updateBadges(total) {
                $("#Enroller-Notifications-Menu-Count").find(".badge").text(total);
            }
            listen(signalr) {
                if (this._listening === false) {
                    signalr.on(m => m.notification, (notificationId, notification, log) => {
                    });
                    this._listening = true;
                }
            }
        }
        class NotificationCenter {
            get signalr() {
                if (enroller.core.isAuthenticated == false) {
                    return null;
                }
                if (!this._signalr) {
                    this._signalr = enroller.signalr.connect();
                    this.signalr.start();
                }
                return this._signalr;
            }
            constructor() {
                this.channels = [];
                if (enroller.core.isAuthenticated) {
                    this.channels.push(new MenuNotificationChannel(this));
                    this.channels.push(new BannerNotificationChannel(this));
                }
            }
            update() {
                for (let i = 0; i < this.channels.length; i++) {
                    this.channels[i].update();
                }
            }
            listen() {
                if (this.signalr) {
                    for (let i = 0; i < this.channels.length; i++) {
                        this.channels[i].listen(this.signalr);
                    }
                }
            }
            onNotification(callback) {
                this.signalr.on(m => m.notification, callback);
            }
            off(callback) {
                this.signalr.off("Notification", callback);
            }
        }
        notifications.NotificationCenter = NotificationCenter;
        notifications.Notification = enroller.kendoui.data.ParsedModel.define({
            id: "NotificationId",
            fields: {
                NotificationId: { type: "number" },
                Date: { type: "date" },
                Status: { type: "string", defaultValue: "New" },
                State: { type: "string", defaultValue: "Default" },
                Level: { type: "string", defaultValue: "Default" },
                Title: { type: "string" },
                Body: { type: "string" },
            },
            icon: function () {
                let name = _states[this.get("State")]?.icon
                    || _levels[this.get("Level")]?.icon;
                let classes = _states[this.get("State")]?.classes;
                let ico = enroller.util.icon(name, { classes: classes });
                return ico;
            },
            border: function () {
                let color = _levels[this.get("Level")]?.color;
                return color ? `border-${color}` : "border-secondary";
            },
            alert: function () {
                let color = _levels[this.get("Level")]?.color;
                return color ? `alert-${color}` : "alert-secondary";
            }
        });
        const _levels = {
            Default: { icon: null, color: "secondary", outline: "border-secondary" },
            Success: { icon: "check", color: "success", outline: "border-success" },
            Info: { icon: "circle-info", color: "info", outline: "border-info" },
            Warning: { icon: "exclamation", color: "warning", outline: "border-warning" },
            Error: { icon: "exclamation", color: "danger", outline: "border-danger" }
        };
        const _states = {
            Default: { icon: null, classes: null },
            Queued: { icon: "ellipsis", classes: null },
            Running: { icon: "arrows-rotate", classes: "fa-spin" },
            Complete: { icon: null, classes: null }
        };
    })(notifications = enroller.notifications || (enroller.notifications = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class EnrollerContext {
        get csrf() { return this._csrf; }
        isLocalHost() {
            return location.hostname === "localhost" || location.hostname === "127.0.0.1";
        }
        get notifications() { return this._notifications; }
        get urls() { return this._urls; }
        get http() { return this._remote; }
        get org() { return this._config.org; }
        get isAuthenticated() {
            return !!this._config?.a;
        }
        init(config) {
            this._config = config;
            this._urls = new enroller.Urls(config);
            window.global = window;
            if (global === undefined) {
                global = window;
            }
            enroller.cache?.init();
            if (!this.isLocalHost()) {
                window.onerror = this.errorHandler;
            }
            this._remote = new enroller.EnrollerHttp();
            this._csrf = config.csrf;
            if (!config.layout) {
                this.initWindow();
            }
            this.initJQuery();
            this.initKendo();
            $(() => {
                if (!config.layout) {
                    this.initMenu();
                }
                this._notifications = new enroller.notifications.NotificationCenter();
            });
        }
        clear() {
            window.sessionStorage?.clear();
            enroller.cache.clear();
        }
        ready() {
            $(() => {
                var tooltipTriggerList = [].slice.call(document.querySelectorAll('main [data-bs-toggle="tooltip"]'));
                tooltipTriggerList.map(function (tooltipTriggerEl) {
                    return new bootstrap.Tooltip(tooltipTriggerEl, {});
                });
                enroller.router.start();
            });
        }
        errorHandler(message, url, line, column, error) {
            if (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
                return;
            }
            return true;
        }
        initMenu() {
            let container = $("#enr-menu-admin");
            if (container.length == 0 || !sessionStorage) {
                return;
            }
            let storageKey = "enr.menus.admin.top";
            if (this.urls.org) {
                storageKey += "." + this.urls.org;
            }
            var cache = JSON.parse(sessionStorage.getItem(storageKey));
            $.when(cache || $.get(this.urls.api("account/menu", this.urls.org)).then(r => {
                sessionStorage.setItem(storageKey, JSON.stringify(r));
                return r;
            }))
                .then(r => {
                kendo.bind(container, kendo.observable({
                    menu: r.Menu || [],
                    primaries: r.Primaries || [],
                    organizations: new kendo.data.DataSource({
                        data: r.Organizations || [],
                        sort: { field: "Text" }
                    }),
                    showOrganizations: (r.Organizations?.length > 0),
                    show: () => r.Organizations?.length || r.Menu?.length,
                    search: function (e) {
                        let value = (e.target.value || '').trim();
                        let source = this.get("organizations");
                        if (value.length > 0) {
                            source.filter({ field: "Name", operator: "contains", value: value });
                        }
                        else {
                            source.filter([]);
                        }
                    }
                }));
            })
                .fail(() => {
                container.hide();
            });
        }
        initWindow() {
            let header = document.getElementById("Enroller-Header");
            if (header) {
                var onResize = function () {
                    document.documentElement.style.setProperty('--enr-menu-height', `${header.clientHeight}px`);
                };
                onResize();
                window.addEventListener('resize', onResize);
            }
        }
        initJQuery() {
            jQuery.ajaxSetup({
                cache: false,
                contentType: "application/json; charset=utf-8",
                traditional: true,
                xhrFields: {
                    withCredentials: true
                }
            });
            $.ajaxPrefilter((options, originalOptions, xhr) => {
                xhr.setRequestHeader(enroller.constants.csrfHeader, this.csrf);
                if (this.org) {
                    xhr.setRequestHeader(enroller.constants.orgHeader, this.org);
                }
                var requestType = options.type.toLowerCase();
                if ((requestType === "post" || requestType === "put" || requestType === "delete")
                    && options.data !== null
                    && (typeof originalOptions.data === 'object' || $.isPlainObject(originalOptions.data))
                    && options.contentType.toString().indexOf("json") > -1) {
                    options.data = enroller.util.stringify(originalOptions.data);
                }
            });
        }
        initKendo() {
            kendo.culture('en-US');
            kendo.data.DataSource.prototype.options.error = function (e) {
                let xhr = e.xhr;
                let title = xhr.statusText || xhr.status;
                if (title == "error") {
                    title = null;
                }
                let message = "An error with the server request.";
                if (xhr.responseText !== undefined) {
                    message = xhr.responseText;
                }
                if (xhr.responseJSON !== undefined && xhr.responseJSON.Message !== undefined) {
                    let r = xhr.responseJSON;
                    message = r.Message;
                    if (r.ModelState !== undefined) {
                        var errors = [];
                        for (var prop in r.ModelState) {
                            for (var i = 0; i < r.ModelState[prop].length; i++) {
                                errors.push(r.ModelState[prop][i]);
                            }
                        }
                        title = 'An error occurred saving:';
                        message = errors.join(' ');
                    }
                }
                esd.toast.error(title, message);
            };
            let webApiMap = kendo.data.transports["webapi"].fn.options.parameterMap;
            kendo.data.transports["webapi"] = kendo.data.RemoteTransport.extend({
                init: function (options) {
                    var that = this;
                    if (options.update) {
                        var updateUrl = typeof options.update === "string"
                            ? options.update
                            : options.update.url;
                        options.update = $.extend(options.update, {
                            url: function (data) {
                                return $.isFunction(updateUrl)
                                    ? kendo.format(updateUrl(data), data[options.idField])
                                    : kendo.format(updateUrl, data[options.idField]);
                            }
                        });
                    }
                    if (options.destroy) {
                        var destroyUrl = typeof options.destroy === "string"
                            ? options.destroy
                            : options.destroy.url;
                        options.destroy = $.extend(options.destroy, {
                            url: function (data) {
                                return $.isFunction(destroyUrl)
                                    ? kendo.format(destroyUrl(data), data[options.idField])
                                    : kendo.format(destroyUrl, data[options.idField]);
                            }
                        });
                    }
                    if (options.create && typeof options.create === 'string') {
                        options.create = { url: options.create };
                    }
                    let mergedOptions = $.extend(true, {}, this.options, options);
                    mergedOptions.parameterMap = mergedOptions.parameterMap.bind(that);
                    kendo.data.RemoteTransport.fn.init.call(this, mergedOptions);
                },
                read: kendo.data.transports["webapi"].fn.read,
                options: {
                    read: { type: 'GET' },
                    update: { type: 'PUT', contentType: "application/json; charset=utf-8" },
                    create: { type: 'POST', contentType: "application/json; charset=utf-8" },
                    destroy: { type: 'DELETE', contentType: "application/json; charset=utf-8" },
                    parameterMap: function (options, operation) {
                        if (operation != 'read') {
                            return enroller.util.stringify(options);
                        }
                        return webApiMap.call(this, options, operation, {
                            encode: false,
                            stringifyDates: false,
                            culture: kendo.cultures['en-US']
                        });
                    },
                    prefix: ''
                }
            });
        }
    }
    enroller.core = new EnrollerContext();
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var enums;
    (function (enums) {
        function get(value, values) {
            if (values && value !== null) {
                return values.find(i => i.value === value || i.key === value);
            }
            return null;
        }
        enums.get = get;
        let AuthorizeNetTransactionStatus;
        (function (AuthorizeNetTransactionStatus) {
            AuthorizeNetTransactionStatus["settledSuccessfully"] = "settledSuccessfully";
            AuthorizeNetTransactionStatus["generalError"] = "generalError";
            AuthorizeNetTransactionStatus["declined"] = "declined";
            AuthorizeNetTransactionStatus["voided"] = "voided";
            AuthorizeNetTransactionStatus["refundSettledSuccessfully"] = "refundSettledSuccessfully";
            AuthorizeNetTransactionStatus["capturedPendingSettlement"] = "capturedPendingSettlement";
        })(AuthorizeNetTransactionStatus = enums.AuthorizeNetTransactionStatus || (enums.AuthorizeNetTransactionStatus = {}));
        enums.authorizeNetTransactionStatuses = [
            { value: AuthorizeNetTransactionStatus.settledSuccessfully, key: "settledSuccessfully", text: "Success", badge: "success" },
            { value: AuthorizeNetTransactionStatus.generalError, key: "generalError", text: "Error", badge: "secondary" },
            { value: AuthorizeNetTransactionStatus.declined, key: "declined", text: "Declined", badge: "warning" },
            { value: AuthorizeNetTransactionStatus.voided, key: "voided", text: "Voided", badge: "secondary" },
            { value: AuthorizeNetTransactionStatus.refundSettledSuccessfully, key: "refundSettledSuccessfully", text: "Refunded", badge: "primary" },
            { value: AuthorizeNetTransactionStatus.capturedPendingSettlement, key: "capturedPendingSettlement", text: "Pending", badge: "info" },
        ];
        let ContactType;
        (function (ContactType) {
            ContactType[ContactType["Contact"] = 0] = "Contact";
            ContactType[ContactType["Organizer"] = 1] = "Organizer";
            ContactType[ContactType["Presenter"] = 2] = "Presenter";
            ContactType[ContactType["Caterer"] = 3] = "Caterer";
            ContactType[ContactType["Facilities"] = 4] = "Facilities";
            ContactType[ContactType["TechSupport"] = 5] = "TechSupport";
            ContactType[ContactType["Other"] = 6] = "Other";
        })(ContactType = enums.ContactType || (enums.ContactType = {}));
        enums.contactTypes = [
            { value: ContactType.Contact, key: "Contact", text: "Contact", badge: "primary", icon: "fal-comment" },
            { value: ContactType.Organizer, key: "Organizer", text: "Organizer", badge: "info", icon: "fal-clipboard-list" },
            { value: ContactType.Presenter, key: "Presenter", text: "Presenter", badge: "success", icon: "fal-chalkboard-user" },
            { value: ContactType.Caterer, key: "Caterer", text: "Caterer", badge: "secondary" },
            { value: ContactType.Facilities, key: "Facilities", text: "Facilities", badge: "secondary" },
            { value: ContactType.TechSupport, key: "TechSupport", text: "Tech Support", badge: "secondary" },
            { value: ContactType.Other, key: "Other", text: "Other", badge: "secondary" },
        ];
        let ContactVisibility;
        (function (ContactVisibility) {
            ContactVisibility[ContactVisibility["Public"] = 0] = "Public";
            ContactVisibility[ContactVisibility["Registered"] = 1] = "Registered";
            ContactVisibility[ContactVisibility["Admin"] = 2] = "Admin";
        })(ContactVisibility = enums.ContactVisibility || (enums.ContactVisibility = {}));
        enums.contactVisibilities = [
            { value: ContactVisibility.Public, key: "Public", text: "Public", badge: "primary" },
            { value: ContactVisibility.Registered, key: "Registered", text: "info", badge: "info" },
            { value: ContactVisibility.Admin, key: "Admin", text: "Admin", badge: "secondary" },
        ];
        let ClockHourApprovalStatus;
        (function (ClockHourApprovalStatus) {
            ClockHourApprovalStatus[ClockHourApprovalStatus["Draft"] = 0] = "Draft";
            ClockHourApprovalStatus[ClockHourApprovalStatus["Proposed"] = 1] = "Proposed";
            ClockHourApprovalStatus[ClockHourApprovalStatus["Approved"] = 2] = "Approved";
            ClockHourApprovalStatus[ClockHourApprovalStatus["Denied"] = 3] = "Denied";
            ClockHourApprovalStatus[ClockHourApprovalStatus["Removed"] = 4] = "Removed";
        })(ClockHourApprovalStatus = enums.ClockHourApprovalStatus || (enums.ClockHourApprovalStatus = {}));
        enums.clockHourApprovalStatus = [
            { value: ClockHourApprovalStatus.Draft, key: "Draft", text: "Draft", badge: "info" },
            { value: ClockHourApprovalStatus.Proposed, key: "Proposed", text: "Proposed", badge: "primary" },
            { value: ClockHourApprovalStatus.Approved, key: "Approved", text: "Approved", badge: "success" },
            { value: ClockHourApprovalStatus.Denied, key: "Denied", text: "Denied", badge: "danger" },
            { value: ClockHourApprovalStatus.Removed, key: "Removed", text: "Removed", badge: "secondary" },
        ];
        let DataSourceType;
        (function (DataSourceType) {
            DataSourceType[DataSourceType["Entity"] = 0] = "Entity";
            DataSourceType[DataSourceType["SQL"] = 1] = "SQL";
        })(DataSourceType = enums.DataSourceType || (enums.DataSourceType = {}));
        enums.datasourceType = [
            { value: DataSourceType.Entity, key: "Entity", text: "Entity", badge: "info" },
            { value: DataSourceType.SQL, key: "SQL", text: "SQL", badge: "info" },
        ];
        let DayOfWeek;
        (function (DayOfWeek) {
            DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
            DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
            DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
            DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
            DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
            DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
            DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
        })(DayOfWeek = enums.DayOfWeek || (enums.DayOfWeek = {}));
        enums.daysOfWeek = [
            { value: DayOfWeek.Sunday, key: "Sunday", text: "Sunday", badge: "info" },
            { value: DayOfWeek.Monday, key: "Monday", text: "Monday", badge: "info" },
            { value: DayOfWeek.Tuesday, key: "Tuesday", text: "Tuesday", badge: "info" },
            { value: DayOfWeek.Wednesday, key: "Wednesday", text: "Wednesday", badge: "info" },
            { value: DayOfWeek.Thursday, key: "Thursday", text: "Thursday", badge: "info" },
            { value: DayOfWeek.Friday, key: "Friday", text: "Friday", badge: "info" },
            { value: DayOfWeek.Saturday, key: "Saturday", text: "Saturday", badge: "info" },
        ];
        let EventStatus;
        (function (EventStatus) {
            EventStatus[EventStatus["Draft"] = 0] = "Draft";
            EventStatus[EventStatus["Active"] = 1] = "Active";
            EventStatus[EventStatus["Cancelled"] = 2] = "Cancelled";
            EventStatus[EventStatus["Removed"] = 3] = "Removed";
            EventStatus[EventStatus["None"] = 4] = "None";
        })(EventStatus = enums.EventStatus || (enums.EventStatus = {}));
        enums.eventStatuses = [
            { value: EventStatus.Draft, key: "Draft", text: "Draft", badge: "info" },
            { value: EventStatus.Active, key: "Active", text: "Active", badge: "success" },
            { value: EventStatus.Cancelled, key: "Cancelled", text: "Cancelled", badge: "warning" },
            { value: EventStatus.Removed, key: "Removed", text: "Removed", badge: "secondary" },
            { value: EventStatus.None, key: "None", text: "Clock Hours Only", badge: "primary" }
        ];
        let InvoiceItemStatus;
        (function (InvoiceItemStatus) {
            InvoiceItemStatus[InvoiceItemStatus["Received"] = 0] = "Received";
            InvoiceItemStatus[InvoiceItemStatus["Pending"] = 1] = "Pending";
            InvoiceItemStatus[InvoiceItemStatus["Remitted"] = 2] = "Remitted";
            InvoiceItemStatus[InvoiceItemStatus["Error"] = 255] = "Error";
        })(InvoiceItemStatus = enums.InvoiceItemStatus || (enums.InvoiceItemStatus = {}));
        enums.invoiceItemStatuses = [
            { value: InvoiceItemStatus.Received, key: "Received", text: "Received", badge: "success", icon: "fal-check" },
            { value: InvoiceItemStatus.Pending, key: "Pending", text: "Pending", badge: "secondary" },
            { value: InvoiceItemStatus.Remitted, key: "Remitted", text: "Remitted", badge: "primary", icon: "fal-chevron-right" },
            { value: InvoiceItemStatus.Error, key: "Error", text: "Error", badge: "danger", icon: "fal-circle-exclamation" },
        ];
        let OrganizationType;
        (function (OrganizationType) {
            OrganizationType[OrganizationType["PublicSchool"] = 0] = "PublicSchool";
            OrganizationType[OrganizationType["PrivateSchool"] = 1] = "PrivateSchool";
            OrganizationType[OrganizationType["District"] = 2] = "District";
            OrganizationType[OrganizationType["ESD"] = 3] = "ESD";
            OrganizationType[OrganizationType["StateAgency"] = 4] = "StateAgency";
            OrganizationType[OrganizationType["Other"] = 5] = "Other";
            OrganizationType[OrganizationType["CharterSchool"] = 6] = "CharterSchool";
        })(OrganizationType = enums.OrganizationType || (enums.OrganizationType = {}));
        enums.organizationType = [
            { value: OrganizationType.PublicSchool, key: "PublicSchool", text: "Public School" },
            { value: OrganizationType.PrivateSchool, key: "PrivateSchool", text: "Private School" },
            { value: OrganizationType.District, key: "District", text: "District" },
            { value: OrganizationType.ESD, key: "ESD", text: "ESD" },
            { value: OrganizationType.Other, key: "Other", text: "Other" },
            { value: OrganizationType.CharterSchool, key: "CharterSchool", text: "CharterSchool" },
        ];
        let NotificationEmailFrequency;
        (function (NotificationEmailFrequency) {
            NotificationEmailFrequency[NotificationEmailFrequency["Never"] = 0] = "Never";
            NotificationEmailFrequency[NotificationEmailFrequency["EveryNotification"] = 1] = "EveryNotification";
            NotificationEmailFrequency[NotificationEmailFrequency["Daily"] = 2] = "Daily";
            NotificationEmailFrequency[NotificationEmailFrequency["Weekly"] = 3] = "Weekly";
        })(NotificationEmailFrequency = enums.NotificationEmailFrequency || (enums.NotificationEmailFrequency = {}));
        enums.notificationEmailFrequencies = [
            { value: NotificationEmailFrequency.Never, key: "Never", text: "Never", badge: "info" },
            { value: NotificationEmailFrequency.EveryNotification, key: "EveryNotification", text: "Every Notification", badge: "info" },
            { value: NotificationEmailFrequency.Daily, key: "Daily", text: "Daily", badge: "info" },
            { value: NotificationEmailFrequency.Weekly, key: "Weekly", text: "Weekly", badge: "info" },
        ];
        let NotificationLevel;
        (function (NotificationLevel) {
            NotificationLevel[NotificationLevel["Default"] = 0] = "Default";
            NotificationLevel[NotificationLevel["Success"] = 1] = "Success";
            NotificationLevel[NotificationLevel["Info"] = 2] = "Info";
            NotificationLevel[NotificationLevel["Warning"] = 3] = "Warning";
            NotificationLevel[NotificationLevel["Error"] = 4] = "Error";
        })(NotificationLevel = enums.NotificationLevel || (enums.NotificationLevel = {}));
        enums.notificationLevels = [
            { value: NotificationLevel.Default, key: "Default", text: "Default", badge: "primary" },
            { value: NotificationLevel.Success, key: "Success", text: "Success", badge: "success" },
            { value: NotificationLevel.Info, key: "Info", text: "Info", badge: "info" },
            { value: NotificationLevel.Warning, key: "Warning", text: "Warning", badge: "warning" },
            { value: NotificationLevel.Error, key: "Error", text: "Error", badge: "danger" },
        ];
        let NotificationState;
        (function (NotificationState) {
            NotificationState[NotificationState["Default"] = 0] = "Default";
            NotificationState[NotificationState["Queued"] = 1] = "Queued";
            NotificationState[NotificationState["Running"] = 2] = "Running";
            NotificationState[NotificationState["Complete"] = 3] = "Complete";
            NotificationState[NotificationState["Error"] = 4] = "Error";
        })(NotificationState = enums.NotificationState || (enums.NotificationState = {}));
        enums.notificationStates = [
            { value: NotificationState.Default, key: "Default", text: "New", badge: "primary" },
            { value: NotificationState.Queued, key: "Queued", text: "Queued", badge: "info" },
            { value: NotificationState.Running, key: "Running", text: "Running", badge: "primary" },
            { value: NotificationState.Complete, key: "Complete", text: "Complete", badge: "success" },
            { value: NotificationState.Error, key: "Error", text: "Error", badge: "danger" },
        ];
        let PriceModifierType;
        (function (PriceModifierType) {
            PriceModifierType[PriceModifierType["Base"] = 0] = "Base";
            PriceModifierType[PriceModifierType["Fee"] = 1] = "Fee";
            PriceModifierType[PriceModifierType["Discount"] = 2] = "Discount";
            PriceModifierType[PriceModifierType["Coupon"] = 3] = "Coupon";
        })(PriceModifierType = enums.PriceModifierType || (enums.PriceModifierType = {}));
        enums.priceModifierTypes = [
            { value: PriceModifierType.Base, key: "Base", text: "Base Price", badge: "primary" },
            { value: PriceModifierType.Fee, key: "Fee", text: "Fee", badge: "warning" },
            { value: PriceModifierType.Discount, key: "Discount", text: "Discount", badge: "info" },
            { value: PriceModifierType.Coupon, key: "Coupon", text: "Coupon", badge: "success" },
        ];
        let PriceModifierComputationType;
        (function (PriceModifierComputationType) {
            PriceModifierComputationType[PriceModifierComputationType["Dollar"] = 0] = "Dollar";
            PriceModifierComputationType[PriceModifierComputationType["Percent"] = 1] = "Percent";
            PriceModifierComputationType[PriceModifierComputationType["Absolute"] = 2] = "Absolute";
        })(PriceModifierComputationType = enums.PriceModifierComputationType || (enums.PriceModifierComputationType = {}));
        enums.priceModifierComputationTypes = [
            { value: PriceModifierComputationType.Dollar, key: "Dollar", text: "$ Dollar", badge: "info" },
            { value: PriceModifierComputationType.Percent, key: "Percent", text: "% Percent", badge: "info" },
            { value: PriceModifierComputationType.Absolute, key: "Absolute", text: "$ Fixed", badge: "info" },
        ];
        let QueryRunStatus;
        (function (QueryRunStatus) {
            QueryRunStatus["Queued"] = "Queued";
            QueryRunStatus["Running"] = "Running";
            QueryRunStatus["Complete"] = "Complete";
            QueryRunStatus["Failed"] = "Failed";
            QueryRunStatus["Expired"] = "Expired";
            QueryRunStatus["Stopped"] = "Stopped";
            QueryRunStatus["Removed"] = "Removed";
            QueryRunStatus["Retrying"] = "Retrying";
        })(QueryRunStatus = enums.QueryRunStatus || (enums.QueryRunStatus = {}));
        enums.queryRunStatuses = [
            { value: QueryRunStatus.Queued, key: "Queued", text: "Queued", badge: "info", icon: "fa-ellipsis" },
            { value: QueryRunStatus.Running, key: "Running", text: "Running", badge: "primary", icon: "fal-arrows-rotate", iconClasses: "fa-spin" },
            { value: QueryRunStatus.Complete, key: "Complete", text: "Complete", badge: "success", icon: "fal-check" },
            { value: QueryRunStatus.Failed, key: "Failed", text: "Failed", badge: "danger", icon: "fal-circle-exclamation" },
            { value: QueryRunStatus.Expired, key: "Expired", text: "Expired", badge: "light" },
            { value: QueryRunStatus.Stopped, key: "Stopped", text: "Stopped", badge: "warning" },
            { value: QueryRunStatus.Removed, key: "Removed", text: "Removed", badge: "secondary" },
            { value: QueryRunStatus.Retrying, key: "Retrying", text: "Retrying", badge: "warning", icon: "fa-ellipsis" },
        ];
        let QueryScheduleStatus;
        (function (QueryScheduleStatus) {
            QueryScheduleStatus[QueryScheduleStatus["Draft"] = 0] = "Draft";
            QueryScheduleStatus[QueryScheduleStatus["Active"] = 1] = "Active";
            QueryScheduleStatus[QueryScheduleStatus["Stopped"] = 2] = "Stopped";
            QueryScheduleStatus[QueryScheduleStatus["Removed"] = 3] = "Removed";
        })(QueryScheduleStatus = enums.QueryScheduleStatus || (enums.QueryScheduleStatus = {}));
        enums.queryScheduleStatuses = [
            { value: QueryScheduleStatus.Draft, key: "Draft", text: "Queued", badge: "info" },
            { value: QueryScheduleStatus.Active, key: "Active", text: "Running", badge: "success" },
            { value: QueryScheduleStatus.Stopped, key: "Stopped", text: "Complete", badge: "warning" },
            { value: QueryScheduleStatus.Removed, key: "Removed", text: "Failed", badge: "secondary" },
        ];
        let RegistrationStatus;
        (function (RegistrationStatus) {
            RegistrationStatus[RegistrationStatus["Incomplete"] = 0] = "Incomplete";
            RegistrationStatus[RegistrationStatus["Active"] = 1] = "Active";
            RegistrationStatus[RegistrationStatus["Cancelled"] = 2] = "Cancelled";
            RegistrationStatus[RegistrationStatus["Pending"] = 3] = "Pending";
            RegistrationStatus[RegistrationStatus["Removed"] = 4] = "Removed";
            RegistrationStatus[RegistrationStatus["Expired"] = 5] = "Expired";
        })(RegistrationStatus = enums.RegistrationStatus || (enums.RegistrationStatus = {}));
        enums.registrationStatuses = [
            { value: RegistrationStatus.Incomplete, key: "Incomplete", text: "Incomplete", badge: "light" },
            { value: RegistrationStatus.Active, key: "Active", text: "Active", badge: "success" },
            { value: RegistrationStatus.Cancelled, key: "Cancelled", text: "Cancelled", badge: "warning" },
            { value: RegistrationStatus.Pending, key: "Pending", text: "Pending", badge: "info" },
            { value: RegistrationStatus.Removed, key: "Removed", text: "Removed", badge: "light" },
            { value: RegistrationStatus.Expired, key: "Expired", text: "Expired", badge: "light" },
        ];
        let SessionRegistrationType;
        (function (SessionRegistrationType) {
            SessionRegistrationType[SessionRegistrationType["DisplayOnly"] = 0] = "DisplayOnly";
            SessionRegistrationType[SessionRegistrationType["Single"] = 1] = "Single";
            SessionRegistrationType[SessionRegistrationType["Multiple"] = 2] = "Multiple";
        })(SessionRegistrationType = enums.SessionRegistrationType || (enums.SessionRegistrationType = {}));
        enums.sessionRegistrationTypes = [
            { value: SessionRegistrationType.DisplayOnly, key: "DisplayOnly", text: "Display Only", badge: "secondary" },
            { value: SessionRegistrationType.Single, key: "Single", text: "Single", badge: "primary" },
            { value: SessionRegistrationType.Multiple, key: "Multiple", text: "Multiple", badge: "primary" }
        ];
        let SpaceStatus;
        (function (SpaceStatus) {
            SpaceStatus[SpaceStatus["Incomplete"] = 0] = "Incomplete";
            SpaceStatus[SpaceStatus["Active"] = 1] = "Active";
            SpaceStatus[SpaceStatus["Cancelled"] = 2] = "Cancelled";
            SpaceStatus[SpaceStatus["Waitlist"] = 3] = "Waitlist";
            SpaceStatus[SpaceStatus["Transferred"] = 4] = "Transferred";
            SpaceStatus[SpaceStatus["Replaced"] = 5] = "Replaced";
            SpaceStatus[SpaceStatus["PendingActive"] = 6] = "PendingActive";
            SpaceStatus[SpaceStatus["PendingWaitlist"] = 7] = "PendingWaitlist";
            SpaceStatus[SpaceStatus["Duplicate"] = 8] = "Duplicate";
        })(SpaceStatus = enums.SpaceStatus || (enums.SpaceStatus = {}));
        enums.spaceStatuses = [
            { value: SpaceStatus.Incomplete, key: "Incomplete", text: "Incomplete", badge: "light" },
            { value: SpaceStatus.Active, key: "Active", text: "Active", badge: "success" },
            { value: SpaceStatus.Cancelled, key: "Cancelled", text: "Cancelled", badge: "warning" },
            { value: SpaceStatus.Waitlist, key: "Waitlist", text: "Waitlist", badge: "info" },
            { value: SpaceStatus.Transferred, key: "Transferred", text: "Transferred", badge: "secondary" },
            { value: SpaceStatus.Replaced, key: "Replaced", text: "Replaced", badge: "secondary" },
            { value: SpaceStatus.PendingActive, key: "PendingActive", text: "Pending (Active)", badge: "light" },
            { value: SpaceStatus.PendingWaitlist, key: "PendingWaitlist", text: "Pending (Waitlist)", badge: "light" },
            { value: SpaceStatus.Duplicate, key: "Duplicate", text: "Duplicate", badge: "light" }
        ];
        let SubscriptionAction;
        (function (SubscriptionAction) {
            SubscriptionAction[SubscriptionAction["Block"] = 0] = "Block";
            SubscriptionAction[SubscriptionAction["NotificationOnly"] = 1] = "NotificationOnly";
            SubscriptionAction[SubscriptionAction["NotificationAndEmail"] = 2] = "NotificationAndEmail";
        })(SubscriptionAction = enums.SubscriptionAction || (enums.SubscriptionAction = {}));
        enums.subscriptionActions = [
            { value: SubscriptionAction.Block, key: "Block", text: "Block", badge: "secondary" },
            { value: SubscriptionAction.NotificationOnly, key: "NotificationOnly", text: "Notification Only", badge: "primary" },
            { value: SubscriptionAction.NotificationAndEmail, key: "NotificationAndEmail", text: "Notification and Email", badge: "primary" },
        ];
        let SurveyStatus;
        (function (SurveyStatus) {
            SurveyStatus[SurveyStatus["Draft"] = 0] = "Draft";
            SurveyStatus[SurveyStatus["Published"] = 1] = "Published";
            SurveyStatus[SurveyStatus["Removed"] = 2] = "Removed";
        })(SurveyStatus = enums.SurveyStatus || (enums.SurveyStatus = {}));
        enums.surveyStatuses = [
            { value: SurveyStatus.Draft, key: "Draft", text: "Draft", badge: "warning" },
            { value: SurveyStatus.Published, key: "Published", text: "Published", badge: "success" },
            { value: SurveyStatus.Removed, key: "Removed", text: "Deleted", badge: "danger" },
        ];
        let TagCategory;
        (function (TagCategory) {
            TagCategory[TagCategory["Custom"] = 0] = "Custom";
            TagCategory[TagCategory["SecurityGroup"] = 1] = "SecurityGroup";
            TagCategory[TagCategory["Audience"] = 2] = "Audience";
            TagCategory[TagCategory["Subject"] = 3] = "Subject";
            TagCategory[TagCategory["ApplicationTopic"] = 4] = "ApplicationTopic";
            TagCategory[TagCategory["CertificationRequirement"] = 5] = "CertificationRequirement";
            TagCategory[TagCategory["ClockHourCommittee"] = 6] = "ClockHourCommittee";
            TagCategory[TagCategory["Organization"] = 7] = "Organization";
            TagCategory[TagCategory["SupportGroup"] = 8] = "SupportGroup";
            TagCategory[TagCategory["ExternalCatalog"] = 9] = "ExternalCatalog";
            TagCategory[TagCategory["TpepTeacherCriteria"] = 10] = "TpepTeacherCriteria";
            TagCategory[TagCategory["TpepPrincipalCriteria"] = 11] = "TpepPrincipalCriteria";
            TagCategory[TagCategory["DocumentationTree"] = 12] = "DocumentationTree";
            TagCategory[TagCategory["UserAccommodationDietary"] = 13] = "UserAccommodationDietary";
            TagCategory[TagCategory["UserAccommodationPhysical"] = 14] = "UserAccommodationPhysical";
            TagCategory[TagCategory["Cooperative"] = 15] = "Cooperative";
        })(TagCategory = enums.TagCategory || (enums.TagCategory = {}));
        let TicketPriority;
        (function (TicketPriority) {
            TicketPriority[TicketPriority["Low"] = 0] = "Low";
            TicketPriority[TicketPriority["Medium"] = 1] = "Medium";
            TicketPriority[TicketPriority["High"] = 2] = "High";
        })(TicketPriority = enums.TicketPriority || (enums.TicketPriority = {}));
        enums.ticketPriorities = [
            { value: TicketPriority.Low, key: "Low", text: "Low", badge: "info" },
            { value: TicketPriority.Medium, key: "Medium", text: "Medium", badge: "primary" },
            { value: TicketPriority.High, key: "High", text: "High", badge: "danger" },
        ];
        let TicketStatusType;
        (function (TicketStatusType) {
            TicketStatusType[TicketStatusType["Open"] = 0] = "Open";
            TicketStatusType[TicketStatusType["Closed"] = 1] = "Closed";
        })(TicketStatusType = enums.TicketStatusType || (enums.TicketStatusType = {}));
        enums.ticketStatusTypes = [
            { value: TicketStatusType.Open, key: "Open", text: "Open", badge: "primary" },
            { value: TicketStatusType.Closed, key: "Closed", text: "Closed", badge: "secondary" },
        ];
        let TicketSource;
        (function (TicketSource) {
            TicketSource[TicketSource["Email"] = 0] = "Email";
            TicketSource[TicketSource["Web"] = 1] = "Web";
        })(TicketSource = enums.TicketSource || (enums.TicketSource = {}));
        enums.ticketSources = [
            { value: TicketSource.Email, key: "Email", text: "Email", badge: "secondary", icon: "envelope" },
            { value: TicketSource.Web, key: "Web", text: "Web", badge: "secondary", icon: "cloud" },
        ];
        let TicketStatus;
        (function (TicketStatus) {
            TicketStatus[TicketStatus["New"] = 0] = "New";
            TicketStatus[TicketStatus["InProgress"] = 1] = "InProgress";
            TicketStatus[TicketStatus["InfoRequested"] = 2] = "InfoRequested";
            TicketStatus[TicketStatus["Hold"] = 3] = "Hold";
            TicketStatus[TicketStatus["Resolved"] = 4] = "Resolved";
            TicketStatus[TicketStatus["Closed"] = 5] = "Closed";
            TicketStatus[TicketStatus["Removed"] = 6] = "Removed";
        })(TicketStatus = enums.TicketStatus || (enums.TicketStatus = {}));
        enums.ticketStatuses = [
            { value: TicketStatus.New, key: "New", text: "New", badge: "success" },
            { value: TicketStatus.InProgress, key: "InProgress", text: "In Progress", badge: "success" },
            { value: TicketStatus.InfoRequested, key: "InfoRequested", text: "Info Requested", badge: "info" },
            { value: TicketStatus.Hold, key: "Hold", text: "Hold", badge: "warning" },
            { value: TicketStatus.Resolved, key: "Resolved", text: "Resolved", badge: "primary" },
            { value: TicketStatus.Closed, key: "Closed", text: "Closed", badge: "secondary" },
            { value: TicketStatus.Removed, key: "Removed", text: "Removed", badge: "light" },
        ];
        let TicketType;
        (function (TicketType) {
            TicketType[TicketType["Bug"] = 0] = "Bug";
            TicketType[TicketType["Suggestion"] = 1] = "Suggestion";
            TicketType[TicketType["Support"] = 2] = "Support";
        })(TicketType = enums.TicketType || (enums.TicketType = {}));
        enums.ticketTypes = [
            { value: TicketType.Bug, key: "Bug", text: "Bug", badge: "danger", icon: "fal-bug" },
            { value: TicketType.Suggestion, key: "Suggestion", text: "Suggestion", badge: "success", icon: "fal-lightbulb" },
            { value: TicketType.Support, key: "Support", text: "Support", badge: "primary", icon: "fal-circle-question" },
        ];
    })(enums = enroller.enums || (enroller.enums = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var format;
    (function (format_1) {
        function datetime(value, format) {
            if (value == null) {
                return "";
            }
            return kendo.format(format, kendo.parseDate(value));
        }
        format_1.datetime = datetime;
        function booleanBadge(value, trueBadge, falseBadge) {
            return value
                ? '<span class="badge bg-success">' + trueBadge + '</span>'
                : '<span class="badge bg-secondary">' + falseBadge + '</span>';
        }
        format_1.booleanBadge = booleanBadge;
        function badge(value, values) {
            let item = enroller.enums.get(value, values);
            if (item) {
                let icon = "";
                if (item.icon) {
                    icon = `${enroller.util.icon(item.icon, { classes: item.iconClasses })} `;
                }
                return `<span class="badge bg-${item.badge}">${icon}${item.text}</span>`;
            }
            return value;
        }
        format_1.badge = badge;
        function bytes(bytes) {
            let totalSize = parseInt(bytes);
            if (isNaN(totalSize)) {
                return null;
            }
            totalSize /= 1024;
            if (totalSize < 1024) {
                return totalSize.toFixed(2) + ' KB';
            }
            else {
                return (totalSize / 1024).toFixed(2) + ' MB';
            }
        }
        format_1.bytes = bytes;
    })(format = enroller.format || (enroller.format = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var page;
    (function (page) {
        function title(text) {
            let el = document.getElementById("Enroller-Page-Title");
            if (el) {
                el.textContent = text;
            }
        }
        page.title = title;
        function subtitle(text) {
            let el = document.getElementById("Enroller-Page-Subtitle");
            if (el) {
                el.textContent = text;
            }
        }
        page.subtitle = subtitle;
    })(page = enroller.page || (enroller.page = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var reporting;
    (function (reporting) {
        function report(config) {
            $(config.container).each((i, el) => {
                var validator = $(el).kendoValidator().data('kendoValidator');
                var model = kendo.observable($.extend({
                    preview: function (e) {
                        e.preventDefault();
                        alert("Previewing has been removed.");
                    }
                }, config.model || {}));
                kendo.bind($(el), model);
            });
        }
        reporting.report = report;
    })(reporting = enroller.reporting || (enroller.reporting = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    class EnrRouter {
        constructor() {
            this._started = false;
        }
        initRouter(options) {
            if (location.hostname === "localhost") {
                options = $.extend({}, {
                    routeMissing: (e) => {
                        console.warn("Global Router | No Route Found: " + e.url);
                    },
                    change: (e) => {
                        console.info("Global Router | Route Changed: " + e.url);
                    },
                    init: (e) => {
                        console.info(`Global Router | Initialized (${e.sender.routes.length} routes)`);
                    }
                }, options);
            }
            this._router = new kendo.Router(options);
        }
        init(options) {
            if (this._router === null || this._router === undefined) {
                this.initRouter(options);
            }
            return this._router;
        }
        start(force) {
            if (this._started === true) {
                return;
            }
            if (force === true || this._router != null) {
                if (this._router == null) {
                    this.initRouter();
                }
                this._router.start();
                this._started = true;
            }
        }
        navigate(e) {
            let href = e.currentTarget.getAttribute("href");
            if (this._router && href) {
                this._router.navigate(href);
                e.preventDefault();
                return false;
            }
            return true;
        }
    }
    enroller.EnrRouter = EnrRouter;
    enroller.router = new EnrRouter();
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var search;
    (function (search) {
        function a(e) {
            let code = null;
            if (e instanceof Event) {
                code = $(e.target).data("analytics");
            }
            else {
                code = e;
            }
            if (code != null && navigator.sendBeacon != undefined) {
                navigator.sendBeacon(enroller.core.urls.api("log/search/" + code));
            }
            return true;
        }
        search.a = a;
    })(search = enroller.search || (enroller.search = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var util;
    (function (util) {
        var cookies;
        (function (cookies) {
            function set(name, value, days) {
                let now = new Date();
                var exp = new Date(now.setTime(now.getTime() + (days || 14) * 864e5));
                let val = typeof value == "string" || typeof value == "number"
                    ? value.toString().replace(/=/g, '%3D')
                    : btoa(JSON.stringify(value)).replace(/=/g, "_");
                document.cookie = `${name}=;max-age=-1`;
                document.cookie = `${name}=${val};expires=${exp.toUTCString()};SameSite=Strict`;
            }
            cookies.set = set;
            function erase(name) {
                document.cookie = `${name}=;max-age=-1;`;
            }
            cookies.erase = erase;
        })(cookies = util.cookies || (util.cookies = {}));
    })(util = enroller.util || (enroller.util = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var util;
    (function (util) {
        function filterSource(url, params, options, filters) {
            options = $.extend(true, {
                type: "webapi",
                serverFiltering: true,
                serverPaging: true,
                serverSorting: true,
                transport: {
                    read: {
                        url: url,
                        data: (readOptions) => {
                            var query = { q: null };
                            $.extend(query, params || {});
                            enroller.util.traverse(query, function (o, i, val) {
                                if (typeof val === "function") {
                                    o[i] = val(readOptions);
                                }
                            });
                            if (readOptions.filter != undefined
                                && readOptions.filter.filters != undefined
                                && readOptions.filter.filters.length > 0) {
                                var first = readOptions.filter.filters.shift();
                                query.q = first.value;
                            }
                            if (filters) {
                                readOptions.filter = { filters: filters, logic: "and" };
                            }
                            return query;
                        }
                    }
                },
                schema: {
                    data: function (r) {
                        if (r.Data) {
                            return r.Data;
                        }
                        return r;
                    },
                    total: function (r) {
                        if (r.Total) {
                            return r.Total;
                        }
                        return r.length;
                    }
                },
                pageSize: 10
            }, options || {});
            return new kendo.data.DataSource(options);
        }
        util.filterSource = filterSource;
        class SearchDataSource extends kendo.data.DataSource {
            constructor(options) {
                super($.extend(true, {
                    transport: {
                        read: {
                            contentType: "application/json",
                            data: () => {
                                return this.params;
                            }
                        },
                    },
                    schema: {
                        data: "Data",
                        total: "Total"
                    },
                    requestStart: (e) => { this.isSearching = true; },
                    requestEnd: (e) => { this.isSearching = false; },
                }, options));
                this.isSearching = false;
                this.params = {};
            }
            reset() {
                this.page(0);
                this.data([]);
                this.isSearching = false;
            }
            search(e) {
                var that = this;
                if (e.target !== undefined) {
                    var value = e.target.value;
                    this.params.q = value;
                    this.page(0);
                    this.read();
                }
            }
        }
        util.SearchDataSource = SearchDataSource;
        function traverse(obj, func) {
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    func.apply(this, [obj, i, obj[i]]);
                    if (obj[i] !== null && typeof (obj[i]) == "object") {
                        traverse(obj[i], func);
                    }
                }
            }
        }
        util.traverse = traverse;
        function getDataSource(options) {
            let dataSoureOptions = getDataSourceOptions(options);
            return new kendo.data.DataSource(dataSoureOptions);
        }
        util.getDataSource = getDataSource;
        function getHierarchicalDataSource(options) {
            let dataSoureOptions = getDataSourceOptions(options);
            return new kendo.data.HierarchicalDataSource(dataSoureOptions);
        }
        util.getHierarchicalDataSource = getHierarchicalDataSource;
        function getHierarchicalDataSourceOptions(options) {
            return getDataSourceOptions(options);
        }
        util.getHierarchicalDataSourceOptions = getHierarchicalDataSourceOptions;
        function getDataSourceOptions(options) {
            options = $.extend({
                transports: ['create', 'update', 'destroy']
            }, options);
            var model = $.isPlainObject(options.model)
                ? kendo.data.Model.define(options.model)
                : options.model;
            let transport = {
                idField: model.idField || model.id,
            };
            if (Array.isArray(options.data) == false) {
                transport.read = {
                    method: "GET",
                    url: $.isFunction(options.url) ? options.url : options.url
                };
            }
            if (options.transports.indexOf('create') >= 0) {
                transport.create = {
                    method: "POST",
                    url: $.isFunction(options.url) ? options.url : options.url
                };
            }
            if (options.transports.indexOf('update') >= 0) {
                transport.update = {
                    method: "PUT",
                    url: $.isFunction(options.url) ? options.url : options.url + "/{0}"
                };
            }
            if (options.transports.indexOf('destroy') >= 0) {
                transport.destroy = {
                    method: "DELETE",
                    url: $.isFunction(options.url) ? options.url : options.url + "/{0}"
                };
            }
            let dataSourceOptions = $.extend(true, {
                type: "webapi",
                schema: getDefaultSchema({ model: model }),
                error: function (e) {
                    if (options.error != undefined && $.isFunction(options.error)) {
                        var r = e.xhr.responseJSON || {};
                        var errors = enroller.util.extractModelStateErrors(r);
                        options.error(errors);
                    }
                },
                transport: transport,
                sync: options.sync,
            }, options.options || {});
            if (Array.isArray(options.data)) {
                dataSourceOptions.data = {
                    Data: options.data.filter(function (i) { return i != null; })
                };
            }
            return dataSourceOptions;
        }
        util.getDataSourceOptions = getDataSourceOptions;
        function getDefaultSchema(schema) {
            return $.extend(true, {
                data: function (r) {
                    if (Array.isArray(r.Data)) {
                        return r.Data;
                    }
                    else if (Array.isArray(r.data)) {
                        return r.data;
                    }
                    return r;
                },
                total: function (r) {
                    if ($.isNumeric(r.Total)) {
                        return r.Total;
                    }
                    else if (Array.isArray(r.Data)) {
                        return r.Data.length;
                    }
                    else if ($.isNumeric(r.total)) {
                        return r.total;
                    }
                    else if (Array.isArray(r.data)) {
                        return r.data.length;
                    }
                    return r.length;
                }
            }, schema);
        }
        util.getDefaultSchema = getDefaultSchema;
    })(util = enroller.util || (enroller.util = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var util;
    (function (util) {
        var dates;
        (function (dates_1) {
            function min(...dates) {
                return minMax((a, b) => a > b ? 1 : a < b ? -1 : 0, dates);
            }
            dates_1.min = min;
            function max(...dates) {
                return minMax((a, b) => a > b ? -1 : a < b ? 1 : 0, dates);
            }
            dates_1.max = max;
            function minMax(comparer, dates) {
                if (dates == null || dates.length == 0) {
                    return null;
                }
                var realDates = formatDates(dates);
                if (realDates.length == 0) {
                    return null;
                }
                realDates.sort(comparer);
                return realDates[0];
            }
            function formatDates(dates) {
                var realDates = [];
                for (var i = 0; i < dates.length; i++) {
                    if (dates[i] == null) {
                        continue;
                    }
                    if (typeof dates[i] === 'string' || dates[i] instanceof String) {
                        realDates.push(kendo.parseDate(dates[i]));
                    }
                    else if (dates[i] instanceof Date) {
                        realDates.push(dates[i]);
                    }
                }
                return realDates;
            }
        })(dates = util.dates || (util.dates = {}));
    })(util = enroller.util || (enroller.util = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var util;
    (function (util) {
        function pageSave(config) {
            if (config.container == undefined) {
                return;
            }
            let _config = {
                container: null,
                model: {
                    data: null,
                    schema: null,
                    dirty: false,
                    errors: [],
                    sources: {},
                    saving: false,
                    save: function (e) {
                        save(e);
                    }
                },
                save: (dirty) => {
                    return dirty;
                },
                formatData: (data) => {
                    return data;
                },
                validator: {},
                url: null,
                messages: {
                    success: null,
                    noChanges: 'No changes pending.'
                }
            };
            _config = $.extend(true, _config, config);
            if (_config.model.sources != undefined) {
                for (var key in _config.model.sources) {
                    if (_config.model.sources.hasOwnProperty(key)) {
                        var url = _config.model.sources[key];
                        if (typeof url === 'string' || url instanceof String) {
                            _config.model.sources[key] = enroller.util.filterSource(url);
                        }
                    }
                }
            }
            esd.ajaxErrorHandler.addHandler(400, null);
            let _container = $(_config.container);
            if (_container.length == 0) {
                console.warn(`No container could be found for ${_config.container}.`);
            }
            let _validator = _container.kendoValidator(_config.validator).data('kendoValidator');
            let data;
            if (_config.model.schema) {
                var M = kendo.data.Model.define(_config.model.schema);
                data = new M(_config.model.data);
            }
            else {
                data = kendo.observable(_config.model.data);
            }
            data.bind('change', function (e) {
                _model.set('dirty', true);
            });
            _config.model.data = data;
            var _model = kendo.observable(_config.model);
            if (config.events) {
                if (config.events.change) {
                    _model.bind("change", config.events.change);
                }
                if (config.events.set) {
                    _model.bind("set", config.events.set);
                }
                if (config.events.get) {
                    _model.bind("get", config.events.get);
                }
            }
            let save = (e) => {
                _model.set('errors', []);
                _validator.hideMessages();
                _validator.validate();
                let dirty = _model.get('dirty');
                if (_config.save(dirty)) {
                    e.preventDefault();
                    let data = _config.formatData(_model.get('data').toJSON());
                    enroller.util.processing(e.delegateTarget, true);
                    $(e.delegateTarget).attr("disabled");
                    _model.set("saving", true);
                    $.ajax(_config.url, {
                        type: 'PUT',
                        data: data
                    })
                        .done(function () {
                        _model.set('dirty', false);
                        esd.toast.success(_config.messages.success);
                        let href = e.currentTarget.href;
                        if (href != undefined && href != '#' && href != '') {
                            document.location.href = href;
                        }
                    })
                        .fail(r => {
                        let data = r.responseJSON || {};
                        if (r.status >= 400 && r.status < 500) {
                            var rErrors = data.ModelState || data.errors;
                            let errors = [];
                            for (let prop in rErrors) {
                                errors.push(rErrors[prop]);
                            }
                            _model.set('errors', errors);
                        }
                        else {
                            let message = null;
                            if (r.responseText !== undefined) {
                                message = r.responseText;
                            }
                            else if (r.responseJSON !== undefined && r.responseJSON.Message !== undefined) {
                                message = r.responseJSON.Message;
                            }
                            esd.toast.error(r.status + ": " + r.statusText, message);
                        }
                    })
                        .always(() => {
                        $(e.delegateTarget).attr("enabled");
                        enroller.util.processing(e.delegateTarget, false);
                        _model.set("saving", false);
                    });
                }
                else {
                    esd.toast.info(_config.messages.noChanges);
                    let href = e.currentTarget.href;
                    if (href == undefined || href == '#' || href == '') {
                        e.preventDefault();
                    }
                }
            };
            $('.enroller-saveChanges').click(save);
            if (_container.length && _container[0].tagName?.toLowerCase() == "form") {
                _config.url ?? (_config.url = _container.attr("action"));
                _container.submit(save);
            }
            kendo.bind(_container, _model);
            if (config.load === true) {
                kendo.ui.progress(_container, true);
                $.get({
                    url: config.url
                })
                    .done(r => {
                    _model.set("data", r);
                })
                    .always(() => {
                    kendo.ui.progress(_container, false);
                });
            }
            return _model;
        }
        util.pageSave = pageSave;
    })(util = enroller.util || (enroller.util = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var util;
    (function (util) {
        var search;
        (function (search) {
            function baseModel(config, extended) {
                var defaults = {
                    pageSize: 10,
                    minChars: 2,
                    params: {},
                    events: {}
                };
                config = $.extend(defaults, config);
                var base = {
                    page: 0,
                    results: [],
                    term: null,
                    hasMore: false,
                    hasLess: function () {
                        return 0 < this.get('page');
                    },
                    hasAny: function () {
                        return this.get('page') > 0 || this.get('results').length > 0;
                    },
                    hasSearchTerm: function () {
                        var term = this.get('term');
                        return term != null && config.minChars <= term.length;
                    },
                    isSearching: false,
                    reset: function () {
                        this.set("page", 0);
                        this.set("results", []);
                        this.set("term", null);
                        this.set("hasMore", false);
                    },
                    search: enroller.util.debounce(function (e) {
                        var that = this;
                        if (e.target !== undefined) {
                            var value = e.target.value;
                            that.set('term', value);
                            that.set('page', 0);
                            if (value == null || value.length <= config.minChars) {
                                return;
                            }
                        }
                        if (config.events != null && config.events.searching != null) {
                            config.events.searching.call(this, e);
                        }
                        that._fetch.apply(this);
                    }, 400),
                    filter: function () {
                        this._fetch();
                    },
                    _fetch: function () {
                        var that = this;
                        if (this.get('isSearching')) {
                            this.set('_repeat', true);
                            return;
                        }
                        this.set('isSearching', true);
                        var url = ($.isFunction(config.url)
                            ? config.url()
                            : config.url);
                        var searching = that.hasSearchTerm();
                        if (config.defaultUrl !== undefined && !that.hasSearchTerm()) {
                            url = $.isFunction(config.defaultUrl)
                                ? config.defaultUrl()
                                : config.defaultUrl;
                        }
                        let params = $.isFunction(config.params)
                            ? config.params(this)
                            : config.params || {};
                        if (params instanceof kendo.data.ObservableObject) {
                            params = params.toJSON();
                        }
                        params = $.extend(params, {
                            q: this.get('term'),
                            page: this.get('page'),
                            pageSize: config.pageSize,
                        });
                        $.get(url, $.param(params))
                            .done(data => {
                            var results = data;
                            this.set('hasMore', (results.length > config.pageSize));
                            if (results.length > config.pageSize) {
                                results.pop();
                            }
                            if (config.itemModel != null) {
                                let d = [];
                                for (var i = 0; i < results.length; i++) {
                                    d.push(new config.itemModel(results[i]));
                                }
                                results = d;
                            }
                            this.set('results', results);
                            if (config.events != null && config.events.searched != null) {
                                config.events.searched.call(this, results);
                            }
                        })
                            .always(() => {
                            this.set('isSearching', false);
                            if (this.get('_repeat')) {
                                this.set('_repeat', false);
                                this._fetch();
                            }
                        });
                    },
                    next: function (e) {
                        e.preventDefault();
                        this.set('page', Math.max(0, this.get('page') + 1));
                        this._fetch();
                    },
                    prev: function (e) {
                        e.preventDefault();
                        this.set('page', Math.max(0, this.get('page') - 1));
                        this._fetch();
                    },
                };
                return $.extend(base, extended || {});
            }
            search.baseModel = baseModel;
        })(search = util.search || (util.search = {}));
    })(util = enroller.util || (enroller.util = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var util;
    (function (util) {
        function blockwhitespace(evt) {
            if (evt.keyCode == 32) {
                evt.preventDefault();
            }
        }
        util.blockwhitespace = blockwhitespace;
        function clamp(value, min, max) {
            if (value === null || value === undefined) {
                return null;
            }
            return Math.min(max, Math.max(min, value));
        }
        util.clamp = clamp;
        function cleanwhitespace(evt) {
            let el = evt.target;
            if (el.value != null) {
                el.value = el.value.replace(/\s/g, "");
            }
        }
        util.cleanwhitespace = cleanwhitespace;
        function copy(evt) {
            let el = evt.currentTarget;
            evt.preventDefault();
            if (el?.tagName == "A") {
                let href = el.getAttribute("href");
                if (href && href != "#") {
                    el = document.getElementById(href.substring(1));
                }
            }
            let text = (el?.textContent || el?.innerText)?.trim() ?? '';
            navigator.clipboard.writeText(text);
            esd.toast.success("Text copied.");
        }
        util.copy = copy;
        function stopPropagation(evt) {
            evt.stopPropagation();
        }
        util.stopPropagation = stopPropagation;
        function debounce(func, wait, immediate) {
            var timeout, args, context, timestamp, result;
            var later = function () {
                var last = Date.now() - timestamp;
                if (last < wait && last >= 0) {
                    timeout = setTimeout(later, wait - last);
                }
                else {
                    timeout = null;
                    if (!immediate) {
                        result = func.apply(context, args);
                        if (!timeout)
                            context = args = null;
                    }
                }
            };
            return function () {
                context = this;
                args = arguments;
                timestamp = Date.now();
                var callNow = immediate && !timeout;
                if (!timeout)
                    timeout = setTimeout(later, wait);
                if (callNow) {
                    result = func.apply(context, args);
                    context = args = null;
                }
                return result;
            };
        }
        util.debounce = debounce;
        ;
        function deparam(params) {
            let opts = {};
            if ($.isPlainObject(params)) {
                opts = params;
            }
            else if (params === undefined) {
                opts = {};
            }
            else {
                opts = { params: params };
            }
            if (opts.params === undefined) {
                opts.params = window.location.search;
            }
            if (opts.params?.startsWith('?')) {
                opts.params = opts.params.slice(1);
            }
            if (opts.coerce === undefined) {
                opts.coerce = true;
            }
            var obj = {}, coerce_types = { 'true': !0, 'false': !1, 'null': null };
            if (!opts.params || opts.params == "") {
                return obj;
            }
            opts.params.replace(/\+/g, ' ').split('&').forEach(function (v, j) {
                var param = v.split('='), key = decodeURIComponent(param[0]), val, cur = obj, i = 0, keys = key.split(']['), keys_last = keys.length - 1;
                if (/\[/.test(keys[0]) && /\]$/.test(keys[keys_last])) {
                    keys[keys_last] = keys[keys_last].replace(/\]$/, '');
                    keys = keys.shift().split('[').concat(keys);
                    keys_last = keys.length - 1;
                }
                else {
                    keys_last = 0;
                }
                if (param.length === 2) {
                    val = decodeURIComponent(param[1]);
                    if (opts.coerce) {
                        val = val && !isNaN(val) ? +val
                            : val === 'undefined' ? undefined
                                : coerce_types[val] !== undefined
                                    ? coerce_types[val]
                                    : val;
                    }
                    if (keys_last) {
                        if (opts.allowedKeys != null && opts.allowedKeys.indexOf(keys[0].toLowerCase()) === -1) {
                            return;
                        }
                        for (; i <= keys_last; i++) {
                            key = keys[i] === '' ? cur.length : keys[i];
                            cur = cur[key] = i < keys_last
                                ? cur[key] || (keys[i + 1] && isNaN(keys[i + 1]) ? {} : [])
                                : val;
                        }
                    }
                    else {
                        if (opts.allowedKeys != null && opts.allowedKeys.indexOf(key.toLowerCase()) === -1) {
                            return;
                        }
                        if (Array.isArray(obj[key])) {
                            obj[key].push(val);
                        }
                        else if (obj[key] !== undefined) {
                            obj[key] = [obj[key], val];
                        }
                        else {
                            obj[key] = val;
                        }
                    }
                }
                else if (key) {
                    obj[key] = opts.coerce
                        ? undefined
                        : '';
                }
            });
            return obj;
        }
        util.deparam = deparam;
        function fetch(obj, path) {
            if (typeof obj === 'undefined') {
                return obj;
            }
            var index = path.indexOf('.');
            if (index > -1) {
                return fetch(obj[path.substring(0, index)], path.substr(index + 1));
            }
            return obj[path];
        }
        util.fetch = fetch;
        function flatten(obj) {
            var result = {};
            function recurse(cur, prop) {
                if (Object(cur) !== cur) {
                    result[prop] = cur;
                }
                else if (Array.isArray(cur)) {
                    for (var i = 0, l = cur.length; i < l; i++)
                        recurse(cur[i], prop + "[" + i + "]");
                    if (l == 0)
                        result[prop] = [];
                }
                else {
                    var isEmpty = true;
                    for (var p in cur) {
                        isEmpty = false;
                        recurse(cur[p], prop ? prop + "." + p : p);
                    }
                    if (isEmpty && prop)
                        result[prop] = {};
                }
            }
            recurse(obj, "");
            return result;
        }
        util.flatten = flatten;
        function formToJson(form) {
            var obj = {};
            var a = $(form).serializeArray();
            $.each(a, function () {
                if (obj[this.name]) {
                    if (!obj[this.name].push) {
                        obj[this.name] = [obj[this.name]];
                    }
                    obj[this.name].push(this.value || '');
                }
                else {
                    obj[this.name] = this.value || '';
                }
            });
            return obj;
        }
        util.formToJson = formToJson;
        function jsonToForm(data, form, parentKey) {
            form ?? (form = {});
            if (data instanceof kendo.data.ObservableObject) {
                data = data.toJSON();
            }
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    jsonToForm(data[key], form, parentKey ? `${parentKey}[${key}]` : key);
                });
            }
            else {
                const value = data == null ? '' : data;
                form[parentKey] = value;
            }
            return form;
        }
        util.jsonToForm = jsonToForm;
        function get(func, fallbackValue) {
            try {
                var value = func();
                return (value === null || value === undefined) ? fallbackValue : value;
            }
            catch (e) {
                return fallbackValue;
            }
        }
        util.get = get;
        function icon(name, { classes = null, template = false, attributes = null, title = null } = {}) {
            if (!name) {
                return '';
            }
            if (!name?.startsWith("fa")) {
                name = `fal-${name}`;
            }
            let attrs = "";
            if (attributes) {
                for (let k in attributes) {
                    if (attributes.hasOwnProperty(k)) {
                        attrs += ` ${k}="${attributes[k]}"`;
                    }
                }
            }
            let titleHtml = '';
            if (title) {
                titleHtml = `<title>${kendo.htmlEncode(title)}</title>`;
            }
            return name ? `<svg class="fa ${classes || ''}"${attrs}>${titleHtml}<use href="/content/icons.svg${template ? "\\" : ''}#${name}"></use></svg>` : "";
        }
        util.icon = icon;
        function isEmail(email) {
            return enroller.constants.emailTest.test(email?.toString()?.trim());
        }
        util.isEmail = isEmail;
        function extractModelStateErrors(r, outerErrors) {
            let errors = outerErrors || [];
            if (r == null) {
                return errors;
            }
            if (typeof r === "string") {
                errors.push(r);
            }
            if (r.responseJSON !== undefined) {
                return extractModelStateErrors(r.responseJSON, errors);
            }
            else if (r.response !== undefined && r.response[0] == '{') {
                return extractModelStateErrors(JSON.parse(r.response), errors);
            }
            else if (r.responseText !== undefined) {
                errors.push(r.responseText);
            }
            else if (r.XMLHttpRequest !== undefined) {
                return extractModelStateErrors(r.XMLHttpRequest, errors);
            }
            if (r.ModelState !== undefined) {
                addObjectErrors(r.ModelState, errors);
            }
            else if (r.ExceptionMessage != undefined) {
                errors.push(r.ExceptionMessage);
            }
            else if (r.Message != undefined && typeof r.Message == "string") {
                errors.push(r.Message);
            }
            else if (r.detail != undefined && typeof r.detail == "string") {
                errors.push(r.detail);
            }
            else if (Array.isArray(r)) {
                for (let i = 0; i < r.length; i++) {
                    extractModelStateErrors(r[i], errors);
                }
            }
            else if ($.isPlainObject(r)) {
                addObjectErrors(r, errors);
            }
            return errors;
        }
        util.extractModelStateErrors = extractModelStateErrors;
        function addObjectErrors(obj, errors) {
            for (let prop in obj) {
                if (obj.hasOwnProperty(prop)) {
                    let val = obj[prop];
                    if (Array.isArray(val)) {
                        for (let i = 0; i < val.length; i++) {
                            errors.push(val[i]);
                        }
                    }
                    else if (typeof val == "string") {
                        errors.push(val);
                    }
                }
            }
        }
        util.processingOnClasses = 'fa-spin fal-arrows-rotate';
        function processing(element, enable) {
            let el = $(element);
            if (!el.hasClass("fa")) {
                el = el.find(".fa");
            }
            if (el.length == 0) {
                return;
            }
            if (el[0].tagName == "svg") {
                let use = el.find("use");
                if (enable === true || (enable === undefined && !el.hasClass("fa-spin"))) {
                    let href = use.attr("href");
                    use.data("original", href);
                    el.addClass("fa-spin");
                    use.attr("href", href.replace(/(#fa.+)/, "#fal-arrows-rotate"));
                }
                else if (enable === false || (enable === undefined && el.hasClass("fa-spin"))) {
                    el.removeClass("fa-spin");
                    use.attr("href", use.data("original"));
                }
            }
            else {
                if (enable === true || (enable === undefined && !el.hasClass("fa-spin"))) {
                    el.addClass(util.processingOnClasses);
                }
                else if (enable === false || (enable === undefined && el.hasClass("fa-spin"))) {
                    el.removeClass(util.processingOnClasses);
                }
            }
        }
        util.processing = processing;
        function resize(el) {
            if (el.tagName.toUpperCase() == "TEXTAREA") {
                el.style.height = "auto";
                if (el.scrollHeight > 0) {
                    el.style.height = (el.scrollHeight + 4) + "px";
                }
            }
        }
        util.resize = resize;
        function resizeHandler(e) {
            if (e.currentTarget.tagName.toUpperCase() == "TEXTAREA") {
                resize(e.currentTarget);
            }
        }
        util.resizeHandler = resizeHandler;
        function stringify(obj) {
            if (typeof obj.toJSON === "function") {
                obj = obj.toJSON();
            }
            return JSON.stringify(obj, function (key, value) {
                if (value instanceof Date) {
                    return value.toISOString();
                }
                else if (value instanceof kendo.data.ObservableObject) {
                    return value.toJSON();
                }
                else if (value instanceof kendo.data.DataSource) {
                    return value.data().toJSON();
                }
                return value;
            });
        }
        util.stringify = stringify;
        function dateRange(start, end, format) {
            return enroller.util.dateTimeRange(start, end, format || { format: "D" });
        }
        util.dateRange = dateRange;
        function timeRange(start, end) {
            var format = "{0:h:mm tt}";
            var s = start != null ? kendo.parseDate(start) : null;
            var e = end != null ? kendo.parseDate(end) : null;
            if (s && e) {
                var st = kendo.format(format, s);
                var et = kendo.format(format, e);
                if (st == et) {
                    return st;
                }
                return st + " - " + et;
            }
            else {
                if (s) {
                    return kendo.format(format, s);
                }
                if (e) {
                    return kendo.format(format, e);
                }
            }
        }
        util.timeRange = timeRange;
        let _defaultFormats = {
            d: {
                singleDay: "{0:M/d/yyyy}",
                multiDay: "{0:M/d}-{1:d/yyyy}",
                multiMonth: "{0:M/d} - {1:M/d/yyyy}",
                multiYear: "{0:M/d/yyyy} - {1:M/d/yyyy}"
            },
            dd: {
                singleDay: "{0:ddd, MMM d yyyy}",
                multiDay: "{0:MMM d}-{1:d yyyy}",
                multiMonth: "{0:ddd, MMM} - {1:ddd, MMM d yyyy}",
                multiYear: "{0:ddd, MMM d yyyy} - {1:ddd, MMM d yyyy}"
            },
            ddd: {
                singleDay: "{0:ddd, MMMM d yyyy}",
                multiDay: "{0:MMMM d}-{1:d yyyy}",
                multiMonth: "{0:ddd, MMMM} - {1:ddd, MMMM d yyyy}",
                multiYear: "{0:ddd, MMMM d yyyy} - {1:ddd, MMMM d yyyy}"
            },
            g: {
                singleDay: "{0:M/d/yyyy h:mm tt} - {1:h:mm tt}",
                multiDay: "{0:M/d}-{1:d/yyyy} {0:h:mm tt} - {1:h:mm tt}",
                multiMonth: "{0:M/d} - {1:M/d/yyyy} {0:h:mm tt} - {1:h:mm tt}",
                multiYear: "{0:M/d/yyyy h:mm tt} - {1:M/d/yyyy h:mm tt}"
            },
            f: {
                singleDay: "{0:ddd, MMMM d yyyy h:mm tt} - {1:h:mm tt}",
                multiDay: "{0:MMMM d}-{1:d yyyy} {0:h:mm tt} - {1:h:mm tt}",
                multiMonth: "{0:ddd, MMMM d h:mm tt} - {1:ddd, MMMM d yyyy h:mm tt}",
                multiYear: "{0:ddd, MMMM d yyyy h:mm tt} - {1:ddd, MMMM d yyyy h:mm tt}"
            },
            ff: {
                singleDay: "{0:ddd, MMM d yyyy h:mm tt} - {1:h:mm tt}",
                multiDay: "{0:MMM d}-{1:d yyyy} {0:h:mm tt} - {1:h:mm tt}",
                multiMonth: "{0:ddd, MMM d h:mm tt} - {1:ddd, MMM d yyyy h:mm tt}",
                multiYear: "{0:ddd, MMM d yyyy h:mm tt} - {1:ddd, MMM d yyyy h:mm tt}"
            }
        };
        _defaultFormats["D"] = _defaultFormats.ddd;
        function dateTimeRange(start, end, formats) {
            if (typeof formats === "string") {
                formats = { format: formats };
            }
            else if (formats == null) {
                formats = { format: "f" };
            }
            formats = $.extend({}, formats, _defaultFormats[formats.format]);
            var s = start != null ? kendo.parseDate(start) : null;
            var e = end != null ? kendo.parseDate(end) : null;
            if (s && e) {
                if (kendo.toString(s, 'yyyy-MM-dd') == kendo.toString(e, 'yyyy-MM-dd')) {
                    return kendo.format(formats.singleDay, s, e);
                }
                if (kendo.toString(s, 'yyyy-MM') == kendo.toString(e, 'yyyy-MM')) {
                    return kendo.format(formats.multiDay, s, e);
                }
                return kendo.format(formats.multiYear, s, e);
            }
            else {
                if (s) {
                    return kendo.format(formats.singleDayStart || formats.singleDay, s);
                }
                if (e) {
                    return kendo.format(formats.singleDayEnd || formats.singleDay, e);
                }
            }
            return null;
        }
        util.dateTimeRange = dateTimeRange;
        function throttle(func, wait, options) {
            var context, args, result;
            var timeout = null;
            var previous = 0;
            if (!options)
                options = {};
            var later = function () {
                previous = options.leading === false ? 0 : Date.now();
                timeout = null;
                result = func.apply(context, args);
                if (!timeout)
                    context = args = null;
            };
            return function () {
                var now = Date.now();
                if (!previous && options.leading === false)
                    previous = now;
                var remaining = wait - (now - previous);
                context = this;
                args = arguments;
                if (remaining <= 0 || remaining > wait) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    previous = now;
                    result = func.apply(context, args);
                    if (!timeout)
                        context = args = null;
                }
                else if (!timeout && options.trailing !== false) {
                    timeout = setTimeout(later, remaining);
                }
                return result;
            };
        }
        util.throttle = throttle;
        ;
        function unflatten(obj) {
            "use strict";
            if (Object(obj) !== obj || Array.isArray(obj)) {
                return obj;
            }
            let regex = /\.?([^.\[\]]+)|\[(\d+)\]/g, result = {};
            for (var key in obj) {
                var cur = result, prop = "", m;
                while (m = regex.exec(key)) {
                    cur = cur[prop] || (cur[prop] = (m[2] ? [] : {}));
                    prop = m[2] || m[1];
                }
                cur[prop] = obj[key];
            }
            return result[""] || result;
        }
        util.unflatten = unflatten;
    })(util = enroller.util || (enroller.util = {}));
})(enroller || (enroller = {}));
var esd;
(function (esd) {
    var handler = function (e, xhr) {
        if (esd.ajaxErrorHandler.handlers != undefined) {
            var handler = esd.ajaxErrorHandler.handlers[xhr.status.toString()];
            if (handler !== undefined) {
                if ($.isFunction(handler)) {
                    handler(e, xhr);
                }
                return;
            }
            var title = xhr.statusText || xhr.status;
            var message = "An error with the server request.";
            if (xhr.responseText !== undefined) {
                message = xhr.responseText;
            }
            if (xhr.responseJSON !== undefined && xhr.responseJSON.Message !== undefined) {
                var r = xhr.responseJSON;
                message = r.Message;
                if (r.ModelState !== undefined) {
                    var errors = [];
                    for (var prop in r.ModelState) {
                        for (var i = 0; i < r.ModelState[prop].length; i++) {
                            errors.push(r.ModelState[prop][i]);
                        }
                    }
                    title = 'An error occurred saving:';
                    message = errors.join(' ');
                }
            }
            esd.toast.error(title, message);
        }
    };
    esd.ajaxErrorHandler = handler;
    esd.ajaxErrorHandler.handlers = {};
    esd.ajaxErrorHandler.addHandler = function (status, handler) {
        this.handlers[status.toString()] = handler;
    };
})(esd || (esd = {}));
var esd;
(function (esd) {
    class Toaster {
        constructor() {
            this._kendoNotification = null;
        }
        initialize() {
            if (this._kendoNotification != null) {
                return;
            }
            var container = $('#enr-toast-container');
            if (container.length === 0) {
                container = $('<div id="enr-toast-container"></div>');
                $('body').append(container);
            }
            this._kendoNotification = container.kendoNotification({
                animation: {
                    open: {
                        effects: "expand:vertical",
                    },
                    close: {
                        effects: "expand:vertical",
                        reverse: true
                    }
                },
                appendTo: container,
                autoHideAfter: 7000,
                hideOnClick: true,
                stacking: 'top',
                templates: [
                    {
                        type: 'info',
                        template: `<div class='enr-toast'>${enroller.util.icon("info", { classes: "fa-fw", template: true })}<div><strong>#: title #</strong><div>#: message #</div></div></div>`
                    }, {
                        type: 'success',
                        template: `<div class='enr-toast'>${enroller.util.icon("check", { classes: "fa-fw", template: true })}<div><strong>#: title #</strong><div>#: message #</div></div></div>`
                    }, {
                        type: 'warning',
                        template: `<div class='enr-toast'>${enroller.util.icon("exclamation", { classes: "fa-fw", template: true })}<div><strong>#: title #</strong><div>#: message #</div></div></div>`
                    }, {
                        type: 'error',
                        template: `<div class='enr-toast'>${enroller.util.icon("circle-exclamation", { classes: "fa-fw", template: true })}<div><strong>#: title #</strong><div>#: message #</div></div></div>`
                    }
                ]
            }).data("kendoNotification");
        }
        notify(title, message, type) {
            this.initialize();
            if (message == null) {
                message = (title || '').toString();
                title = undefined;
            }
            this._kendoNotification.show({
                title: title || '',
                message: message || ''
            }, type.toLowerCase());
        }
        info(title, message) {
            this.notify(title, message, "info");
        }
        success(title, message) {
            this.notify(title, message, "success");
        }
        warning(title, message) {
            this.notify(title, message, "warning");
        }
        error(title, message) {
            this.notify(title, message, "error");
        }
        hide(title, message) {
            this.notify(title, message, "info");
        }
    }
    esd.Toaster = Toaster;
    esd.toast = new Toaster();
})(esd || (esd = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var binders;
        (function (binders) {
            let data = kendo.data;
            let parseValue = function (value, dataType) {
                if (dataType == 'date') {
                    value = kendo.parseDate(value);
                }
                else if (dataType == 'datetime-local') {
                    value = kendo.parseDate(value, [
                        'yyyy-MM-ddTHH:mm:ss',
                        'yyyy-MM-ddTHH:mm'
                    ]);
                }
                else if (dataType == 'number') {
                    value = kendo.parseFloat(value);
                }
                else if (dataType == 'boolean') {
                    value = value.toLowerCase();
                    if (kendo.parseFloat(value) !== null) {
                        value = Boolean(kendo.parseFloat(value));
                    }
                    else {
                        value = value.toLowerCase() === 'true';
                    }
                }
                return value;
            };
            var TypedBinder = data.Binder.extend({
                dataType: function () {
                    var dataType = this.element.getAttribute('data-type') || this.element.type || 'text';
                    return dataType.toLowerCase();
                },
                parsedValue: function () {
                    return parseValue(this.element.value, this.dataType());
                },
                isMatch: function (binding) {
                    let selectedValue = this.bindings[binding].get();
                    let value = $(this.element).data("value");
                    let dataType = this.dataType();
                    if (value !== null && value !== undefined) {
                        for (let match of value.toString().split(",")) {
                            if (parseValue(match, dataType) == selectedValue) {
                                return true;
                            }
                        }
                    }
                    else {
                        return selectedValue === null;
                    }
                    return false;
                }
            });
            data.binders.text = TypedBinder.extend({
                refresh: function () {
                    let text = this.bindings.text.get();
                    if (text === null || text === "") {
                        if (this.element.hasAttribute("data-default")) {
                            text = this.element.getAttribute("data-default");
                        }
                    }
                    let dataType = this.dataType();
                    let value = parseValue(text, dataType);
                    let dataFormat = this.element.getAttribute('data-format') || '';
                    if (value == null) {
                        value = '';
                    }
                    $(this.element).text(kendo.toString(value, dataFormat));
                }
            });
            data.binders.json = TypedBinder.extend({
                refresh: function () {
                    let text = this.bindings.json.get();
                    $(this.element).text(JSON.stringify(text, null, 2));
                }
            });
            var dateTimeRangeRefresh = function (binding) {
                let el = $(this.element);
                let item = this.bindings[binding.toLowerCase()].get();
                let start, end, format = null;
                if (typeof item == "string") {
                    item = kendo.parseDate(item);
                }
                if (item instanceof Date) {
                    start = item;
                }
                else if (item && typeof item == "object") {
                    start = item[el.data("start") || "Start"];
                    end = item[el.data("end") || "End"];
                    format = el.data("format");
                }
                $(this.element).text(enroller.util[binding](start, end, format));
            };
            data.binders.daterange = data.Binder.extend({
                refresh: function () {
                    dateTimeRangeRefresh.call(this, "dateRange");
                }
            });
            data.binders.datetimerange = data.Binder.extend({
                refresh: function () {
                    dateTimeRangeRefresh.call(this, "dateTimeRange");
                }
            });
            data.binders.timerange = data.Binder.extend({
                refresh: function () {
                    dateTimeRangeRefresh.call(this, "timeRange");
                }
            });
            data.binders.resize = data.Binder.extend({
                init: function (element, bindings, options) {
                    data.Binder.fn.init.call(this, element, bindings, options);
                    element.addEventListener("input", enroller.util.resizeHandler, false);
                },
                refresh: function () {
                    setTimeout(() => enroller.util.resize(this.element), 0);
                },
                destroy: function () {
                    this.element.removeEventListener("input", enroller.util.resizeHandler);
                }
            });
            let actionIf = function (value, element) {
                let action = $(element).data("action");
                if ((action == "enable" && value) || (action == "disable" && !value)) {
                    element.removeAttribute('disabled');
                }
                else if ((action == "disable" && value) || (action == "enable" && !value)) {
                    element.setAttribute('disabled', 'disabled');
                }
                else if ((action == "hide" && value) || (action == "show" && !value)) {
                    element.style.display = 'none';
                }
                else if ((action == "show" && value) || (action == "hide" && !value)) {
                    element.style.display = '';
                }
            };
            data.binders.actionIfOrganizationIdOther = data.Binder.extend({
                refresh: function () {
                    let value = this.bindings.actionIfOrganizationIdOther.get();
                    let others = [312, 313];
                    if ($(this.element).data("includeNull")) {
                        others.push(null);
                    }
                    actionIf(others.indexOf(value) > -1, this.element);
                }
            });
            data.binders.actionIfOrganizationIdKnown = data.Binder.extend({
                refresh: function () {
                    let value = this.bindings.actionIfOrganizationIdKnown.get();
                    let others = [312, 313];
                    if ($(this.element).data("includeNull")) {
                        others.push(null);
                    }
                    actionIf(others.indexOf(value) == -1, this.element);
                }
            });
            data.binders.collapse = TypedBinder.extend({
                refresh: function () {
                    let value = this.bindings.collapse.get();
                    if (value) {
                        $(this.element).addClass("show");
                    }
                    else {
                        $(this.element).removeClass("show");
                    }
                }
            });
            data.binders.clear = kendo.data.Binder.extend({
                init: function (element, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, element, bindings, options);
                    $(element).on("click", this._handler.bind(this));
                },
                refresh: function () { },
                change: function () { },
                _handler: function (e) {
                    this.bindings["clear"].set(null);
                },
                destroy: function () {
                    $(this.element).off("click", this._handler);
                }
            });
            data.binders.copy = kendo.data.Binder.extend({
                init: function (element, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, element, bindings, options);
                    $(element).on("click", this._handler.bind(this));
                },
                refresh: function () { },
                change: function () { },
                _handler: function (e) {
                    let value = kendo.stringify(this.bindings["copy"].get());
                    navigator.clipboard.writeText(value);
                    esd.toast.success("Text copied.");
                },
                destroy: function () {
                    $(this.element).off("click", this._handler);
                }
            });
            var visible = function (element, visible) {
                if (visible) {
                    element.style.removeProperty("display");
                }
                else {
                    element.style.setProperty("display", "none", "important");
                }
            };
            data.binders.visible = TypedBinder.extend({
                refresh: function () {
                    visible(this.element, this.bindings.visible.get());
                }
            });
            data.binders.invisible = TypedBinder.extend({
                refresh: function () {
                    visible(this.element, !this.bindings.invisible.get());
                }
            });
            data.binders.visibleValue = TypedBinder.extend({
                refresh: function () {
                    visible(this.element, this.isMatch("visibleValue"));
                }
            });
            data.binders.invisibleValue = TypedBinder.extend({
                refresh: function () {
                    visible(this.element, !this.isMatch("invisibleValue"));
                }
            });
            data.binders.enabledValue = TypedBinder.extend({
                refresh: function () {
                    if (this.isMatch("enabledValue")) {
                        this.element.removeAttribute('disabled');
                    }
                    else {
                        this.element.setAttribute('disabled', 'disabled');
                    }
                }
            });
            data.binders.disabledValue = TypedBinder.extend({
                refresh: function () {
                    if (this.isMatch("disabledValue")) {
                        this.element.setAttribute('disabled', 'disabled');
                    }
                    else {
                        this.element.removeAttribute('disabled');
                    }
                }
            });
            data.binders.widget.enabledValue = TypedBinder.extend({
                init: function (widget, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                    this.widget = widget;
                },
                refresh: function () {
                    if (this.widget.enable) {
                        this.widget.enable(this.isMatch("enabledValue"));
                    }
                }
            });
            data.binders.widget.disabledValue = TypedBinder.extend({
                init: function (widget, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                    this.widget = widget;
                },
                refresh: function () {
                    if (this.widget.enable) {
                        this.widget.enable(!this.isMatch("disabledValue"));
                    }
                }
            });
            data.binders.fadeIn = kendo.data.Binder.extend({
                first: true,
                init: function (element, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, element, bindings, options);
                    let value = this.bindings["fadeIn"].get();
                    if (value instanceof kendo.data.DataSource) {
                        value.one("change", () => {
                            this.first = false;
                        });
                    }
                },
                refresh: function (e) {
                    let value = this.bindings["fadeIn"].get();
                    if (value instanceof kendo.data.DataSource && e?.action == "add") {
                        let item = value.at(e.index);
                        if (item?.uid) {
                            this._play(kendo.fx($(`#${item.uid}`)));
                        }
                    }
                    else {
                        this._play(kendo.fx(this.element));
                        this.first = false;
                    }
                },
                _play(el) {
                    if (!this.first && el) {
                        el.fadeIn().duration(700).play();
                    }
                }
            });
            data.binders.broadcast = data.Binder.extend({
                init: function (element, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, element, bindings, options);
                    this.events = {};
                },
                _evt: function (e) {
                    if (!e.startsWith("bs")) {
                        return e;
                    }
                    let toggle = $(this.element).data("toggle");
                    return `${e.substr(2)}.bs.${toggle}`;
                },
                refresh: function () {
                    let path = this.bindings.broadcast.path;
                    if ($.isPlainObject(path)) {
                        for (let k in path) {
                            if (path.hasOwnProperty(k)) {
                                let evt = this._evt(k);
                                this.events[evt] = path[k];
                                $(this.element).on(evt, this._handler.bind(this, evt));
                            }
                        }
                    }
                },
                _handler: function (evt, e) {
                    let root = this.bindings.broadcast.parents[this.bindings.broadcast.parents.length - 1];
                    root.trigger(this.events[evt], e);
                },
                destroy: function () {
                    for (let k in this.events) {
                        if (this.events.hasOwnProperty(k)) {
                            $(this.element).off(k, this._handler);
                        }
                    }
                }
            });
            var listen = {
                handlers: null,
                init: function (element, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, element, bindings, options);
                    this.handlers = {};
                },
                refresh: function () {
                    let path = this.bindings.listen.path;
                    let root = this.bindings.listen.parents[this.bindings.listen.parents.length - 1];
                    if ($.isPlainObject(path)) {
                        for (let evt in path) {
                            if (path.hasOwnProperty(evt)) {
                                let handler = (e) => {
                                    let modelHandler = this.bindings.listen.source.get(evt);
                                    if ($.isFunction(modelHandler)) {
                                        modelHandler(e);
                                    }
                                    else if ($.isFunction(this.element[this.bindings.listen.path[evt]])) {
                                        this.element[this.bindings.listen.path[evt]]();
                                    }
                                };
                                this.handlers[evt] = handler;
                                root.bind(evt, handler.bind(this));
                            }
                        }
                    }
                },
                destroy: function () {
                    let root = this.bindings.listen.parents[this.bindings.listen.parents.length - 1];
                    for (let evt in this.handlers) {
                        root.unbind(evt, this.handlers[evt]);
                    }
                    this.handlers = {};
                }
            };
            data.binders.listen = data.Binder.extend(listen);
            data.binders.widget.listen = data.Binder.extend(listen);
            data.binders.events = kendo.data.Binder.extend({
                init: function (element, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, element, bindings, options);
                    this.handlers = {};
                },
                refresh: function (key) {
                    var element = $(this.element), binding = this.bindings.events[key], handler = this.handlers[key];
                    formattedKey = key;
                    if (key.includes("_bs_")) {
                        var formattedKey = key.replace(/_/g, ".");
                    }
                    if (handler) {
                        element.off(formattedKey, handler);
                    }
                    handler = this.handlers[key] = binding.get();
                    element.on(formattedKey, binding.source, handler);
                },
                destroy: function () {
                    var element = $(this.element), handler;
                    for (handler in this.handlers) {
                        element.off(handler, this.handlers[handler]);
                    }
                }
            });
            var bs = function (evt) {
                return {
                    toggle: null,
                    component: function (element, bindings, options) {
                        kendo.data.Binder.fn.init.call(this, element, bindings, options);
                        this.component = $(element).data("toggle")
                            || $(element).data("dismiss");
                        if (this.component) {
                            $(element).on(`${evt}.bs.${this.component}`, this._handler.bind(this));
                        }
                    },
                    refresh: function () { },
                    change: function () { },
                    _handler: function (e) {
                        let modelHandler = this.bindings[`bs${evt}`].get();
                        if ($.isFunction(modelHandler)) {
                            modelHandler(e);
                        }
                    },
                    destroy: function () {
                        if (this.component) {
                            $(this.element).off(`${evt}.bs.${this.component}`, this._handler);
                        }
                    }
                };
            };
            data.binders.bsshow = data.Binder.extend(bs("show"));
            data.binders.bsshown = data.Binder.extend(bs("shown"));
            data.binders.bshide = data.Binder.extend(bs("hide"));
            data.binders.bshidden = data.Binder.extend(bs("hidden"));
            data.binders.bsclose = data.Binder.extend(bs("close"));
            data.binders.bsclosed = data.Binder.extend(bs("closed"));
            data.binders.mailto = data.Binder.extend({
                refresh: function () {
                    var value = this.bindings["mailto"].get();
                    if (value) {
                        this.element.setAttribute("href", "mailto:" + value);
                    }
                    else {
                        this.element.removeAttribute("href");
                    }
                }
            });
            data.binders.tel = data.Binder.extend({
                refresh: function () {
                    var value = this.bindings["tel"].get();
                    if (value) {
                        this.element.setAttribute("href", "tel:" + value);
                    }
                    else {
                        this.element.removeAttribute("href");
                    }
                }
            });
            data.binders.toggle = data.Binder.extend({
                handler: function (e) {
                    var value = !!e.data.get();
                    e.data.set(!value);
                },
                refresh: function () {
                    if (this.bound) {
                        $(this.element).off("click", this.handler);
                    }
                    this.bound = true;
                    var binding = this.bindings["toggle"];
                    $(this.element).on("click", binding, this.handler);
                },
                destroy: function () {
                    $(this.element).off("click", this.handler);
                }
            });
            data.binders.processing = data.Binder.extend({
                init: function (element, bindings, options) {
                    data.Binder.fn.init.call(this, element, bindings, options);
                },
                refresh: function () {
                    let value = this.bindings["processing"].get();
                    enroller.util.processing(this.element, !!value);
                }
            });
            data.binders.icon = data.Binder.extend({
                init: function (element, bindings, options) {
                    data.Binder.fn.init.call(this, element, bindings, options);
                },
                refresh: function () {
                    let value = this.bindings["icon"].get();
                    let el = $(this.element);
                    let enumValue = parseEnumValues(el);
                    if (enumValue) {
                        let item = enroller.enums.get(value, enumValue);
                        if (item && item.icon) {
                            value = item.icon;
                        }
                    }
                    $(this.element).html(enroller.util.icon(value));
                }
            });
            data.binders.badge = data.Binder.extend({
                refresh: function () {
                    let value = this.bindings["badge"].get();
                    let el = $(this.element);
                    let values = parseEnumValues(el);
                    if (!values) {
                        el.text(value || '');
                    }
                    else {
                        let badge = enroller.format.badge(value, values);
                        el.html(badge);
                    }
                }
            });
            data.binders.enum = data.Binder.extend({
                refresh: function () {
                    let value = this.bindings["enum"].get();
                    let el = $(this.element);
                    let values = parseEnumValues(el);
                    let item = enroller.enums.get(value, values);
                    el.text(item?.text || value || '');
                }
            });
            function parseEnumValues(el) {
                let values;
                let path = (el.data("badge") || el.data("enum") || "").split(".");
                if (path.length == 1) {
                    return enroller.enums[path[0]];
                }
                else if (path.length > 1) {
                    values = window[path[0]];
                    for (let i = 1; i < path.length; i++) {
                        if (!values) {
                            break;
                        }
                        values = values[path[i]];
                    }
                    return values;
                }
            }
            data.binders.class = data.Binder.extend({
                init: function (element, bindings, options) {
                    data.Binder.fn.init.call(this, element, bindings, options);
                    this.appliedClasses = null;
                },
                refresh: function (className) {
                    let element = $(this.element);
                    element.removeClass(this.appliedClasses);
                    let classes = this.bindings["class"].get();
                    element.addClass(classes);
                    this.appliedClasses = classes;
                }
            });
            data.binders.input.checkedValue = TypedBinder.extend({
                init: function (element, bindings, options) {
                    TypedBinder.fn.init.call(this, element, bindings, options);
                    this._change = $.proxy(this.change, this);
                    $(this.element).change(this._change);
                },
                change: function () {
                    var value = this.element.value;
                    if (this.element.type == 'radio') {
                        value = this.parsedValue();
                        this.bindings["checkedValue"].set(value);
                    }
                    else if (this.element.type == 'checkbox') {
                        var source = this.bindings["checkedValue"].get();
                        var index;
                        if (source instanceof kendo.data.ObservableArray) {
                            value = this.parsedValue();
                            if (value instanceof Date) {
                                for (var i = 0; i < source.length; i++) {
                                    if (source[i] instanceof Date && +source[i] === +value) {
                                        index = i;
                                        break;
                                    }
                                }
                            }
                            else {
                                index = source.indexOf(value);
                            }
                            if (index > -1) {
                                source.splice(index, 1);
                            }
                            else {
                                source.push(value);
                            }
                        }
                        else {
                            if (this.element.checked) {
                                this.bindings["checkedValue"].set(value);
                            }
                            else {
                                this.bindings["checkedValue"].set(null);
                            }
                        }
                    }
                },
                refresh: function () {
                    var value = this.bindings["checkedValue"].get(), source = value, type = this.dataType(), element = this.element;
                    if (element.type == 'checkbox') {
                        if (source instanceof kendo.data.ObservableArray) {
                            var index = -1;
                            value = this.parsedValue();
                            if (value instanceof Date) {
                                for (var i = 0; i < source.length; i++) {
                                    if (source[i] instanceof Date && +source[i] === +value) {
                                        index = i;
                                        break;
                                    }
                                }
                            }
                            else {
                                index = source.indexOf(value);
                            }
                            element.checked = index >= 0;
                        }
                        else {
                            element.checked = !(value === null || value === undefined);
                        }
                    }
                    else if (element.type == 'radio') {
                        if (type == 'date') {
                            value = kendo.toString(value, 'yyyy-MM-dd');
                        }
                        else if (type == 'datetime-local') {
                            value = kendo.toString(value, 'yyyy-MM-ddTHH:mm:ss');
                        }
                        if (value !== null && typeof value !== 'undefined' && element.value === value.toString()) {
                            element.checked = true;
                        }
                        else {
                            element.checked = false;
                        }
                    }
                },
                destroy: function () {
                    $(this.element).off("change", this._change);
                }
            });
            data.binders.widget.options = data.Binder.extend({
                init: function (target, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, target, bindings, options);
                    let bound = enroller.util.flatten(this.bindings.options.path);
                    this._lookups = {};
                    for (let key in bound) {
                        if (!bound.hasOwnProperty(key))
                            continue;
                        this._lookups[key] = {
                            path: bound[key],
                            original: enroller.util.fetch(this.options, key)
                        };
                    }
                },
                refresh: function () {
                    let settings = {};
                    for (var setting in this._lookups) {
                        if (!this._lookups.hasOwnProperty(setting))
                            continue;
                        let lookup = this._lookups[setting];
                        this.bindings.options.path = lookup.path;
                        var value = this.bindings.options.get();
                        if (lookup.original !== undefined && typeof lookup.original === "string") {
                            value = binders.tokenizer(lookup.original, value, null);
                        }
                        settings[setting] = value;
                    }
                    this.element.setOptions(enroller.util.unflatten(settings));
                }
            });
            data.binders.href = kendo.data.Binder.extend({
                refresh: function (key) {
                    tokenizerBinding(this, "href");
                }
            });
            data.binders.action = kendo.data.Binder.extend({
                refresh: function (key) {
                    tokenizerBinding(this, "action");
                }
            });
            data.binders.widget.action = kendo.data.Binder.extend({
                refresh: function (key) {
                    tokenizerBinding(this, "action");
                }
            });
            let tokenizerBinding = function (binder, attr) {
                let element = binder.element instanceof kendo.ui.Widget
                    ? $(binder.element.element)
                    : $(binder.element);
                let dataRoute = $(element).data(attr);
                let attrRoute = $(element).attr(attr);
                if (!dataRoute && !attrRoute) {
                    throw new Error(attr + " binding expected a non-null route in " + attr + " or data-" + attr + " attribtues.");
                }
                else if (attrRoute && !dataRoute) {
                    $(element).data(attr, attrRoute);
                    dataRoute = attrRoute;
                }
                let value = binder.bindings[attr].get();
                element.attr(attr, binders.tokenizer(dataRoute, value, element.data("format")));
            };
            function tokenizer(route, value, format) {
                return route.replace(/[/?=]:([a-z0-9]+)/ig, (sub, ...args) => {
                    let token = args[0];
                    if (value instanceof kendo.data.ObservableArray) {
                        value = value.toJSON();
                    }
                    if ($.isArray(value)) {
                        return sub.substring(0, 1) + "[" + value.join(",") + "]";
                    }
                    let tokenValue = value !== null && typeof value === "object"
                        ? value[token]
                        : value;
                    if (tokenValue instanceof kendo.data.ObservableObject || tokenValue instanceof kendo.data.ObservableArray) {
                        tokenValue = tokenValue.toJSON();
                    }
                    var rawValue = $.isFunction(tokenValue)
                        ? tokenValue()
                        : tokenValue;
                    return sub.substring(0, 1) + (format
                        ? kendo.format(format, rawValue)
                        : rawValue);
                });
            }
            binders.tokenizer = tokenizer;
            data.binders.widget.self = kendo.data.Binder.extend({
                init: function (widget, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                    this.widget = widget;
                    this.bindings["self"].set(widget);
                },
                change: function () { }
            });
            data.binders.widget.jsonValue = kendo.data.Binder.extend({
                init: function (widget, bindings, options) {
                    kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                    this.widget = widget;
                },
                refresh: function () {
                    let text = this.bindings.jsonValue.get();
                    this.widget.value(JSON.stringify(text.toJSON(), null, 2));
                }
            });
            data.binders.widget.listbox = {
                value: kendo.data.Binder.extend({
                    init: function (widget, bindings, options) {
                        kendo.data.Binder.fn.init.call(this, widget.element[0], bindings, options);
                        this._change = $.proxy(this.change, this);
                        this.widget = widget;
                        this.widget.dataSource.first("change", this._change);
                        this._initChange = false;
                        this._refreshChange = false;
                    },
                    refresh: function () {
                        if (this._initChange) {
                            this._initChange = false;
                            return;
                        }
                        this._refreshChange = true;
                        var field = this.widget.options.dataValueField || this.widget.options.dataTextField;
                        var values = this.bindings["value"].get() || [];
                        var source = $('#' + this.widget.options.connectWith).data("kendoListBox");
                        if (source === undefined) {
                            return;
                        }
                        var toAdd = [];
                        var toRemove = [];
                        for (var i = 0; i < values.length; i++) {
                            var found = this.widget.dataSource.get(values[i]);
                            if (found === undefined) {
                                toAdd.push(values[i]);
                            }
                        }
                        var data = this.widget.dataSource.data();
                        for (var i = 0; i < data.length; i++) {
                            let id = data[i][field];
                            if (values.indexOf(id) == -1) {
                                toRemove.push(id);
                            }
                        }
                        for (var i = 0; i < toAdd.length; i++) {
                            let item = source.dataSource.get(toAdd[i]);
                            this.widget.dataSource.add(item);
                            source.dataSource.remove(item);
                        }
                        for (var i = 0; i < toRemove.length; i++) {
                            let item = this.widget.dataSource.get(toRemove[i]);
                            this.widget.dataSource.remove(item);
                            source.dataSource.add(item);
                        }
                        this._refreshChange = false;
                    },
                    change: function (e) {
                        if ((e.action !== "add" && e.action !== "remove") || this._refreshChange) {
                            return;
                        }
                        this._initChange = true;
                        var field = this.widget.options.dataValueField || this.widget.options.dataTextField;
                        var values = [];
                        var data = e.sender.data();
                        for (var i = 0; i < data.length; i++) {
                            values.push(data[i][field]);
                        }
                        this.bindings.value.set(values);
                        this._initChange = false;
                    },
                    destroy: function () {
                        this.widget.unbind("check", this._check);
                    }
                })
            };
        })(binders = kendoui.binders || (kendoui.binders = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var excel;
        (function (excel_1) {
            function exportGrid(grid) {
                let g = grid instanceof kendo.ui.Grid ? grid : $(grid).data('kendoGrid');
                return excelExport(g, true);
            }
            excel_1.exportGrid = exportGrid;
            function gridEvent(e) {
                excelExport(e.sender, false);
                e.preventDefault();
            }
            excel_1.gridEvent = gridEvent;
            function excelExport(grid, triggerEvent) {
                const source = grid.dataSource;
                const excel = grid.options.excel || {};
                const columns = grid.columns.slice(0)
                    .filter((c) => c.exportable !== false);
                const excelFormatProps = [
                    "groupFooterTemplate",
                    "groupHeaderTemplate",
                    "groupHeaderColumnTemplate",
                    "headerTemplate",
                    "footerTemplate",
                    "title"
                ];
                for (var key in columns) {
                    const column = columns[key];
                    if (column.exportable !== false) {
                        column.exportable = true;
                    }
                    for (let prop of excelFormatProps) {
                        if (column.excel && column.excel[prop]) {
                            column[prop] = column.excel[prop];
                        }
                    }
                }
                const exporter = new kendo.ExcelExporter({
                    columns: columns,
                    dataSource: source,
                    allPages: true,
                    filterable: excel.filterable || true,
                    hierarchy: true,
                });
                return exporter.workbook().then($.proxy(function (book, data) {
                    if (!triggerEvent || !this.trigger('excelExport', {
                        workbook: book,
                        data: data
                    })) {
                        function evaluate(o, cell) {
                            if (o instanceof Function) {
                                return o(cell);
                            }
                            return o;
                        }
                        var offset = book.sheets[0].columns.length - columns.length;
                        for (let i = 0; i < columns.length; i++) {
                            let column = columns[i];
                            if (column.excel) {
                                if (column.excel.width) {
                                    book.sheets[0].columns[i + offset].autoWidth = false;
                                    book.sheets[0].columns[i + offset].width = column.excel.width;
                                }
                                for (let ri = 0; ri < book.sheets[0].rows.length; ri++) {
                                    let row = book.sheets[0].rows[ri];
                                    if (row.type == "data") {
                                        row.cells[i + offset].background = evaluate(column.excel.background, row.cells[i + offset]);
                                        row.cells[i + offset].bold = evaluate(column.excel.bold, row.cells[i + offset]);
                                        row.cells[i + offset].color = evaluate(column.excel.color, row.cells[i + offset]);
                                        row.cells[i + offset].format = evaluate(column.excel.format, row.cells[i + offset]);
                                        row.cells[i + offset].italic = evaluate(column.excel.italic, row.cells[i + offset]);
                                    }
                                }
                            }
                        }
                        for (let ri = 0; ri < book.sheets[0].rows.length; ri++) {
                            let row = book.sheets[0].rows[ri];
                            if (row.type == "group-header") {
                                row.height = 35;
                                for (let i = 0; i < row.cells.length; i++) {
                                    row.cells[i].bold = true;
                                    row.cells[i].borderTop = { color: "#333333", size: 1 };
                                }
                            }
                            else if (row.type == "header") {
                                row.height = 35;
                                for (let i = 0; i < row.cells.length; i++) {
                                    row.cells[i].bold = true;
                                }
                            }
                        }
                        let workbook = new kendo.ooxml.Workbook(book);
                        let fileName = book.name || excel.fileName;
                        if (!fileName.toLowerCase().endsWith(".xlsx")) {
                            fileName = fileName + ".xlsx";
                        }
                        workbook.toDataURLAsync()
                            .then((dataURL) => {
                            kendo.saveAs({
                                dataURI: dataURL,
                                fileName: fileName,
                                proxyURL: excel.proxyURL,
                                forceProxy: excel.forceProxy
                            });
                        });
                    }
                }, grid));
            }
        })(excel = kendoui.excel || (kendoui.excel = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
;
(function () {
    if (kendo.ui.Popup === undefined) {
        return;
    }
    var _init = kendo.ui.Popup.fn.init;
    var Popup = kendo.ui.Popup.extend({
        init: function (element, options) {
            if (options.appendTo === undefined) {
                var parentModal = $(options.anchor).closest('.modal, .modal-body, .modal-content');
                if (parentModal.length > 0) {
                    options.appendTo = parentModal[0];
                }
            }
            _init.call(this, element, options);
        }
    });
    kendo.ui.plugin(Popup);
}());
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var dateSelectors = [
            '[type^=date]',
            '[data-type=date]',
            '[data-role=dateinput]',
            '[data-role=datepicker]',
            '[data-role=datetimepicker]',
        ].join(',');
        var dateMap = {
            dateinput: "kendoDateInput",
            datepicker: "kendoDatePicker",
            datetimepicker: "kendoDateTimePicker"
        };
        function min(input) {
            if (input.filter(dateSelectors).length && input.attr("min")) {
                let min = kendo.parseDate(input.attr("min"));
                let value = getDate(input);
                return !min || !value || value >= min;
            }
            return kendo.ui.Validator.fn.options.rules["min"].call(this, input);
        }
        function max(input) {
            if (input.filter(dateSelectors).length && input.attr("max")) {
                let max = kendo.parseDate(input.attr("max"));
                let value = getDate(input);
                return !max || !value || value <= max;
            }
            return kendo.ui.Validator.fn.options.rules["max"].call(this, input);
        }
        class Validator extends kendo.ui.Validator {
            constructor(element, options) {
                super(element, $.extend(true, {}, {
                    rules: {
                        min: min,
                        max: max,
                        mvcmin: min,
                        mvcmax: max,
                        requiredIf: enroller.kendoui.validator.requiredIf,
                        required: function (input) {
                            if (input.filter('[type=radio]').length && input.attr("required") && input.attr("name")) {
                                return this.element.find(`input[type=radio][name='${input.attr("name")}']:checked`).length;
                            }
                            else if (input.filter('[type=checkbox]').length && input.attr("required") && input.attr("name")) {
                                return this.element.find(`input[type=checkbox][name='${input.attr("name")}']:checked`).length;
                            }
                            return kendo.ui.Validator.fn.options.rules["required"].call(this, input);
                        },
                        date: function (input) {
                            let val = input.val();
                            if (input.filter(dateSelectors).length
                                && val != ""
                                && val.indexOf("month/day/year") == -1) {
                                return getDate(input) !== null;
                            }
                            return true;
                        }
                    },
                    messages: {
                        email: (input) => input.data("val-email") || kendo.ui.Validator.fn.options.messages["email"],
                        min: (input) => input.data("val-min") || kendo.ui.Validator.fn.options.messages["min"],
                        max: (input) => input.data("val-max") || kendo.ui.Validator.fn.options.messages["max"],
                    }
                }, options));
            }
        }
        kendoui.Validator = Validator;
        function getDate(input) {
            let role = input.data("role");
            if (dateMap[role]) {
                let widget = input.data(dateMap[role]);
                return widget.value();
            }
            let val = input.val();
            if (!val) {
                return null;
            }
            return kendo.parseDate(val)
                || input.attr("data-format")
                ? kendo.parseDate(val, input.attr("data-format"))
                : null;
        }
        kendo.ui.plugin(Validator);
        kendo.ui.Validator.prototype.options.errorTemplate = `<span>${enroller.util.icon("fa-exclamation", { template: true })}#=message#</span>`;
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var validator;
        (function (validator_1) {
            function matches(input) {
                var matches = input.data('matches');
                if (matches) {
                    var match = $(matches);
                    return $.trim(input.val()) === $.trim(match.val());
                }
                return true;
            }
            validator_1.matches = matches;
            var availability = {
                cache: {},
                getItem: function (element) {
                    var key = element.attr('id') || element.attr('name');
                    return this.cache[key] = this.cache[key] || {};
                },
                check: function (element, url, validator) {
                    var cache = this.getItem(element);
                    var spinner = $('<em class="text-muted"><i class="fa fa-spin fa-refresh"></i> Checking availability...</em>');
                    element.after(spinner);
                    $.ajax({
                        url: url,
                        dataType: 'json',
                        data: {
                            q: element.val()
                        }
                    })
                        .done(function (data, state, xhr) {
                        cache.valid = data === null || data === false || xhr.status === 204;
                        cache.response = data;
                        cache.value = element.val();
                        validator.validateInput(element);
                    })
                        .fail(function () {
                        cache.valid = true;
                        cache.value = element.val();
                        validator.validateInput(element);
                    })
                        .always(function () {
                        spinner.remove();
                    });
                }
            };
            function available(input) {
                var validate = input.data('available');
                if (typeof validate === 'undefined' || validate === false || !input.val()) {
                    if (success) {
                        $(success).hide();
                    }
                    return true;
                }
                if (this.options.messages.available === undefined) {
                    this.options.messages.available = enroller.kendoui.validator.available_msg;
                }
                var cache = availability.getItem(input);
                var success = input.data('availableSuccess');
                if (success) {
                    $(success).hide();
                }
                if (cache.value === input.val() && cache.valid) {
                    if (success) {
                        $(success).show();
                    }
                    return true;
                }
                if (cache.value === input.val() && !cache.valid) {
                    return false;
                }
                availability.check(input, input.data('availableUrl'), this);
                return true;
            }
            validator_1.available = available;
            function available_msg(input) {
                var cache = availability.getItem(input);
                var message = kendo.template(input.data('availableTemplate') || '#: value # is not available.');
                return message(cache);
            }
            validator_1.available_msg = available_msg;
            function greaterdate(input) {
                if (input.is("[data-greaterdate-msg]") && input.val() != "") {
                    var date = _getDateTime(input, this);
                    var other = this.element.find("[name='" + input.data("greaterdateField") + "']");
                    var otherDate = _getDateTime(other, this);
                    if (otherDate != null) {
                        if (!other.data("is-validating-target")) {
                            input.data("is-validating-target", true);
                            this.validateInput(other);
                            input.removeData("is-validating-target");
                        }
                        return otherDate?.getTime() < date?.getTime();
                    }
                }
                return true;
            }
            validator_1.greaterdate = greaterdate;
            function lesserdate(input) {
                if (input.is("[data-lesserdate-msg]") && input.val() != "") {
                    var date = _getDateTime(input, this);
                    var other = this.element.find("[name='" + input.data("lesserdateField") + "']");
                    var otherDate = _getDateTime(other, this);
                    if (otherDate != null) {
                        if (!other.data("is-validating-target")) {
                            input.data("is-validating-target", true);
                            this.validateInput(other);
                            input.removeData("is-validating-target");
                        }
                        return otherDate?.getTime() > date?.getTime();
                    }
                }
                return true;
            }
            validator_1.lesserdate = lesserdate;
            function _getDateTime(input, validator) {
                var picker = input.data('kendoDateTimePicker')
                    || input.data('kendoDatePicker')
                    || input.data('kendoTimePicker');
                if (picker != null) {
                    return picker.value();
                }
                return kendo.parseDate(input.val());
            }
            function compare(input) {
                if (input.is("[data-compare-msg]") && input.val() != "") {
                    let val1 = input.val();
                    let target = this.element.find("[name='" + input.data("compareField") + "']");
                    let val2 = target.val();
                    if ($.isNumeric(val1) && $.isNumeric(val2)) {
                        if (!target.data("is-validating-target")) {
                            input.data("is-validating-target", true);
                            this.validateInput(target);
                            input.removeData("is-validating-target");
                        }
                        val1 = val1 * 1;
                        val2 = val2 * 1;
                        var operator = input.data("compare");
                        switch (operator) {
                            case ">":
                                return val1 > val2;
                            case ">=":
                                return val1 >= val2;
                            case "<":
                                return val1 < val2;
                            case "<=":
                                return val1 <= val2;
                            case "==":
                                return val1 == val2;
                            case "!=":
                                return val1 != val2;
                        }
                    }
                }
                return true;
            }
            validator_1.compare = compare;
            function requiredIf(input) {
                var requiredIf = input.data('required-if');
                if (requiredIf != undefined) {
                    var parent = this.element.find('input[name=' + requiredIf + ']');
                    var parentHasValue = parent.filter("[type=checkbox]").length
                        ? parent.is(":checked")
                        : parent.val() === '';
                    if (parentHasValue) {
                        var checkbox = input.filter("[type=checkbox]").length && !input.is(":checked"), value = input.val();
                        return !(value === "" || !value || checkbox);
                    }
                }
                return true;
            }
            validator_1.requiredIf = requiredIf;
            function upload(input) {
                if (input[0].type == "file") {
                    return input.data("kendoUpload").getFiles().length > 0;
                }
                return true;
            }
            validator_1.upload = upload;
        })(validator = kendoui.validator || (kendoui.validator = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            var CHANGE = "change", NAME = "bspager";
            class BsPager extends kendo.ui.Widget {
                constructor(element, options) {
                    super(element, options);
                    this.linkTemplate = kendo.template('<li class="page-item #if(data.current){#active#}#"><a href="\\#" class="page-link" data-page="#=idx#" #if (data.title) {# title="#:data.title#" #}#>#:data.text#</a></li>');
                    this.dataSource = kendo.data.DataSource.create(options.dataSource);
                    this._refreshHandler = $.proxy(this.refresh, this);
                    this.dataSource.bind(CHANGE, this._refreshHandler);
                    if (options.autoBind) {
                        this.refresh();
                    }
                    this.element.on("click", "a", $.proxy(this._click, this));
                }
                jumpButton(page, enabled, icon, dir, title) {
                    let iconClasses = dir ? "fa-rotate-270" : "fa-rotate-90";
                    return enabled
                        ? `<li class="page-item "><a class="page-link" data-page="${page}" href="#" title="${title}">${enroller.util.icon(icon, { classes: iconClasses })}</a></li>`
                        : `<li class="page-item disabled"><a class="page-link" tabindex="-1" aria-disabled="true" data-page="${page}" href="#">${enroller.util.icon(icon, { classes: iconClasses })}</i></a></li>`;
                }
                refresh() {
                    let html = '<ul class="pagination m-0">';
                    let page = this.page(), reminder = 0, start = 1, totalPages = this.totalPages(), buttonCount = this.options.buttonCount;
                    if (page > buttonCount) {
                        reminder = (page % buttonCount);
                        start = (reminder === 0) ? (page - buttonCount) + 1 : (page - reminder) + 1;
                    }
                    let end = Math.min((start + buttonCount) - 1, totalPages);
                    html += this.jumpButton(1, page != 1, "fal-angles-up", true, "First Page");
                    html += this.jumpButton(Math.max(page - 1, 1), page != 1, "fal-angle-up", true, "Previous Page");
                    if (start > 1) {
                        html += this.linkTemplate({
                            idx: start - 1,
                            text: '...',
                            current: false,
                            title: "More pages"
                        });
                    }
                    for (let i = start; i <= end; i++) {
                        html += this.linkTemplate({
                            idx: i,
                            text: i,
                            current: i == page
                        });
                    }
                    if (end < totalPages) {
                        html += this.linkTemplate({
                            idx: end + 1,
                            text: '...',
                            current: false,
                            title: "More pages"
                        });
                    }
                    html += this.jumpButton(Math.min(page + 1, totalPages), page != totalPages, "fal-angle-up", false, "Next Page");
                    html += this.jumpButton(totalPages, end != totalPages, "fal-angles-up", false, "Last Page");
                    html += '</ul>';
                    this.element.html(html);
                }
                _click(e) {
                    e.preventDefault();
                    var target = $(e.currentTarget);
                    if (!target.is("disabled")) {
                        this.trigger(CHANGE, { index: target.attr("data-page") });
                    }
                }
                totalPages() {
                    return Math.ceil((this.dataSource.total() || 0) / (this.pageSize() || 1));
                }
                pageSize() {
                    return this.dataSource.pageSize() || this.dataSource.total();
                }
                page(page) {
                    if (page !== undefined) {
                        this.dataSource.page(page);
                        this.trigger(CHANGE, { index: page });
                    }
                    else {
                        return this.dataSource.total() > 0
                            ? this.dataSource.page()
                            : 0;
                    }
                }
                destroy() {
                    var that = this;
                    kendo.ui.Widget.fn.destroy.call(that);
                    that.element.off(BsPager.ns);
                    that.dataSource.unbind(CHANGE, that._refreshHandler);
                    that._refreshHandler = null;
                    kendo.destroy(that.element);
                    that.element = null;
                }
                setDataSource(dataSource) {
                    this.dataSource.unbind(CHANGE, this._refreshHandler);
                    this.dataSource = this.options.dataSource = dataSource;
                    dataSource.bind(CHANGE, this._refreshHandler);
                    if (this.options.autoBind) {
                        dataSource.fetch();
                    }
                }
            }
            BsPager.ns = ".enr-bs-pager";
            widgets.BsPager = BsPager;
            BsPager.fn = BsPager.prototype;
            BsPager.fn.options = $.extend(true, {}, {
                name: NAME,
                autoBind: false,
                buttonCount: 5,
            });
            kendo.ui.plugin(BsPager);
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            function noDataTemplate(resource) {
                return function () {
                    if (this.options.filter === undefined || this.options.filter === 'none') {
                        return "No " + resource + " found.";
                    }
                    var hasValue = this.filterInput === undefined
                        ? this.value()
                        : this.filterInput.val();
                    return hasValue
                        ? "No " + resource + " found."
                        : "Search to find " + resource + "...";
                };
            }
            widgets.noDataTemplate = noDataTemplate;
            function set(e) {
                if (e.value !== null && e.value != e.sender.value()) {
                    if (e.sender.dataSource.get(e.value)) {
                        return;
                    }
                    e.sender.dataSource.read({ id: e.value, q: null })
                        .then(r => {
                        e.sender.select(i => i[e.sender.options.dataValueField] == e.value);
                    });
                }
            }
            widgets.set = set;
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            widgets.orgInit = function (element, options) {
                options = options || {};
                if (options.dataSource == undefined) {
                    var that = this;
                    var params = {
                        id: function () {
                            return that.value();
                        },
                    };
                    if (options.includeSystem == true) {
                        params.includeSystem = true;
                    }
                    if (options.scope) {
                        params.scope = (options) => {
                            if (this.options.scope == "current") {
                                return enroller.core.urls.organizationId;
                            }
                            return this.options.scope;
                        };
                    }
                    options.dataSource = enroller.util.filterSource(enroller.core.urls.api("organizations"), params);
                    if (options.value != null || element.value != "") {
                        options.autoBind = true;
                    }
                }
            };
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            function addBuilding(id, value) {
                let widget = $("#" + id).data("kendoBuildingDropDownList");
                let dataSource = widget.dataSource;
                let parent = $(`#${widget.options.cascadeFrom}`).data("kendoOrganizationDropDownList");
                if (!parent) {
                    console.error("Building dropdown must cascade from organization dropdown.");
                    return;
                }
                dataSource.add({
                    Name: value,
                    OrganizationId: parent.value()
                });
                dataSource.sync().done(() => {
                    let viewLength = dataSource.view().length;
                    let index = widget.options.optionLabel ? viewLength : viewLength - 1;
                    widget.select(index);
                    widget.close();
                });
            }
            widgets.addBuilding = addBuilding;
            var BuildingDropDownList = kendo.ui.DropDownList.extend({
                init: function (element, options) {
                    options = options || {};
                    if (options.dataSource == undefined) {
                        options.dataSource = enroller.util.getDataSource({
                            url: enroller.core.urls.api("buildings"),
                            model: {
                                id: "BuildingId",
                                fields: {
                                    BuildingId: { type: "number" },
                                    Name: { type: "string" },
                                    OrganizationId: { type: "number" }
                                }
                            },
                            transports: ["create"],
                            options: {
                                transport: {
                                    read: {
                                        data: (readOptions) => {
                                            return { id: this.value() };
                                        }
                                    }
                                },
                                serverFiltering: true,
                                serverPaging: true,
                                serverSorting: true,
                                pageSize: 20
                            }
                        });
                        if (options.value != null || element.value != "") {
                            options.autoBind = true;
                        }
                    }
                    kendo.ui.DropDownList.fn.init.call(this, element, options);
                    this.bind("set", widgets.set);
                },
                _parentWidget: function () {
                    if (!this.options.cascadeFrom) {
                        return;
                    }
                    var parentElement = $('#' + this.options.cascadeFrom);
                    if (parentElement.length == 0) {
                        return parent;
                    }
                    return parentElement[0].kendoBindingTarget?.target;
                },
                options: {
                    name: "BuildingDropDownList",
                    filter: "contains",
                    autoBind: false,
                    minLength: 2,
                    dataTextField: "Name",
                    height: 300,
                    dataValueField: "BuildingId",
                    valuePrimitive: true,
                    optionLabel: " -- School / Building",
                    optionLabelTemplate: `<em class="text-muted">-- School / Building</em>`,
                    noDataTemplate: `
<div>
    #if (instance.filterInput.val()) { #
    <p>
        No school or building matches. Add as new item "#: instance.filterInput.val() #"?
    </p>
    <button type="button"
            class="btn btn-success btn-sm"
            onclick="enroller.kendoui.widgets.addBuilding('#: instance.element[0].id #', '#: instance.filterInput.val() #')">
        <i class="fa fal-plus"></i>
        Add Building
    </button>
    #} else {#
    Search to find buildings...
    #}#
</div>`,
                    suggest: true,
                }
            });
            kendo.ui.plugin(BuildingDropDownList);
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
;
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            var CHANGE = "change", NAME = "FrEditor";
            var _froalaInit = false;
            var _froalaDefaults = function () {
                if (_froalaInit || window["FroalaEditor"] === undefined) {
                    return;
                }
                _froalaInit = true;
                FroalaEditor.DEFAULTS.key = 'Lc2C1qE1D2F4C3I3A11A9ifsA-9whtpqD-17mF4npdxC4B3A3C1B5A1E1E4I1A1==';
                $.extend(true, FroalaEditor.DEFAULTS, {
                    fileUploadURL: null,
                    imageUploadURL: null,
                    fileUploadParam: "files",
                    imageUploadParam: "files",
                    videoUploadParam: "files",
                    imageManagerLoadURL: null,
                    imageManagerDeleteMethod: "DELETE",
                    codeBeautifierOptions: {
                        end_with_newline: true,
                        indent_inner_html: true,
                        extra_liners: '["p", "h1", "h2", "h3", "h4", "h5", "h6", "blockquote", "pre", "ul", "ol", "table", "dl"]',
                        brace_style: "expand",
                        indent_char: " ",
                        indent_size: 2,
                        wrap_line_length: 0
                    },
                    codeMirrorOptions: {
                        tabMode: "indent",
                        tabSize: 2,
                        indentWithTabs: false,
                        mode: { name: "handlebars", base: "text/html" },
                        autoCloseTags: true,
                        foldGutter: true,
                        styleActiveLine: true,
                        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]
                    }
                });
                FroalaEditor.DEFAULTS.htmlAllowedTags.push("data");
                FroalaEditor.DEFAULTS.htmlDoNotWrapTags.push("data");
                FroalaEditor.DEFAULTS.htmlRemoveTags.push("main");
                FroalaEditor.DEFAULTS.imageStyles = {
                    "img-fluid": "Fluid",
                    "shadow": "Shadow",
                    "img-thumbnail": "Bordered",
                    "border-secondary": "Border - dark",
                    "float-start": "Float Left",
                    "float-end": "Float Right",
                    "maxwidth-600": "Max-width 600px)",
                    "maxwidth-400": "Max-width 400px)",
                    "maxwidth-300": "Max-width 300px)",
                };
                FroalaEditor.DEFAULTS.paragraphMultipleStyles = false;
                FroalaEditor.DEFAULTS.paragraphStyles = {
                    "line-height-1": "Line Height 1",
                    "line-height-1-25": "Line Height 1.25",
                    "line-height-1-5": "Line Height 1.5",
                    "line-height-2": "Line Height 2",
                    "alert alert-primary": "Alert - Primary",
                    "alert alert-success": "Alert - Success",
                    "alert alert-warning": "Alert - Warning",
                    "alert alert-info": "Alert - Info",
                    "alert alert-danger": "Alert - Danger",
                };
                FroalaEditor.DEFAULTS.requestWithCredentials = true;
                FroalaEditor.DEFAULTS.tableStyles = {
                    "table": "Basic",
                    "table table-bordered": "Bordered",
                    "table table-striped": "Striped",
                    "table table-sm": "Condensed",
                    "table table-hover": "Hover",
                };
                FroalaEditor.DEFAULTS.tableMultipleStyles = true;
                FroalaEditor.DEFAULTS.tableCellMultipleStyles = false;
                FroalaEditor.DEFAULTS.tableCellStyles = {
                    "active": "Active",
                    "success": "Success",
                    "info": "Info",
                    "warning": "Warning",
                    "danger": "Danger",
                };
                FroalaEditor.DEFAULTS.fontSize = ["12", "14", "16", "18", "24", "30"];
                FroalaEditor.DEFAULTS.linkInsertButtons = ["linkBack"];
                FroalaEditor.DEFAULTS.linkList = [];
                FroalaEditor.DEFAULTS.linkMultipleStyles = false;
                FroalaEditor.DEFAULTS.linkStyles = {
                    "enr-underline": "Underline",
                    "enr-underline-dotted": "Dotted Underline",
                };
                FroalaEditor.DEFAULTS.linkText = true;
                FroalaEditor.DEFAULTS.videoUpload = false;
                FroalaEditor.DEFAULTS.toolbarButtons = {
                    moreText: {
                        buttons: ["bold", "italic", "underline", "strikeThrough", "subscript", "superscript", "fontFamily", "fontSize", "textColor", "backgroundColor", "inlineClass", "inlineStyle", "clearFormatting"],
                        buttonsVisible: 3
                    },
                    moreParagraph: {
                        buttons: ["alignLeft", "alignCenter", "formatOLSimple", "alignRight", "alignJustify", "formatOL", "formatUL", "paragraphFormat", "paragraphStyle", "lineHeight", "outdent", "indent", "quote"],
                        buttonsVisible: 3
                    },
                    moreRich: {
                        buttons: ["insertLink", "insertImage", "insertTable", "insertFile", "insertVideo", "insertHR", "specialCharacters"],
                        buttonsVisible: 4
                    },
                    moreMisc: {
                        buttons: ["undo", "arrow-rotate-right", "html", "fullscreen", "print", "getPDF", "spellChecker", "selectAll", "help"],
                        align: "right",
                        buttonsVisible: 3
                    }
                };
                FroalaEditor.DEFAULTS.toolbarButtonsMD = $.extend(true, {}, FroalaEditor.DEFAULTS.toolbarButtons, {
                    moreText: { buttonsVisible: 3 },
                    moreParagraph: { buttonsVisible: 3 },
                    moreRich: { buttonsVisible: 3 },
                    moreMisc: { buttonsVisible: 2 },
                });
                FroalaEditor.DEFAULTS.toolbarButtonsSM = $.extend(true, {}, FroalaEditor.DEFAULTS.toolbarButtons, {
                    moreText: { buttonsVisible: 2 },
                    moreParagraph: { buttonsVisible: 2 },
                    moreRich: { buttonsVisible: 2 },
                    moreMisc: { buttonsVisible: 0 },
                });
                FroalaEditor.DEFAULTS.toolbarButtonsXS = $.extend(true, {}, FroalaEditor.DEFAULTS.toolbarButtons, {
                    moreText: { buttonsVisible: 2 },
                    moreParagraph: { buttonsVisible: 0 },
                    moreRich: { buttonsVisible: 0 },
                    moreMisc: { buttonsVisible: 0 },
                });
                FroalaEditor.DEFAULTS.toolbarStickyOffset = 50;
                let froala = {
                    toolbars: {
                        simple: {
                            xs: ["bold", "italic", "underline", "formatOL", "formatUL", "insertLink"],
                            sm: ["bold", "italic", "underline", "formatOL", "formatUL", "insertLink"],
                            md: ["bold", "italic", "underline", "formatOL", "formatUL", "insertLink", "|", "insertImage", "insertFile"],
                            lg: ["bold", "italic", "underline", "formatOL", "formatUL", "insertLink", "|", "insertImage", "insertFile"],
                        },
                        simpletext: {
                            xs: ["bold", "italic", "underline", "insertLink", "|", "html"],
                            sm: ["bold", "italic", "underline", "formatOL", "formatUL", "|", "insertLink", "|", "html"],
                            md: ["bold", "italic", "underline", "formatOL", "formatUL", "|", "insertLink", "|", "paragraphStyle", "paragraphFormat", "|", "html"],
                            lg: ["bold", "italic", "underline", "formatOL", "formatUL", "|", "insertLink", "|", "paragraphStyle", "paragraphFormat", "|", "html"],
                        },
                        full: {
                            xs: FroalaEditor.DEFAULTS.toolbarButtonsXS,
                            sm: FroalaEditor.DEFAULTS.toolbarButtonsSM,
                            md: FroalaEditor.DEFAULTS.toolbarButtonsMD,
                            lg: FroalaEditor.DEFAULTS.toolbarButtons
                        }
                    }
                };
                esd.froala = froala;
            };
            _froalaDefaults();
            class KendoFroalaEditor extends kendo.ui.Widget {
                constructor(element, options) {
                    options.config = options.config || {};
                    super(element, options);
                    this._initOptions = {};
                    this.wrapper = $(element);
                    _froalaDefaults();
                    this.options.config.imageManagerLoadURL = this.options.config.imageManagerLoadURL || this.options.config.imageUploadURL;
                    this.options.config.imageManagerDeleteURL = this.options.config.imageManagerDeleteURL || this.options.config.imageUploadURL;
                    this.options.config.imageUploadParams = {
                        _f: enroller.core.csrf
                    };
                    if (this.options.config.toolbarSticky !== false && !this.options.config.toolbarStickyOffset) {
                        this.options.config.toolbarStickyOffset = $("#Enroller-Header").outerHeight();
                    }
                    if (this.options.upload === false) {
                        this.options.config.fileUpload = false;
                        this.options.config.imageUpload = false;
                        this.options.config.videoUpload = false;
                    }
                    if (this.options.config.scrollableContainer == FroalaEditor.DEFAULTS.scrollableContainer) {
                        var parentModal = this.element.closest(".modal");
                        if (parentModal.length > 0) {
                            if (this.options.config.toolbarSticky === undefined || this.options.config.toolbarSticky == null) {
                                this.options.config.toolbarSticky = false;
                            }
                            this.options.config.scrollableContainer = parentModal[0].id
                                ? "#" + parentModal[0].id
                                : FroalaEditor.DEFAULTS.scrollableContainer;
                        }
                    }
                    let toolbar = esd.froala.toolbars[this.options.toolbar || "full"];
                    let customToolbar = this.options.customToolbar;
                    if (customToolbar) {
                        toolbar.lg = $.extend(true, {}, toolbar.lg, customToolbar);
                        toolbar.md = $.extend(true, {}, toolbar.md, customToolbar);
                        toolbar.sm = $.extend(true, {}, toolbar.sm, customToolbar);
                        toolbar.xs = $.extend(true, {}, toolbar.xs, customToolbar);
                    }
                    this.options.config = $.extend(true, {
                        toolbarButtons: toolbar.lg || null,
                        toolbarButtonsMD: toolbar.md || null,
                        toolbarButtonsSM: toolbar.sm || null,
                        toolbarButtonsXS: toolbar.xs || null
                    }, this.options.config, {
                        attribution: false
                    });
                    this.options.config.fontFamilyDefaultSelection = 'Font Family';
                    this.options.config.fontSizeDefaultSelection = 'Font Size';
                    let that = this;
                    this.options.config.events = {
                        initialized: function () {
                            that._editor = this;
                            if (that._initOptions.value) {
                                that._editor.html.set(that._initOptions.value);
                                that.element.val(that._initOptions.value);
                                that._initOptions.value = null;
                            }
                            that._enable();
                            that._bsTab(that.element);
                        },
                        contentChanged: this._frChange.bind(this),
                        blur: this._frBlur.bind(this),
                        'paste.afterCleanup': function (content) {
                            const cleaner = /(font-family:[^;]+;?)/gmi;
                            return content?.replace(cleaner, '');
                        }
                    };
                    this._editor = new FroalaEditor(element, this.options.config);
                }
                _bsTab(el) {
                    let tabId = el.parents(".tab-pane").attr("id");
                    if (tabId) {
                        $(`a[href=\"#${tabId}\"]`).on("shown.bs.tab", e => {
                            this._editor.size.refresh();
                            if (this._editor.opts.toolbarSticky) {
                                this._editor.position.refresh();
                            }
                        });
                    }
                }
                _frChange() {
                    this.trigger(CHANGE);
                }
                _frBlur(e, editor) {
                    if (this._editor.codeView.isActive()) {
                        this._editor.html.set(this._editor.codeView.get());
                    }
                    this.element.trigger("blur", e);
                }
                _enable() {
                    if (this._initOptions.enabled === true) {
                        return;
                    }
                    if (this._initOptions.enabled === false || this.element.is("[disabled]") === true || this.options?.enabled === false) {
                        this.enable(false);
                    }
                }
                value(value) {
                    if (this._editor.html == null) {
                        if (value != null) {
                            this._initOptions.value = value || "";
                        }
                        return;
                    }
                    if (value === undefined) {
                        return this._editor.html.get();
                    }
                    if (value !== null) {
                        value = value.trim();
                    }
                    this._editor.html.set(value || "");
                }
                setOptions(options) {
                    super.setOptions(options);
                    if (this._editor == null) {
                        return;
                    }
                    if (options.config !== undefined) {
                        let config = options.config;
                        for (var prop in config) {
                            if (config.hasOwnProperty(prop) && (prop.indexOf("file") === 0 || prop.indexOf("image") === 0)) {
                                this._editor.opts[prop] = config[prop];
                                if (prop == "imageUploadURL") {
                                    this._editor.opts["imageManagerLoadURL"] = config[prop];
                                    this._editor.opts["imageManagerDeleteURL"] = config[prop];
                                }
                            }
                        }
                    }
                }
                enable(enabled) {
                    this.readonly(!enabled);
                }
                readonly(readonly) {
                    if (this._editor.edit == null) {
                        this._initOptions.enabled = !readonly;
                        return;
                    }
                    if (readonly) {
                        this._editor.edit.off();
                    }
                    else {
                        this._editor.edit.on();
                    }
                }
                destroy() {
                    if (this._editor != null) {
                        this.unbind("change");
                        this.unbind("value");
                        this._editor = null;
                    }
                }
            }
            KendoFroalaEditor.defaultConfig = {
                charCounterCount: false,
                fileUploadURL: null,
                imageUploadURL: null,
                imageUploadParam: "files",
                imageManagerLoadURL: null,
                imageManagerDeleteURL: null,
                imageManagerDeleteMethod: "DELETE",
                pasteDeniedTags: ["script"],
                placeholderText: null,
                scrollableContainer: "body"
            };
            widgets.KendoFroalaEditor = KendoFroalaEditor;
            KendoFroalaEditor.fn = KendoFroalaEditor.prototype;
            KendoFroalaEditor.fn.options = $.extend(true, {}, {
                name: NAME,
                toolbar: null,
                customToolbar: null,
                upload: null,
                enabled: true,
                config: KendoFroalaEditor.defaultConfig
            });
            kendo.ui.plugin(KendoFroalaEditor);
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            var OrganizationComboBox = kendo.ui.DropDownList.extend({
                init: function (element, options) {
                    widgets.orgInit.call(this, element, options);
                    kendo.ui.ComboBox.fn.init.call(this, element, options);
                    this.bind("set", widgets.set);
                },
                options: {
                    name: "OrganizationComboBox",
                    filter: "contains",
                    autoBind: false,
                    minLength: 2,
                    dataTextField: "OfficialName",
                    dataValueField: "OrganizationId",
                    valuePrimitive: true,
                    noDataTemplate: widgets.noDataTemplate("organizations"),
                    includeSystem: false,
                    scope: null,
                    suggest: true,
                    template: '<span class="me-2">#: data.OfficialName #</span><small class="text-muted ms-auto">#: data.Esd || "" #</small>',
                    change: function (e) {
                        var widget = e.sender;
                        if (widget.value() && widget.select() === -1) {
                            widget.value("");
                        }
                    }
                }
            });
            kendo.ui.plugin(OrganizationComboBox);
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            var OrganizationDropDownList = kendo.ui.DropDownList.extend({
                init: function (element, options) {
                    widgets.orgInit.call(this, element, options);
                    kendo.ui.DropDownList.fn.init.call(this, element, options);
                    this.bind("set", widgets.set);
                },
                options: {
                    name: "OrganizationDropDownList",
                    filter: "contains",
                    autoBind: false,
                    minLength: 2,
                    dataTextField: "OfficialName",
                    dataValueField: "OrganizationId",
                    valuePrimitive: true,
                    noDataTemplate: widgets.noDataTemplate("organizations"),
                    includeSystem: false,
                    suggest: true,
                    scope: null,
                    valueTemplate: '<span class="me-2">#: data.OfficialName #</span><small class="text-muted ms-auto">#: data.Esd || "" #</small>',
                    template: '<span class="me-2">#: data.OfficialName #</span><small class="text-muted ms-auto">#: data.Esd || "" #</small>',
                }
            });
            kendo.ui.plugin(OrganizationDropDownList);
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var kendoui;
    (function (kendoui) {
        var widgets;
        (function (widgets) {
            class StateDropDownList extends kendo.ui.DropDownList {
                constructor(element, options) {
                    options = options ?? {};
                    let states = [];
                    for (let i = 0; i < StateDropDownList.states.length; i++) {
                        let group = StateDropDownList.states[i];
                        for (let j = 0; j < group.items.length; j++) {
                            states.push({
                                value: group.items[j].value,
                                text: group.items[j].text,
                                group: group.text
                            });
                        }
                    }
                    options = {
                        ...options,
                        ...{
                            dataTextField: "text",
                            dataValueField: "value",
                            valuePrimitive: true,
                            minLength: 1,
                            height: 300,
                            filter: "contains",
                            filtering: (e) => {
                                let value = e.filter?.value?.trim()?.toUpperCase();
                                if (value?.length == 2 && e.sender.dataSource.get(value)) {
                                    e.sender.select(i => i.value == value);
                                    e.preventDefault();
                                }
                            },
                            ignoreCase: true,
                            noDataTemplate: "No states found.",
                            dataSource: new kendo.data.DataSource({
                                data: states,
                                schema: {
                                    model: {
                                        id: "value"
                                    }
                                },
                                group: {
                                    field: "group", compare: (a, b) => a.items.length == b.items.length ? 0
                                        : a.items.length < b.items.length ? 1
                                            : -1
                                }
                            })
                        }
                    };
                    super(element, options);
                    ;
                }
            }
            StateDropDownList.states = [{
                    text: "United States",
                    items: [
                        { value: "AL", text: "Alabama" },
                        { value: "AK", text: "Alaska" },
                        { value: "AZ", text: "Arizona" },
                        { value: "AR", text: "Arkansas" },
                        { value: "CA", text: "California" },
                        { value: "CO", text: "Colorado" },
                        { value: "CT", text: "Connecticut" },
                        { value: "DC", text: "District Of Columbia" },
                        { value: "DE", text: "Delaware" },
                        { value: "FL", text: "Florida" },
                        { value: "GA", text: "Georgia" },
                        { value: "HI", text: "Hawaii" },
                        { value: "ID", text: "Idaho" },
                        { value: "IL", text: "Illinois" },
                        { value: "IN", text: "Indiana" },
                        { value: "IA", text: "Iowa" },
                        { value: "KS", text: "Kansas" },
                        { value: "KY", text: "Kentucky" },
                        { value: "LA", text: "Louisiana" },
                        { value: "ME", text: "Maine" },
                        { value: "MD", text: "Maryland" },
                        { value: "MA", text: "Massachusetts" },
                        { value: "MI", text: "Michigan" },
                        { value: "MN", text: "Minnesota" },
                        { value: "MS", text: "Mississippi" },
                        { value: "MO", text: "Missouri" },
                        { value: "MT", text: "Montana" },
                        { value: "NE", text: "Nebraska" },
                        { value: "NV", text: "Nevada" },
                        { value: "NH", text: "New Hampshire" },
                        { value: "NJ", text: "New Jersey" },
                        { value: "NM", text: "New Mexico" },
                        { value: "NY", text: "New York" },
                        { value: "NC", text: "North Carolina" },
                        { value: "ND", text: "North Dakota" },
                        { value: "OH", text: "Ohio" },
                        { value: "OK", text: "Oklahoma" },
                        { value: "OR", text: "Oregon" },
                        { value: "PA", text: "Pennsylvania" },
                        { value: "RI", text: "Rhode Island" },
                        { value: "SC", text: "South Carolina" },
                        { value: "SD", text: "South Dakota" },
                        { value: "TN", text: "Tennessee" },
                        { value: "TX", text: "Texas" },
                        { value: "UT", text: "Utah" },
                        { value: "VT", text: "Vermont" },
                        { value: "VA", text: "Virginia" },
                        { value: "WA", text: "Washington" },
                        { value: "WV", text: "West Virginia" },
                        { value: "WI", text: "Wisconsin" },
                        { value: "WY", text: "Wyoming" }
                    ]
                },
                {
                    text: "United States Territories",
                    items: [
                        { value: "AS", text: "American Samoa" },
                        { value: "FM", text: "Federated States of Micronesia" },
                        { value: "GU", text: "Guam" },
                        { value: "MH", text: "Marshall Islands" },
                        { value: "MP", text: "Northern Mariana Islands" },
                        { value: "PW", text: "Palau" },
                        { value: "PR", text: "Puerto Rico" },
                        { value: "VI", text: "Virgin Islands" },
                    ]
                },
                {
                    text: "Canada",
                    items: [
                        { value: "AB", text: "Alberta" },
                        { value: "BC", text: "British Columbia" },
                        { value: "MB", text: "Manitoba" },
                        { value: "NB", text: "New Brunswick" },
                        { value: "NL", text: "Newfoundland and Labrador" },
                        { value: "NT", text: "Northwest Territories" },
                        { value: "NS", text: "Nova Scotia" },
                        { value: "NU", text: "Nunavut" },
                        { value: "PE", text: "Prince Edward Island" },
                        { value: "SK", text: "Saskatchewan" },
                        { value: "ON", text: "Ontario" },
                        { value: "QC", text: "Quebec" },
                        { value: "YT", text: "Yukon" }
                    ]
                },
                {
                    text: "Other",
                    items: [
                        { value: "Africa", text: "Africa" },
                        { value: "Asia", text: "Asia" },
                        { value: "Europe", text: "Europe" },
                        { value: "N. America", text: "North America" },
                        { value: "S. America", text: "South America" },
                    ]
                }];
            widgets.StateDropDownList = StateDropDownList;
            StateDropDownList.fn = StateDropDownList.prototype;
            StateDropDownList.fn.options = $.extend(true, {}, kendo.ui.DropDownList.fn.options);
            StateDropDownList.fn.options.name = "StateDropDownList";
            kendo.ui.plugin(StateDropDownList);
        })(widgets = kendoui.widgets || (kendoui.widgets = {}));
    })(kendoui = enroller.kendoui || (enroller.kendoui = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var layout;
    (function (layout) {
        const DEFAULT_BREAKPOINT = 768;
        const BODY_CLASS_SHOW = "enr-offcanvas-show";
        const CLASS_SHOW = "open";
        class Offcanvas {
            get breakpoint() {
                return this._breakpoint;
            }
            constructor(toggle) {
                Offcanvas.canvases.push(this);
                let targetSelector = toggle.getAttribute("data-enr-target") || toggle.getAttribute("href");
                this._breakpoint = parseInt(toggle.getAttribute("data-enr-breakpoint")) || DEFAULT_BREAKPOINT;
                if (!targetSelector) {
                    console.warn("No offcanvas selector found in toggle.");
                    return;
                }
                toggle.addEventListener('click', enroller.util.debounce(this.toggle.bind(this), 250, true));
                this.target = document.querySelector(targetSelector);
                if (Offcanvas.length == 1) {
                    Offcanvas.body = document.querySelector("body");
                    Offcanvas.body.addEventListener("click", Offcanvas._hideAll);
                    Offcanvas.body.addEventListener("touchend", Offcanvas._hideAll);
                    window.onresize = () => {
                        if (window.innerWidth >= this.breakpoint) {
                            Offcanvas._hideAll();
                        }
                    };
                }
            }
            get isOpen() {
                return this.target.classList.contains(CLASS_SHOW);
            }
            open() {
                Offcanvas.body.classList.add(BODY_CLASS_SHOW);
                this.target.classList.add(CLASS_SHOW);
            }
            close() {
                this.target.classList.remove(CLASS_SHOW);
                if (Offcanvas.canvases.every(s => !s.isOpen)) {
                    Offcanvas.body.classList.remove(BODY_CLASS_SHOW);
                }
            }
            toggle(e) {
                e?.stopPropagation();
                if (this.isOpen) {
                    this.close();
                }
                else {
                    this.open();
                }
            }
            static _hideAll(e) {
                let target = e?.target?.tagName?.toLowerCase() || "body";
                if (target != "body"
                    || !Offcanvas.body.classList.contains(BODY_CLASS_SHOW)) {
                    return;
                }
                e?.preventDefault();
                e?.stopImmediatePropagation();
                Offcanvas.body.classList.remove(BODY_CLASS_SHOW);
                for (let i = 0; i < Offcanvas.canvases.length; i++) {
                    Offcanvas.canvases[i].close();
                }
            }
        }
        Offcanvas.canvases = [];
        layout.Offcanvas = Offcanvas;
        $(function () {
            let offcanvases = document.querySelectorAll('[data-enr-toggle="offcanvas"]');
            for (let i = 0; i < offcanvases.length; i++) {
                new Offcanvas(offcanvases[i]);
            }
        });
    })(layout = enroller.layout || (enroller.layout = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var notifications;
    (function (notifications) {
        class NotificationDetailsPage extends kendo.View {
            constructor(manager, routeBase) {
                super("NotificationsManager-Details", {
                    wrap: false,
                    init: (e) => {
                        enroller.core.notifications.onNotification(this._onNotification);
                        $("#NotificationsManager-Details-LogGrid").kendoGrid({
                            dataSource: this.logs,
                            columns: [
                                { field: "Date" },
                                { field: "Key" },
                                { field: "Message" },
                                {
                                    field: "Level",
                                    template: e => enroller.format.badge(e.Level, enroller.enums.notificationLevels)
                                }
                            ],
                            autoBind: false,
                            filterable: true,
                            sortable: true,
                            pageable: {
                                alwaysVisible: true,
                                refresh: true
                            }
                        });
                    },
                    show: (e) => {
                        this.logs.query({
                            page: 1,
                            pageSize: 20,
                            sort: { field: "Date", dir: "desc" },
                            filter: {
                                field: "NotificationId",
                                operator: "eq",
                                value: this.model.get("notificationId")
                            }
                        });
                    },
                    hide: (e) => {
                        enroller.core.notifications.off(this._onNotification);
                    }
                });
                this.manager = manager;
                this.model = kendo.observable({
                    notificationId: null,
                    notification: {},
                });
                this._onNotification = (notification, log) => {
                    if (typeof notification == "number") {
                        notification = { Id: notification };
                    }
                    if (this.model.get("notificationId") != notification.Id) {
                        return;
                    }
                    let mergedNotification = $.extend(this.model.get("notification").toJSON(), notification);
                    this.model.set("notification", mergedNotification);
                    if (log) {
                        this.logs.add(log);
                    }
                };
                this.logs = enroller.util.getDataSource({
                    url: enroller.core.urls.api("notifications/logs"),
                    model: {
                        id: "NotificationLogId",
                        fields: {
                            NotificationLogId: { type: "number" },
                            Date: { type: "date" },
                        }
                    },
                    options: {
                        serverFiltering: true,
                        serverPaging: true,
                        serverSorting: true,
                        pageSize: 15,
                    }
                });
                manager.router.route(`${routeBase || ""}/:notificationId`, (notificationId) => {
                    this.model.set("notificationId", notificationId);
                    this.manager.show(this.manager.views.loading);
                    enroller.core.http.get(enroller.core.urls.api("notifications", notificationId))
                        .then(async (r) => {
                        if (r.status == 200) {
                            let notification = await r.json();
                            this.model.set("notification", notification);
                            this.manager.show(this);
                        }
                        else if (r.status == 404) {
                            this.manager.show(this.manager.views.error.set(404, "Not found."));
                        }
                        else {
                            this.manager.show(this.manager.views.error.set(r.status, r.statusText || ''));
                        }
                    });
                });
            }
        }
        notifications.NotificationDetailsPage = NotificationDetailsPage;
    })(notifications = enroller.notifications || (enroller.notifications = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var notifications;
    (function (notifications) {
        class NotificationsIndexPage extends kendo.View {
            constructor(manager) {
                super("NotificationsManager-Index", {
                    init: (e) => { },
                    show: (e) => { },
                });
                this.manager = manager;
                this.source = enroller.util.getDataSource({
                    model: notifications.Notification,
                    url: enroller.core.urls.api("notifications"),
                    transports: ["update", "destroy"],
                    options: {
                        pageSize: 5,
                        serverFiltering: true,
                        serverPaging: true,
                        serverSorting: true,
                        serverAggregates: true,
                        filter: [
                            { field: "Status", operator: "neq", value: 2 }
                        ],
                        sort: [
                            { field: "Date", dir: "desc" }
                        ],
                        requestStart: (e) => {
                            if (e.type == "read") {
                                kendo.ui.progress(this.element, true);
                            }
                        },
                        requestEnd: (e) => {
                            if (e.type == "read") {
                                kendo.ui.progress(this.element, false);
                            }
                        }
                    }
                });
                this.model = kendo.observable({
                    notifications: this.source,
                    read: (e) => {
                    },
                    dismissAll: (e) => {
                        this.dismiss("all");
                    },
                    dismissTopic: (e) => {
                        let topic = e.data?.Topic;
                        if (!topic) {
                            return;
                        }
                        this.dismiss(`topic/${topic}`);
                    },
                    dismiss: (e) => {
                        let fx = kendo.fx($("#Notification-" + e.data.id)), slide = fx.expandVertical();
                        slide.duration(550)
                            .reverse()
                            .always(() => {
                            this.source.remove(e.data);
                            this.source.sync()
                                .done(() => {
                                this.source.read().done(() => {
                                    enroller.core.notifications?.update();
                                });
                            });
                        });
                    }
                });
                manager.router.route("", this.route.bind(this));
                manager.router.route("/", this.route.bind(this));
            }
            route() {
                this.manager.show(this);
            }
            dismiss(type) {
                kendo.ui.progress(this.element, true);
                $.ajax({
                    url: enroller.core.urls.api("notifications", type),
                    method: "DELETE"
                })
                    .done(() => {
                    this.source.read();
                    enroller.core.notifications?.update();
                })
                    .always(() => {
                    kendo.ui.progress(this.element, false);
                });
            }
        }
        notifications.NotificationsIndexPage = NotificationsIndexPage;
    })(notifications = enroller.notifications || (enroller.notifications = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var notifications;
    (function (notifications) {
        class NotificationManager extends enroller.PageSpa {
            constructor(options) {
                super({
                    layoutElement: "#NotificationsManager",
                    resetHash: false,
                    routerOptions: {
                        pushState: true,
                        root: options.root,
                        routeMissing: (e) => {
                            this.show(this.views.error.set(404, "Not found."));
                        }
                    }
                });
                new notifications.NotificationsIndexPage(this);
                new notifications.NotificationDetailsPage(this);
                this.views = NotificationManager.defaultViews();
            }
            static defaultViews() {
                return {
                    error: new ErrorView(),
                    loading: new kendo.View("#NotificationsManager-Loading", {
                        wrap: false,
                        model: kendo.observable({ item: {} }),
                        show: (e) => {
                            kendo.ui.progress(e.sender.element, true);
                        }
                    })
                };
            }
        }
        notifications.NotificationManager = NotificationManager;
        class ErrorView extends kendo.View {
            constructor() {
                super("#NotificationsManager-Error", {
                    wrap: false
                });
                this.model = kendo.observable({
                    code: 404,
                    message: "Not found."
                });
            }
            set(code, message) {
                this.model.set("code", code);
                this.model.set("message", message);
                return this;
            }
        }
        notifications.ErrorView = ErrorView;
    })(notifications = enroller.notifications || (enroller.notifications = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var search;
    (function (search) {
        class SearchBase {
            get queryParams() {
                return this._queryParams;
            }
            get facetQueryParams() {
                return this._facetQueryParams;
            }
            get defaultQueryParams() {
                return {};
            }
            ;
            constructor(options) {
                this._queryParams = [];
                this._facetQueryParams = {};
                this.options = {
                    ...{
                        pageSize: 15
                    },
                    ...options
                };
                this.filters = {};
                this._queryParams = [...new Set([
                        ...["q", "page", "pagesize", "sort", "filter"],
                        ...(options.queryParams || [])
                    ])];
                this._facetQueryParams = options.facetQueryParams || {};
                this.source = this.initDataSource();
                this.facetModel = this.initFacetModel();
                this.init();
                this.initRoutes();
            }
            init(model) {
                this.router = this.options?.router || enroller.router.init({
                    pushState: true,
                    root: this.options.root
                });
                this.model = kendo.observable($.extend(true, {
                    parameters: {
                        ...this.options.defaultParams,
                        ...enroller.util.deparam({ allowedKeys: this.queryParams }),
                    },
                    results: this.source,
                    isLoaded: false,
                    search: this.onSearch.bind(this),
                    clear: (e) => {
                        if (e.type == "input" && e.target.value == "") {
                            this.model.set("parameters.q", null);
                            this.router.navigate(this.getRoute({ page: 1 }));
                        }
                    }
                }, model));
            }
            load(params) {
                params = params || { page: 1 };
                let page = parseInt(params.page);
                params.page = isNaN(page) ? 1 : page;
                if (this.options.loadingContainer) {
                    kendo.ui.progress($(this.options.loadingContainer), true);
                }
                return this.source.query(params)
                    .done(() => {
                    this.model.set("isLoaded", true);
                })
                    .always(() => {
                    if (this.options.loadingContainer) {
                        kendo.ui.progress($(this.options.loadingContainer), false);
                    }
                });
            }
            getRoute(params) {
                return `/${this.options.route || ''}?${$.param(this.cleanQueryParams(params))}`;
            }
            onSearch(e) {
                e.preventDefault();
                this.router.navigate(this.getRoute({ page: 1 }));
            }
            search(query) {
                this.model.set("parameters.q", query);
                this.router.navigate(this.getRoute({ page: 1 }));
            }
            initRoutes() {
                this.router.route(`${this.options.route || ''}`, (params) => {
                    this.onRoute(params);
                });
                this.router.route(`/${this.options.route || ''}`, (params) => {
                    this.onRoute(params);
                });
            }
            onRoute(params) {
                this.load({ ...{ page: 1, pageSize: this.options.pageSize }, ...params });
            }
            cleanQueryParams(params) {
                let cleaned = {};
                let modelParams = this.model.get("parameters").toJSON();
                let p = { ...modelParams, ...params };
                for (var key in p) {
                    if (p.hasOwnProperty(key) && this.queryParams.indexOf(key.toLowerCase()) > -1 && p[key] != null && p[key] != this.defaultQueryParams[key]) {
                        cleaned[key] = p[key];
                    }
                }
                return cleaned;
            }
            cleanFilterFields(filter) {
                if (filter) {
                    if (filter.filters && filter.logic) {
                        let cleaned = [];
                        for (let i = 0; i < filter.filters.length; i++) {
                            if (filter.filters[i].field) {
                                cleaned.push(this.cleanFilterFields(filter.filters[i]));
                            }
                        }
                        filter.filters = cleaned;
                    }
                    else {
                        filter.field = filter?.field?.replace(/\//g, '.');
                    }
                }
                return filter;
            }
            initFacetModel() {
                let that = this;
                return kendo.data.Model.define({
                    fields: {
                        field: { type: "string" },
                        value: { type: "string" },
                        _name: { type: "string" }
                    },
                    hasName: function () {
                        return !!this._name || (that.options.tags?.[this.field]
                            ? that.options.tags[this.field][this.value.toString()] != undefined
                            : false);
                    },
                    name: function () {
                        return this._name || (that.options.tags?.[this.field]
                            ? that.options.tags[this.field][this.value.toString()]
                            : this.value);
                    },
                    filter: function (e) {
                        const collection = this.parent();
                        for (let i = 0; i < collection.length; i++) {
                            if (collection[i].get("value") != this.get("value")) {
                                collection[i].set("_checked", false);
                            }
                        }
                        const value = e.delegateTarget.value;
                        const name = e.delegateTarget.name;
                        const query = { page: 1 };
                        if (!that.filters[name] || that.filters[name].value != value) {
                            that.filters[name] = { field: name, operator: "eq", value: value };
                        }
                        else {
                            this.set("_checked", false);
                            delete that.filters[name];
                        }
                        if (that.facetQueryParams[name]) {
                            let queryParamName = that.facetQueryParams[name];
                            if (that.filters[name]) {
                                query[queryParamName] = value;
                                that.model.set(`parameters.${queryParamName}`, value);
                            }
                            else {
                                that.model.set(`parameters.${queryParamName}`, null);
                            }
                        }
                        that.router.navigate(that.getRoute(query), true);
                        that.load({ ...query, ...{ page: 1, pageSize: that.options.pageSize } });
                    },
                    showCount: function () {
                        return this.get("count") !== null && !this.isChecked();
                    },
                    _checked: false,
                    isChecked: function () {
                        let checked = false;
                        if (that._facetQueryParams[this.field]) {
                            checked = that.model.get(`parameters.${that._facetQueryParams[this.field]}`) == this.value;
                        }
                        else {
                            checked = (that.filters[this.field] != null && that.filters[this.field].value == this.value)
                                || (that.options.tag && that.options.tag[this.field] == this.value.toString());
                        }
                        this.set("_checked", checked);
                        return checked;
                    },
                    canDeselect: function () {
                        return that.options.tag && that.options.tag[this.field] != this.value
                            && this.get("_checked");
                    },
                    isPageTag: function () {
                        return that.options.tag && that.options.tag[this.field] == this.value;
                    }
                });
            }
        }
        search.SearchBase = SearchBase;
    })(search = enroller.search || (enroller.search = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var events;
    (function (events) {
        class EventSearchBase extends enroller.search.SearchBase {
            get defaultQueryParams() {
                return { online: false };
            }
            ;
            constructor(options) {
                super({
                    ...{ tag: {} },
                    ...options,
                    ...{
                        queryParams: [
                            ...options.queryParams || [],
                            ...["q", "page", "pagesize", "sort", "month", "filter", "range", "tagid", "online", "credit", "g", "matchterms"]
                        ],
                        facetQueryParams: {
                            ...(options.facetQueryParams || {}),
                            ...{
                                "Credits/CreditTypeId": "credit",
                                "Tags/Security/TagId": "g"
                            }
                        }
                    }
                });
                this._tags = {};
                this.router.start();
            }
            ;
            init(model) {
                super.init({
                    ...model, ...{
                        allFacets: {},
                        facets: function (key) {
                            let f = this.get("allFacets")[key];
                            return f && f.length > 0 ? f : null;
                        },
                        tags: (key) => {
                            let optTags = this.options.tags[key];
                            this._tags || (this._tags = {});
                            if (optTags && !this._tags[key]) {
                                let tags = [];
                                for (const i in optTags) {
                                    if (optTags.hasOwnProperty(i)) {
                                        tags.push(new this.facetModel({ field: key, value: i, _name: optTags[i], count: null }));
                                    }
                                }
                                this._tags[key] = new kendo.data.ObservableArray(tags);
                            }
                            return this._tags[key];
                        },
                    }
                });
            }
            ;
            initDataSource(options) {
                let defaultSourceOptions = {
                    type: "webapi",
                    schema: {
                        model: {
                            id: "EventId",
                        },
                        data: "Data",
                        total: "Total"
                    },
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                    serverGrouping: false,
                    serverAggregates: false,
                    page: 1,
                    pageSize: 15,
                    transport: { read: { data: this.data.bind(this) } },
                    requestEnd: this.setFacets.bind(this),
                };
                let source = new kendo.data.DataSource($.extend(true, {}, defaultSourceOptions, options));
                return source;
            }
            getRangeFilters(obj) {
                let now = new Date();
                now.setUTCHours(0, 0, 0, 0);
                let tomorrow = new Date();
                tomorrow.setUTCHours(0, 0, 0, 0);
                tomorrow.setDate(tomorrow.getDate() + 1);
                let filters = {};
                if (obj.range == "upcoming") {
                    filters["Start"] = { field: "Start", operator: "gte", value: now.toISOString() };
                }
                else if (obj.range == "ongoing") {
                    filters["Start"] = { field: "Start", operator: "lte", value: now.toISOString() };
                    filters["End"] = { field: "End", operator: "gte", value: tomorrow.toISOString() };
                }
                else if (obj.range == "past") {
                    filters["End"] = { field: "End", operator: "lt", value: tomorrow.toISOString() };
                }
                return filters;
            }
            data(data) {
                let obj = this.model.get("parameters").toJSON();
                delete this.filters["Start"];
                delete this.filters["End"];
                delete this.filters["Expires"];
                delete this.filters["OnlineOnly"];
                if (!!obj.online) {
                    this.filters["OnlineOnly"] = { field: "OnlineOnly", operator: "eq", value: true };
                }
                else {
                    delete obj.online;
                }
                for (let facet in this.facetQueryParams) {
                    if (!!obj[this.facetQueryParams[facet]]) {
                        this.filters[facet] = { field: facet, operator: "eq", value: obj[this.facetQueryParams[facet]] };
                    }
                    else {
                        delete obj[this.facetQueryParams[facet]];
                    }
                }
                let rangeFilters = this.getRangeFilters(obj);
                if (rangeFilters) {
                    for (let field in rangeFilters) {
                        this.filters[field] = rangeFilters[field];
                    }
                }
                delete obj.range;
                let f = { logic: "and", filters: [] };
                let foundPageTag = false;
                for (let field in this.filters) {
                    if (this.filters.hasOwnProperty(field) && this.filters[field] != null) {
                        if (this.options.tag[field]) {
                            foundPageTag = true;
                            f.filters.push({ logic: "and", filters: [this.filters[field], { field: field, operfator: "eq", value: this.options.tag[field] }] });
                        }
                        else {
                            f.filters.push(this.filters[field]);
                        }
                    }
                }
                if (!foundPageTag) {
                    for (let key in this.options.tag) {
                        if (this.options.tag.hasOwnProperty(key)) {
                            f.filters.push({ field: key, operator: "eq", value: this.options.tag[key] });
                        }
                    }
                }
                if (this.options.filters?.length) {
                    for (let i = 0; i < this.options.filters.length; i++) {
                        f.filters.push(this.options.filters[i]);
                    }
                }
                for (let key in data) {
                    let lowerKey = key.toLowerCase();
                    if (data.hasOwnProperty(key) && data[key] !== null && this.queryParams.indexOf(lowerKey) > -1) {
                        obj[lowerKey] = data[key];
                    }
                }
                if (obj.page !== undefined) {
                    obj.page |= 0;
                    obj.pageSize = this.options.pageSize || 15;
                }
                obj.filter = this.cleanFilterFields(f);
                return obj;
            }
            async setFacets(e, facets) {
                if (e.type == "read") {
                    let promises = [];
                    for (var f in e.response.Facets) {
                        if (f == "Organization/OrganizationId") {
                            promises.push(new Promise(async (resolve) => {
                                let orgs = await enroller.cache.organizations();
                                let facets = {};
                                facets[f] = [];
                                for (let i = 0; i < e.response.Facets[f].length; i++) {
                                    let facet = e.response.Facets[f][i];
                                    facet.field = f;
                                    facet._name = orgs?.find(o => o.OrganizationId == facet.value)?.ShortName;
                                    facets[f].push(new this.facetModel(facet));
                                }
                                resolve(facets);
                            }));
                        }
                        else {
                            promises.push(new Promise(resolve => {
                                let facets = {};
                                facets[f] = [];
                                if (this.options.tag[f]) {
                                    facets[f].push(new this.facetModel({ field: f, value: this.options.tag[f], count: 0, _checked: true }));
                                }
                                for (let i = 0; i < e.response.Facets[f].length; i++) {
                                    let facet = e.response.Facets[f][i];
                                    if (this.options.tag[f] != facet.value) {
                                        facet.field = f;
                                        facets[f].push(new this.facetModel(facet));
                                    }
                                }
                                resolve(facets);
                            }));
                        }
                    }
                    await Promise.all(promises)
                        .then(r => {
                        let facets = Object.assign({}, ...r);
                        this.model.set("allFacets", facets);
                    });
                }
            }
        }
        events.EventSearchBase = EventSearchBase;
    })(events = enroller.events || (enroller.events = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var catalog;
    (function (catalog) {
        class Catalog extends enroller.events.EventSearchBase {
            constructor(options) {
                super(options);
            }
            onSearch(e) {
                if (this.model.get("org.slug") == enroller.core.urls.org) {
                    super.onSearch(e);
                }
            }
            getRangeFilters(obj) {
                if (obj.range == "ongoing") {
                    let tomorrow = new Date();
                    tomorrow.setUTCHours(0, 0, 0, 0);
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    return {
                        Expires: { field: "CatalogSettings/Expires", operator: "gte", value: tomorrow.toISOString() }
                    };
                }
                return super.getRangeFilters(obj);
            }
        }
        catalog.Catalog = Catalog;
    })(catalog = enroller.catalog || (enroller.catalog = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var catalog;
    (function (catalog) {
        class CatalogCalendar extends catalog.Catalog {
            constructor(options) {
                super({
                    ...{ loadingContainer: "#Catalog .enr-cal-weeks" },
                    ...options,
                });
            }
            init() {
                super.init(Object.assign({
                    currentMonth: null,
                    go: (e) => {
                        e.preventDefault();
                        this.router.navigate($(e.delegateTarget).attr("href"));
                    },
                    todayUrl: () => `?${$.param(this.cleanQueryParams())}`,
                    prevMonth: () => {
                        let current = this.model.get("currentMonth") || new Date();
                        return new Date(current.getFullYear(), current.getMonth() - 1, 1);
                    },
                    prevMonthUrl: () => `${kendo.toString(this.model.prevMonth(), "yyyy-MM")}?${$.param(this.cleanQueryParams())}`,
                    nextMonth: () => {
                        let current = this.model.get("currentMonth") || new Date();
                        return new Date(current.getFullYear(), current.getMonth() + 1, 1);
                    },
                    nextMonthUrl: () => `${kendo.toString(this.model.nextMonth(), "yyyy-MM")}?${$.param(this.cleanQueryParams())}`,
                    weeks: []
                }, catalog.getOrgSelectModel("calendar", this.getRoute.bind(this))));
                this.router.route("/:date", (date, params) => {
                    var dateParts = date.split("-");
                    if (dateParts.length < 2) {
                        this.router.navigate("/");
                    }
                    let fullDate = kendo.parseDate(`${dateParts[0]}-${dateParts[1]}-01`);
                    if (fullDate == null) {
                        this.router.navigate("/");
                    }
                    this.model.set("currentMonth", fullDate);
                    this.load()
                        .done(() => {
                        this.render();
                    });
                });
                kendo.bind($('#Catalog'), this.model);
            }
            getRoute(params) {
                return `/${this.formatCurrentMonth()}?${$.param(this.cleanQueryParams(params))}`;
            }
            initRoutes() {
                this.router.route("/", (params) => {
                    this.model.set("currentMonth", new Date());
                    this.load()
                        .done(() => {
                        this.render();
                    });
                });
            }
            initDataSource(options) {
                return super.initDataSource({
                    transport: { read: { url: enroller.core.urls.orgApi("events/catalog/calendar") } },
                    schema: { model: CatalogCalendarEvent },
                });
            }
            formatCurrentMonth() {
                let currentMonth = this.model.get("currentMonth");
                return currentMonth
                    ? kendo.toString(currentMonth, "yyyy-MM")
                    : "";
            }
            data(data) {
                data = super.data(data);
                let date = this.model.get("currentMonth") || new Date();
                data.month = kendo.toString(date, "yyyy-MM");
                return data;
            }
            render() {
                let evts = {};
                let data = this.source.data();
                for (let i = 0; i < data.length; i++) {
                    let evt = data[i];
                    for (let d = 0; d < evt.Dates.length; d++) {
                        let evtDateFormatted = kendo.toString(evt.Dates[d], "yyyy-MM-dd");
                        if (evts[evtDateFormatted] == undefined) {
                            evts[evtDateFormatted] = [];
                        }
                        if (evts[evtDateFormatted].some(e => e.EventId == evt.EventId) == false) {
                            evts[evtDateFormatted].push(evt);
                        }
                    }
                }
                this.model.set("weeks", this.getDays(this.model.get("currentMonth"), evts));
            }
            getDays(date, evts) {
                let startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
                let endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                let weeks = [];
                let totalDays = 0;
                let addDays = (start, end) => {
                    for (let i = start; i < end; i++) {
                        let weekIndex = Math.floor(totalDays / 7);
                        let dayDate = new Date(date.getFullYear(), date.getMonth(), i);
                        let dayEvts = evts[kendo.toString(dayDate, "yyyy-MM-dd")];
                        weeks[weekIndex] = weeks[weekIndex] || [];
                        weeks[weekIndex].push(new CatalogCalendarDay(dayDate, startOfMonth, dayEvts));
                        totalDays++;
                    }
                };
                addDays((startOfMonth.getDay() - 1) * -1, 1);
                addDays(1, endOfMonth.getDate());
                addDays(endOfMonth.getDate(), endOfMonth.getDate() + 7 - endOfMonth.getDay());
                return weeks;
            }
        }
        CatalogCalendar.eventCount = 3;
        catalog.CatalogCalendar = CatalogCalendar;
        class CatalogCalendarEvent extends kendo.data.Model {
            constructor(data) {
                super(data);
                this.idField = "EventId";
                let dates = [];
                for (let i = 0; i < data.Dates.length; i++) {
                    dates.push(kendo.parseDate(data.Dates[i]));
                }
                data.Dates = dates;
                this.init(data);
            }
            session(day) {
                let date = `${day.getFullYear()}-${day.getMonth()}-${day.getDate()}`;
                return this.Dates.find(d => date == `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`);
            }
        }
        catalog.CatalogCalendarEvent = CatalogCalendarEvent;
        class CatalogCalendarDay {
            constructor(date, currentMonth, events) {
                this.date = date;
                this.currentMonth = currentMonth;
                this.events = (events || []).sort((a, b) => {
                    let ad = a.session(this.date);
                    let bd = b.session(this.date);
                    return ad > bd ? 1
                        : ad == bd ? 0
                            : -1;
                });
            }
            format(format) {
                if (format) {
                    return kendo.toString(this.date, format);
                }
                if (this.date.getDate() == 1) {
                    return kendo.toString(this.date, "MMM d");
                }
                return this.date.getDate();
            }
            isOther() {
                return this.date.getFullYear() !== this.currentMonth.getFullYear()
                    || this.date.getMonth() !== this.currentMonth.getMonth();
            }
            isToday() {
                let now = new Date();
                return this.date.getFullYear() === now.getFullYear()
                    && this.date.getMonth() === now.getMonth()
                    && this.date.getDate() === now.getDate();
            }
            isEmpty() {
                return !this.events || this.events.length == 0;
            }
        }
        catalog.CatalogCalendarDay = CatalogCalendarDay;
    })(catalog = enroller.catalog || (enroller.catalog = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var catalog;
    (function (catalog) {
        class CatalogList extends catalog.Catalog {
            constructor(options) {
                super({
                    ...{ loadingContainer: "#Catalog .enr-cat" },
                    ...options,
                });
            }
            init() {
                super.init(Object.assign({
                    page: (e) => {
                        this.router.navigate(this.getRoute({ page: e.index }));
                    }
                }, catalog.getOrgSelectModel(null, this.getRoute.bind(this))));
                kendo.bind($('#Catalog'), this.model);
            }
            initDataSource(options) {
                return super.initDataSource({
                    transport: { read: { url: enroller.core.urls.orgApi("events/catalog/list") } },
                    schema: {
                        model: kendo.data.Model.define({
                            id: "EventId",
                            fields: {
                                EventId: {},
                                Start: { type: "date" },
                                End: { type: "date" },
                                Registration: { type: "object" },
                            },
                            statusBadge: function () {
                                let status = this.get("Status");
                                if (status == "Cancelled") {
                                    return '<span class="badge bg-secondary">Cancelled</span>';
                                }
                                let registration = this.get("Registration");
                                let now = new Date();
                                registration.Start = kendo.parseDate(registration.Start);
                                registration.End = kendo.parseDate(registration.End);
                                if (!registration.Enabled) {
                                    return '<span class="badge bg-info">Info</span>';
                                }
                                if (registration.Start && registration.Start > now) {
                                    return `<span class="badge bg-light">Opens ${kendo.toString(registration.Start, "M/d")}</span>`;
                                }
                                if (registration.End && registration.End < now) {
                                    return '<span class="badge bg-light">Closed</span>';
                                }
                                let registered = this.get("SpacesPublicRegistered");
                                let max = registration.MaxCapacity || Number.MAX_SAFE_INTEGER;
                                let available = max - registered;
                                let url = enroller.core.urls.orgUrl("catalog/event", this.EventId);
                                if (available <= 0) {
                                    return `<a href="${url}" class="badge bg-danger">Wait List <span class="visually-hidden">for Event ${this.EventId}</span></a>`;
                                }
                                else if (available < enroller.util.clamp(max * 0.15, 5, 15)) {
                                    return `<a href="${url}" class="badge bg-warning">${available} Seats Left <span class="visually-hidden">for Event ${this.EventId}</span></a>`;
                                }
                                return `<a href="${url}" class="badge bg-success">Register <span class="visually-hidden">for Event ${this.EventId}</span></a>`;
                            }
                        })
                    },
                    page: 1,
                    pageSize: this.options.pageSize || 15
                });
            }
        }
        catalog.CatalogList = CatalogList;
    })(catalog = enroller.catalog || (enroller.catalog = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var catalog;
    (function (catalog) {
        catalog.getOrgSelectModel = function (action, actionParams) {
            return {
                org: {
                    slug: enroller.core.urls.org,
                    name: null,
                    select: function (e) {
                        this.set("org.slug", e.delegateTarget.value);
                        this.set("org.name", e.delegateTarget.innerText?.trim());
                    },
                    action: function () {
                        let params = actionParams ? actionParams({ page: 1 }) : null;
                        return enroller.core.urls.join(this.get("slug"), "catalog", action, params);
                    }
                }
            };
        };
        function home() {
            let model = kendo.observable(catalog.getOrgSelectModel());
            kendo.bind($("#Catalog-MainSearch"), model);
        }
        catalog.home = home;
        function list(options) {
            new catalog.CatalogList(options);
        }
        catalog.list = list;
        function calendar(options) {
            new catalog.CatalogCalendar(options);
        }
        catalog.calendar = calendar;
    })(catalog = enroller.catalog || (enroller.catalog = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var events;
    (function (events) {
        function announcements(config) {
            config.containers.editor.on('hidden.bs.modal', function (e) {
                announcements.cancelChanges();
                validator.hideMessages();
            });
            var Announcement = kendo.data.Model.define({
                id: 'AnnouncementId',
                fields: {
                    AnnouncementId: { editable: false },
                    Title: {},
                    Body: {},
                    Created: { editable: false, type: 'date' },
                    User: { editable: false, type: 'string' },
                    IsUrgent: { type: 'boolean' },
                    Published: { editable: false, type: 'date' },
                    IsPublic: { type: 'boolean' },
                },
            });
            var announcements = new kendo.data.DataSource({
                schema: {
                    model: Announcement
                },
                transport: {
                    read: function (options) {
                        options.success(config.announcements);
                    },
                    create: function (options) {
                        $.ajax(config.url, {
                            type: 'POST',
                            contentType: 'application/json',
                            data: kendo.stringify(options.data)
                        })
                            .done(options.success)
                            .fail(options.error);
                    },
                    update: function (options) {
                        $.ajax(config.url + '/' + options.data.AnnouncementId, {
                            type: 'PUT',
                            contentType: 'application/json',
                            data: kendo.stringify(options.data)
                        })
                            .done(options.success)
                            .fail(options.error);
                    },
                    destroy: function (options) {
                        $.ajax(config.url + '/' + options.data.AnnouncementId, {
                            type: 'DELETE'
                        })
                            .done(options.success)
                            .fail(options.error);
                    }
                },
                sync: function () {
                    config.containers.editor.modal('hide');
                },
                sort: { field: "Created", dir: "desc" }
            });
            var validator = config.containers.editor.kendoValidator().data('kendoValidator');
            var model = kendo.observable({
                announcements: announcements,
                announcement: null,
                editorTitle: function () {
                    var announcement = this.get('announcement');
                    return announcement == null || announcement.isNew()
                        ? 'Create'
                        : 'Edit';
                },
                create: function () {
                    this.set('announcement', new Announcement());
                    config.containers.editor.modal('show');
                },
                edit: function (e) {
                    e.preventDefault();
                    config.containers.editor.modal('show');
                    this.set('announcement', e.data);
                },
                save: function (e) {
                    if (validator.validate()) {
                        var announcement = this.get('announcement');
                        if (announcement.isNew()) {
                            announcements.add(announcement);
                        }
                        announcements.sync();
                    }
                },
                remove: function (e) {
                    var message = "Are you sure you wish to delete '" + e.data.Title + "'?";
                    if (confirm(message)) {
                        announcements.remove(e.data);
                        announcements.sync();
                    }
                }
            });
            kendo.bind(config.containers.manager, model);
        }
        events.announcements = announcements;
    })(events = enroller.events || (enroller.events = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        var sessions;
        (function (sessions) {
            function listenSessionCapacity(eventId, handler) {
                let signalr = enroller.signalr.connect();
                signalr.start()
                    .then(() => {
                    signalr.joinEventGroup(eventId, "sessioncounts")
                        .then(r => {
                    });
                })
                    .catch(enroller.signalr.error);
                signalr.on(m => m.eventsSessionCapacity, handler);
                return signalr;
            }
            sessions.listenSessionCapacity = listenSessionCapacity;
            class SpaceSessionRegistration {
                constructor(eventId, options, getSpace) {
                    this.options = options;
                    let that = this;
                    listenSessionCapacity(eventId, (counts) => {
                        this.updateCounts(counts, this.root);
                    });
                    this.sessionSpaceModel = kendo.data.Model.define({
                        id: "_Id",
                        fields: {
                            _Id: { type: "string" },
                            SessionId: { type: "number" },
                            SpaceId: { type: "number" },
                            Status: { type: "string" }
                        },
                        isActive: function () {
                            return this.get("Status") == "Active"
                                || this.get("Status") == "PendingActive";
                        },
                        isPending: function () {
                            return this.get("Status") == "PendingActive"
                                || this.get("Status") == "PendingRemoved";
                        }
                    });
                    this.sessionsDataSourceOptions = {
                        schema: {
                            data: "Sessions",
                            model: {
                                id: "_Id",
                                fields: {
                                    _checked: { type: "boolean", defaultValue: false },
                                    _enabled: { type: "boolean", defaultValue: true },
                                    Start: { type: "date" },
                                    End: { type: "date" },
                                    Total: { type: "number", defaultValue: 0 },
                                    Properties: { type: "object", defaultValue: {} },
                                },
                                checkState: function () {
                                    let sessionSpace = this.sessionSpace();
                                    this.set("_checked", sessionSpace?.isActive());
                                    let enabled = true;
                                    if (sessionSpace?.isActive() == true) {
                                        this.set("_enabled", enabled);
                                        return;
                                    }
                                    const maxSessions = this.group()?.Properties?.Registration?.MaximumSessions;
                                    if (maxSessions > 1) {
                                        enabled = this.group().totalChecked() < maxSessions;
                                    }
                                    const maxCapacity = this.Properties?.Registration?.MaxCapacity;
                                    if (maxCapacity !== undefined && this.get("Total") >= maxCapacity) {
                                        enabled = false;
                                    }
                                    this.set("_enabled", enabled);
                                },
                                ch: function (e) {
                                    const sessionId = this.SessionId;
                                    const spaceId = this.space().SpaceId;
                                    const group = this.group();
                                    let ss = this.sessionSpace();
                                    if (e.delegateTarget.checked) {
                                        if (ss) {
                                            ss.set("Status", "PendingActive");
                                        }
                                        else {
                                            ss = that.sessionSpaces.add(new that.sessionSpaceModel({
                                                _Id: this.sessionSpaceId(),
                                                SpaceId: spaceId,
                                                SessionId: sessionId,
                                                Status: "PendingActive"
                                            }));
                                        }
                                        ss.dirty = true;
                                        const maxSessions = group?.Properties?.Registration?.MaximumSessions;
                                        if (maxSessions > 0) {
                                            e.data.parent().forEach((gs) => {
                                                if (maxSessions === 1
                                                    && gs.SessionId != sessionId) {
                                                    gs.sessionSpace()?.set("Status", "PendingRemoved");
                                                }
                                                gs.checkState();
                                            });
                                        }
                                    }
                                    else if (ss) {
                                        ss.set("Status", "PendingRemoved");
                                        group?.checkState();
                                    }
                                    that.sessionSpaces.sync()
                                        .then(() => { })
                                        .catch(r => {
                                        console.error(r);
                                    });
                                },
                                isGroup: function () {
                                    return this.get("SessionId") == null;
                                },
                                isSession: function () {
                                    return this.get("SessionId") != null;
                                },
                                space: getSpace || function () {
                                    return this.group().parentNode();
                                },
                                group: function () {
                                    return this.parentNode();
                                },
                                event: function () {
                                    return this.space().parentNode();
                                },
                                sessionSpaceId: function () {
                                    let sessionId = this.get("SessionId");
                                    let space = this.space();
                                    return sessionId ? `${sessionId}-${space.SpaceId}` : null;
                                },
                                sessionSpace: function () {
                                    return that.sessionSpaces.get(this.sessionSpaceId());
                                },
                                showDates: function () {
                                    if (this.isGroup()) {
                                        return this.get("Properties.DisplayDates") === true;
                                    }
                                    let group = this.group();
                                    if (this.get("Properties.DisplayDates") === false) {
                                        return false;
                                    }
                                    return group == null
                                        || group?.get("Properties.DisplayDates") != true
                                        || this.get("Properties.DisplayDates") === true
                                        || this.get("Start")?.getTime() != group?.get("Start")?.getTime()
                                        || this.get("End")?.getTime() != group?.get("End")?.getTime();
                                },
                                registrationEnabled: function () {
                                    return this.get("RegistrationEnabled");
                                },
                                isRequired: function () {
                                    return this.group()?.Required ?? false;
                                }
                            }
                        }
                    };
                    this.sessionsCombinedDataSourceOptions = {
                        schema: {
                            data: "Sessions",
                            model: {
                                ...this.sessionsDataSourceOptions.schema.model,
                                ...{
                                    children: this.sessionsDataSourceOptions,
                                    checkState: function () {
                                        if (this.IsGroup && this.hasChildren) {
                                            this.children.data().forEach(s => s.checkState());
                                        }
                                        else {
                                            that.sessionsDataSourceOptions.schema.model.checkState.call(this);
                                        }
                                    },
                                    space: getSpace || function () {
                                        return this.parentNode();
                                    },
                                    group: function () { return null; },
                                    totalChecked: function () {
                                        if (this.IsSession) {
                                            return null;
                                        }
                                        return this.children.data()
                                            .filter((s) => s.sessionSpace()?.isActive())
                                            .length;
                                    },
                                }
                            }
                        }
                    };
                    this.spacesDataSourceOptions = {
                        schema: {
                            data: "Spaces",
                            model: {
                                id: "SpaceId",
                                hasChildren: true,
                                children: this.sessionsCombinedDataSourceOptions,
                                checkState: function () {
                                    this.children.data().forEach(s => s.checkState());
                                }
                            }
                        }
                    };
                }
                async read() {
                    await this.sessionSpaces.read();
                    await this.root.read();
                    await this.load(this.root.view());
                    this.updateCounts(this.options.counts, this.root, 0);
                    this.root.data().forEach((node) => node.checkState());
                }
                updateCounts(counts, data, def) {
                    if (data instanceof kendo.data.HierarchicalDataSource) {
                        data = data.data();
                    }
                    else if (data instanceof kendo.data.ObservableArray) {
                    }
                    for (let i = 0; i < data.length; i++) {
                        let item = data[i];
                        if (item.get("SessionId")) {
                            if (counts[item.get("SessionId")] !== undefined) {
                                item.set("Total", counts[item.get("SessionId")]);
                                item.checkState();
                            }
                            else if (def !== undefined) {
                                item.set("Total", def);
                            }
                        }
                        else if (item.children) {
                            this.updateCounts(counts, item.children, def);
                        }
                    }
                    ;
                }
                getSessionSpaces(url, sessionSpaces) {
                    return enroller.util.getDataSource({
                        data: sessionSpaces,
                        model: this.sessionSpaceModel,
                        url: url,
                        transports: ["create", "update"],
                        options: {
                            batch: true,
                            transport: {
                                update: {
                                    method: "POST"
                                },
                                parameterMap: function (data, type) {
                                    if (type != "read") {
                                        data["spaces"] = data.models;
                                        delete data.models;
                                    }
                                    return data;
                                }
                            }
                        }
                    });
                }
                async load(data) {
                    for (let i = 0; i < data.length; i++) {
                        const node = data[i];
                        await node.load();
                        if (node.children && node.children.view) {
                            await this.load(node.children.view());
                        }
                    }
                }
                setSessionSpaces(sessionSpaces) {
                    this.sessionSpaces.data(sessionSpaces);
                    this.root.data().forEach((node) => node.checkState());
                }
            }
            sessions.SpaceSessionRegistration = SpaceSessionRegistration;
            class SpaceSessionRegistrationForSpace extends SpaceSessionRegistration {
                constructor(options) {
                    super(options.event.EventId, options, () => { return { SpaceId: options.spaceId }; });
                    this.sessionSpaces = this.getSessionSpaces(this.options.url, this.options.sessionSpaces);
                    this.root = new kendo.data.HierarchicalDataSource({
                        data: [options.event],
                        schema: {
                            model: {
                                id: "EventId",
                                children: this.sessionsCombinedDataSourceOptions,
                                checkState: function () {
                                    this.children.data().forEach(s => s.checkState());
                                }
                            }
                        }
                    });
                }
            }
            sessions.SpaceSessionRegistrationForSpace = SpaceSessionRegistrationForSpace;
            class SpaceSessionRegistrationForRegistration extends SpaceSessionRegistration {
                constructor(options) {
                    super(options.events[0].EventId, options);
                    let sessionSpaces = [];
                    this.options.events.forEach(e => {
                        e.Spaces = this.options.spaces
                            .filter(space => space.EventId == e.EventId)
                            .map(space => {
                            sessionSpaces.push.apply(sessionSpaces, space.Sessions);
                            space.Sessions = e.Sessions;
                            return space;
                        });
                    });
                    this.sessionSpaces = this.getSessionSpaces(this.options.url, sessionSpaces);
                    this.root = new kendo.data.HierarchicalDataSource({
                        data: this.options.events,
                        schema: {
                            model: {
                                id: "EventId",
                                children: this.spacesDataSourceOptions,
                                hasChildren: true,
                                checkState: function () {
                                    this.children.data().forEach(s => s.checkState());
                                }
                            }
                        }
                    });
                }
            }
            sessions.SpaceSessionRegistrationForRegistration = SpaceSessionRegistrationForRegistration;
        })(sessions = registration.sessions || (registration.sessions = {}));
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        class SessionRegistration {
            constructor(options) {
                let sessionSpaces = new registration.sessions.SpaceSessionRegistrationForRegistration({
                    url: enroller.core.urls.api("registrations", options.registrationId, "sessions"),
                    spaces: options.spaces,
                    events: options.events,
                    counts: options.counts
                });
                this.model = kendo.observable({
                    events: []
                });
                kendo.bind($("#RegistrationSessions"), this.model);
                $("#RegistrationSessions").kendoValidator({
                    rules: {}
                });
                sessionSpaces.read()
                    .then(() => {
                    this.model.set("events", sessionSpaces.root);
                });
            }
        }
        registration.SessionRegistration = SessionRegistration;
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        class SpaceRequestManager extends enroller.ModalSpa {
            constructor(config) {
                super({
                    modal: SpaceRequestManager.Modal,
                    events: {
                        cancel: () => {
                            this.source.cancelChanges();
                        }
                    }
                });
                this.RequestModel = kendo.data.Model.define({
                    id: "SpaceId",
                    fields: {
                        RegistrationId: { type: "number" },
                        SpaceId: { type: "number" },
                        NoteId: { type: "number" },
                        Body: { type: "string" },
                        DisplayName: { type: "string" }
                    }
                });
                this.source = enroller.util.getDataSource({
                    url: enroller.core.urls.api("registrations", config.registrationId, "requests"),
                    data: config.requests,
                    model: this.RequestModel,
                    transports: ["update"],
                    options: {
                        filter: { field: "NoteId", operator: "isnotnull" }
                    }
                });
                this.source.read()
                    .then(() => {
                    this._configureView();
                    kendo.bind($(`#${SpaceRequestManager.Container}`), kendo.observable({
                        requests: this.source
                    }));
                });
            }
            _configureView() {
                let that = this;
                let model = kendo.observable({
                    requests: this.source,
                    request: {},
                    errors: [],
                    save: (e) => {
                        kendo.ui.progress(view.element, true);
                        var request = model.get("request");
                        if (request.isNew()) {
                            that.source.add(request);
                        }
                        that.source.sync()
                            .done(() => {
                            that.close();
                        })
                            .always(() => {
                            kendo.ui.progress(view.element, false);
                        });
                    }
                });
                let view = new kendo.View(SpaceRequestManager.EditView, {
                    model: model,
                    init: function (e) {
                        e.sender.element.kendoValidator();
                    },
                    show: function (e) {
                        e.sender.element.data("kendoValidator").hideMessages();
                    }
                });
                this.router.route("/requests/:spaceId", (spaceId) => {
                    var model = view.model;
                    let request = this.source.get(spaceId);
                    if (!request) {
                        console.error("Could not find request for ", spaceId);
                        return;
                    }
                    model.set("request", request);
                    this.show(view);
                });
            }
        }
        SpaceRequestManager.Container = "Spaces-Requests";
        SpaceRequestManager.Modal = "Spaces-Requests-Modal";
        SpaceRequestManager.EditView = "Spaces-Requests-EditView";
        registration.SpaceRequestManager = SpaceRequestManager;
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        function password(config) {
            let modal = $("#RegistrationPassword-Modal");
            let button = $("#RegisterButton");
            let validator = modal.find("form").kendoValidator().data("kendoValidator");
            button.click(function (e) {
                e.preventDefault();
                modal.modal("show");
                validator.hideMessages();
                model.set("error", false);
            });
            var model = kendo.observable({
                password: null,
                error: false,
                message: null,
                submit: function (e) {
                    e.preventDefault();
                    this.set("error", false);
                    if (validator.validate()) {
                        $.post(enroller.core.urls.api("events", config.eventId, "validatepassword"), {
                            password: this.get("password")
                        })
                            .done(function (result) {
                            if (result === true) {
                                sessionStorage.setItem(config.eventId + "_inputPasswordMatched", true.toString());
                                sessionStorage.setItem(config.eventId + "_password", model.get("password"));
                                window.location.href = config.registrationUrl;
                            }
                            else {
                                model.set("error", true);
                                model.set("message", "Password is incorrect.");
                            }
                        })
                            .fail(function (r) {
                            if (r != null && r.status == 401) {
                                model.set("error", true);
                                model.set("message", "Must be logged in to validate event password.");
                            }
                        });
                    }
                }
            });
            kendo.bind(modal, model);
        }
        registration.password = password;
        class RegistrationManager extends enroller.ModalSpa {
            constructor(config) {
                super({
                    modal: "RegistrationModal"
                });
                let that = this;
                const integrations = {};
                if (config.integrations) {
                    for (const int of config.integrations) {
                        integrations[int] = {};
                    }
                }
                this.Space = kendo.data.Model.define({
                    id: "UserId",
                    fields: {
                        UserId: { type: "string" },
                        EventId: { type: "number" },
                        Email: { type: "string" },
                        FirstName: { type: "string" },
                        Integrations: { type: "object", defaultValue: integrations },
                        LastName: { type: "string" },
                        Status: { type: "string", defaultValue: "Active" },
                        IsRegistered: { type: "boolean" },
                        Profile: { type: "object" }
                    },
                    status: function () {
                        let status = this.get("Status");
                        if (config.counts.max != null && (status === "Incomplete" || status === undefined)) {
                            let registered = that.model.get("counts.registered") || 0;
                            let index = this.parent().indexOf(this);
                            return index + registered < config.counts.max ? "Active" : "Waitlist";
                        }
                        return status ? status.replace("Pending", "") : "Active";
                    },
                    organizationIsOther: function () {
                        let orgId = this.get("Profile.OrganizationId");
                        return this.isCurrentUser() && enroller.constants.organizations.isOther(orgId);
                    },
                    isCurrentUser: function () {
                        return this.get("UserId") === config.user?.id;
                    },
                    showBuilding: function () {
                        let orgId = this.get("Profile.OrganizationId");
                        return this.isCurrentUser() && orgId && enroller.constants.organizations.isOther(orgId) === false;
                    },
                    showOther: function () {
                        let orgId = this.get("Profile.OrganizationId");
                        return this.isCurrentUser() && enroller.constants.organizations.isOther(orgId) === true;
                    }
                });
                this.spaces = new kendo.data.DataSource({
                    schema: {
                        model: this.Space
                    },
                    data: config.spaces
                });
                let password = sessionStorage.getItem(`${config.eventId}_password`);
                let passwordMatched = sessionStorage.getItem(`${config.eventId}_inputPasswordMatched`);
                this.model = kendo.observable({
                    registration: {
                        Spaces: this.spaces,
                        EventPassword: password
                    },
                    passwordMatched: passwordMatched === "true",
                    counts: config.counts,
                    submitting: false,
                    errors: [],
                    submit: (e) => {
                        e.preventDefault();
                        if (this.validator.validate() == false) {
                            console.log(this.validator.errors());
                            return false;
                        }
                        if (this.spaces.total() == 0) {
                            this.model.set("errors", [
                                "You must add at least one attendee."
                            ]);
                            return false;
                        }
                        this.model.set("errors", []);
                        kendo.ui.progress($(config.container), true);
                        this.model.set("submitting", true);
                        enroller.core.http
                            .post(enroller.core.urls.orgApi("registrations"), this.model.get("registration"))
                            .then(async (r) => {
                            const data = await r.json();
                            if (data.Location) {
                                window.location = data.Location;
                            }
                            else {
                                kendo.ui.progress($(config.container), false);
                                this.model.set("submitting", false);
                            }
                            if (r.ok == false) {
                                if (data.Type && data.Title) {
                                    esd.toast.notify(data.Title, null, data.Type);
                                }
                                const errors = enroller.util.extractModelStateErrors(data);
                                this.model.set("errors", errors);
                            }
                        })
                            .catch(r => {
                            esd.toast.error("An error occurred.");
                            kendo.ui.progress($(config.container), false);
                            this.model.set("submitting", false);
                        });
                    },
                    rowClass: function (attendee) {
                        return attendee.status() == "Active"
                            ? "list-group-item list-group-item-info"
                            : "list-group-item list-group-item-light";
                    },
                });
                this._addAttendee(config);
                this._removeAttendee();
                kendo.bind($(config.container), this.model);
                this.validator = $(config.container).kendoValidator().data("kendoValidator");
                console.log(this.validator);
            }
            _addAttendee(config) {
                let that = this;
                let pageSize = 6;
                let searchSource = enroller.util.filterSource(enroller.core.urls.api("users"), {
                    q: () => {
                        return model.get("q");
                    },
                    eventId: config.eventId,
                    requireQuery: true,
                    columns: ["DisplayName"]
                }, {
                    pageSize: 6
                });
                let model = kendo.observable({
                    q: null,
                    results: searchSource,
                    searching: false,
                    search: enroller.util.debounce(function (e) {
                        model.set("searching", true);
                        searchSource.query({
                            page: 1,
                            pageSize: 10,
                            q: e.target.value
                        })
                            .always(() => {
                            model.set("searching", false);
                        });
                    }, 400),
                    add: (e) => {
                        e.preventDefault();
                        let user = e.data;
                        if (user.get("IsRegistered") || this.spaces.get(user.get("Id"))) {
                            return;
                        }
                        else {
                            if (user.UserId == config.user?.id && config.user.profile) {
                                user.set("Profile", config.user.profile);
                            }
                            user.set("EventId", config.eventId);
                            this.spaces.add(user);
                            searchSource.data([]);
                            model.set("q", null);
                            this.close();
                        }
                    },
                    added: (e) => {
                        return this.spaces.get(e.UserId) != null;
                    },
                    canAdd: (e) => {
                        return e.IsRegistered != true && this.spaces.get(e.UserId) == null;
                    },
                    itemClass: function (e) {
                        return this.canAdd(e) ? null : "disabled";
                    },
                });
                let view = new kendo.View("RegistrationAttendee-AddModal", {
                    model: model
                });
                this.router.route("add", () => {
                    this.show(view);
                });
            }
            _removeAttendee() {
                let that = this;
                let view = new kendo.View("RegistrationAttendee-RemoveModal", {
                    model: kendo.observable({
                        attendee: null,
                        remove: function () {
                            that.spaces.remove(this.get("attendee"));
                            that.close();
                        }
                    })
                });
                this.router.route("remove/:uid", (uid) => {
                    let attendee = this.spaces.getByUid(uid);
                    view.model.set("attendee", attendee);
                    this.show(view);
                });
            }
        }
        registration.RegistrationManager = RegistrationManager;
        function attendees(config) {
            new RegistrationManager(config);
        }
        registration.attendees = attendees;
        ;
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        var batch;
        (function (batch) {
            class IndexPage {
                constructor(manager) {
                    this.manager = manager;
                    this.view = new enroller.files.FileMapperView("Registration-BatchManager-Index", {
                        url: this.manager.options.root,
                        model: {
                            input: {
                                Options: {
                                    ShouldEmailConfirmation: this.manager.options.eventStatus == "Active",
                                    Split: this.manager.options.eventStatus == "None",
                                    BypassWaitlist: true,
                                    ContactId: this.manager.options.userId,
                                    PriceModifierIds: [],
                                }
                            }
                        },
                        events: {
                            dataSent: (r) => {
                                this.manager.go(`/${r.notificationId}`);
                            }
                        },
                        fields: enroller.files.FileMapperView.defaultFields,
                        dataFieldName: "Spaces",
                        upload: {
                            url: `${this.manager.options.root}/file`
                        }
                    });
                    this.manager.router.route("/", () => {
                        this.manager.show(this.view);
                    });
                    this.manager.router.route("/reset", () => {
                        this.view.reset();
                        this.manager.go("/");
                    });
                }
            }
            batch.IndexPage = IndexPage;
        })(batch = registration.batch || (registration.batch = {}));
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        var batch;
        (function (batch) {
            class ProcessingPage {
                constructor(manager) {
                    this.manager = manager;
                    this.spaces = new kendo.data.DataSource({ schema: { model: { id: "SpaceId" } } });
                    this.model = kendo.observable({
                        notification: {},
                        spaces: this.spaces,
                    });
                    this.view = new kendo.View("Registration-BatchManager-Processing", {
                        model: this.model,
                        init: (e) => {
                            this.manager.signalr.on(m => m.notification, (notification, log) => {
                                if (typeof notification == "number") {
                                    notification = { Id: notification };
                                }
                                if (this.model.get("notificationId") != notification.Id) {
                                    return;
                                }
                                let stateNotification = {
                                    ...this.model.get("notification").toJSON(),
                                    ...notification
                                };
                                this.model.set("notification", stateNotification);
                                if (log?.SpaceId) {
                                    this.spaces.pushCreate(log);
                                }
                                else {
                                    this.model.set("message", log.Message);
                                }
                            });
                        },
                    });
                    this.manager.router.route("/:notificationId", (notificationId) => {
                        this.model.set("notificationId", notificationId);
                        this.model.set("notification", { Id: notificationId });
                        this.spaces.data([]);
                        this.model.set("message", "Queueing...");
                        this.manager.show(this.view);
                    });
                }
            }
            batch.ProcessingPage = ProcessingPage;
        })(batch = registration.batch || (registration.batch = {}));
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var registration;
    (function (registration) {
        var batch;
        (function (batch) {
            class RegistrationBatchManager extends enroller.PageSpa {
                constructor(options) {
                    super({ layoutElement: "Registration-BatchManager" });
                    this.viewContainers = {
                        index: "#Registration-BatchManager-Index",
                        processing: "#Registration-BatchManager-Processing",
                    };
                    this.options = options;
                    this.signalr = enroller.signalr.connect();
                    new batch.IndexPage(this);
                    new batch.ProcessingPage(this);
                    this.signalr.start().catch(enroller.signalr.error);
                }
            }
            batch.RegistrationBatchManager = RegistrationBatchManager;
            function init(options) {
                new RegistrationBatchManager(options);
            }
            batch.init = init;
        })(batch = registration.batch || (registration.batch = {}));
    })(registration = enroller.registration || (enroller.registration = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var reports;
    (function (reports) {
        function query(type, container, resource) {
            new SingleQueryManager(type, container, resource);
        }
        reports.query = query;
        class SingleQueryManager {
            constructor(type, container, resource) {
                this.runningStatuses = [
                    enroller.enums.QueryRunStatus.Queued,
                    enroller.enums.QueryRunStatus.Retrying,
                    enroller.enums.QueryRunStatus.Running,
                ];
                this.type = type;
                this.resource = resource;
                this.runs = enroller.reports.initRuns(enroller.core.urls.orgApi("report", type, "runs"), {
                    resource: resource,
                    options: {
                        page: 1,
                        pageSize: 1
                    }
                });
                let connection = enroller.reports.initSignalR(this.runs, this.onStatus.bind(this));
                this.model = kendo.observable({
                    errors: [],
                    runs: this.runs,
                    running: false,
                    run: async (e) => {
                        this.model.set("running", true);
                        this.model.set("errors", []);
                        connection.start()
                            .finally(() => {
                            this.start(e);
                        })
                            .catch(enroller.signalr.error);
                    }
                });
                kendo.bind($(container), this.model);
            }
            onStatus(run) {
                this.model.set("running", this.runningStatuses.indexOf(run.Status) > -1);
                if (run.Status == enroller.enums.QueryRunStatus.Complete) {
                    let data = this.runs.data();
                    for (let i = 0; i < data.length; i++) {
                        this.runs.pushDestroy(data[i]);
                    }
                    this.runs.pushInsert(0, run);
                }
                else {
                    this.runs.pushUpdate(run);
                }
            }
            start(e) {
                let button = $(e.delegateTarget);
                this.model.set("running", true);
                this.model.set("errors", []);
                let queryKey = button.data("query");
                $.ajax({
                    url: enroller.core.urls.orgApi("report", this.type, queryKey),
                    method: "POST",
                    data: {
                        parameters: this.resource || {},
                        filters: button.data("filters") || [],
                        output: {
                            templateId: button.data("template"),
                            format: button.data("format")
                        }
                    }
                })
                    .then(r => {
                    this.runs.data([]);
                    this.runs.pushInsert(0, r);
                })
                    .fail(r => {
                    this.handleError(r);
                    this.model.set("running", false);
                });
            }
            handleError(r) {
                if (r.responseJSON && r.responseJSON.Errors) {
                    this.model.set("errors", r.responseJSON.Errors);
                }
                else {
                    var errors = enroller.util.extractModelStateErrors(r);
                    this.model.set("errors", errors);
                }
            }
        }
        reports.SingleQueryManager = SingleQueryManager;
    })(reports = enroller.reports || (enroller.reports = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var reports;
    (function (reports) {
        reports.QueryRun = enroller.kendoui.data.ParsedModel.define({
            id: "QueryRunId",
            fields: {
                Date: { type: "date" }
            }
        });
        function initRuns(url, { resource, options }) {
            let runs = enroller.util.getDataSource({
                url: url,
                transports: ["destroy"],
                model: reports.QueryRun,
                options: {
                    ...{
                        autoSync: true,
                        transport: { read: { data: { resource: resource } } },
                        page: 1,
                        pageSize: 10,
                        filter: [{ field: "Status", operator: "ne", value: enroller.enums.QueryRunStatus.Removed }],
                        sort: [{ field: "Date", dir: "desc" }],
                        serverAggregates: true,
                        serverGrouping: true,
                        serverFiltering: true,
                        serverPaging: true,
                        serverSorting: true,
                    },
                    ...options
                }
            });
            return runs;
        }
        reports.initRuns = initRuns;
        function initSignalR(runs, onStatus) {
            let connection = enroller.signalr.connect();
            connection.on(m => m.reportsQueryRunStatus, (queryRun) => {
                if (onStatus) {
                    onStatus(queryRun);
                }
                if (runs.get(queryRun.QueryRunId)) {
                    runs.pushUpdate(queryRun);
                    if (queryRun.Status == enroller.enums.QueryRunStatus.Complete) {
                        kendo.saveAs({
                            dataURI: "",
                            fileName: `${queryRun.FileName}.${queryRun.Type}`,
                            forceProxy: true,
                            proxyURL: enroller.core.urls.api("report", queryRun.QueryRunId, "download")
                        });
                    }
                }
            });
            return connection;
        }
        reports.initSignalR = initSignalR;
    })(reports = enroller.reports || (enroller.reports = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var payments;
    (function (payments) {
        var invoice;
        (function (invoice) {
            function init(config) {
                new PublicInvoiceManager(config);
            }
            invoice.init = init;
            class PublicInvoiceManager extends enroller.ModalSpa {
                constructor(config) {
                    super({
                        modal: "InvoiceTransactions-Modal",
                        events: {
                            cancel: () => {
                                this.transactions.cancelChanges();
                            }
                        }
                    });
                    this.transactions = new kendo.data.DataSource({
                        schema: {
                            model: {
                                id: "InvoiceItemId"
                            }
                        },
                        data: config.invoice.transactions
                    });
                    this.model = kendo.observable({
                        invoiceId: config.invoice.invoiceId,
                        transactions: this.transactions
                    });
                    kendo.bind($("#InvoiceTransactions"), this.model);
                    var that = this;
                    var view = new kendo.View("InvoicePurchaseOrderForm", {
                        model: kendo.observable({
                            transaction: null,
                            saving: false,
                            save: function (e) {
                                this.set("saving", true);
                                kendo.ui.progress(view.element, true);
                                let transaction = this.get("transaction");
                                $.post(enroller.core.urls.api("invoices", config.invoice.invoiceId, transaction.id), {
                                    Identifier: this.get("transaction.Description")
                                })
                                    .done(() => {
                                    that.transactions.pushUpdate(transaction);
                                    that.close();
                                })
                                    .always(() => {
                                    this.set("saving", false);
                                    kendo.ui.progress(view.element, false);
                                });
                            }
                        }),
                        init: function (e) {
                            e.sender.element.kendoValidator();
                        },
                        show: function (e) {
                            view.model.set("saveIcon", "fa fa-check");
                            e.sender.element.data('kendoValidator').hideMessages();
                        }
                    });
                    this.router.route("/invoice/:id", (id) => {
                        var transaction = this.transactions.get(id);
                        view.model.set("transaction", transaction);
                        this.show(view);
                    });
                }
            }
            invoice.PublicInvoiceManager = PublicInvoiceManager;
        })(invoice = payments.invoice || (payments.invoice = {}));
    })(payments = enroller.payments || (enroller.payments = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var payment;
    (function (payment) {
        class BasePaymentForm {
            get model() { return this._model; }
            get validator() { return this._validator; }
            get container() { return this._container; }
            get config() { return this._config; }
            constructor(config) {
                this._config = config;
                this._container = $("#PaymentForm");
                this._model = this.getModel();
                this._validator = this._container.kendoValidator().data("kendoValidator");
                kendo.bind(this.container, this.model);
            }
            getModel(model) {
                return kendo.observable($.extend({
                    submitting: false,
                    submit: (e) => {
                        if (this.validator.validate() == false) {
                            e.preventDefault();
                            return false;
                        }
                        this.model.set("submitting", true);
                        kendo.ui.progress(this.container, true);
                    }
                }, model));
            }
        }
        payment.BasePaymentForm = BasePaymentForm;
        class PaymentForm extends BasePaymentForm {
            constructor() {
                super();
            }
        }
        payment.PaymentForm = PaymentForm;
        class PurchaseOrderForm extends BasePaymentForm {
            constructor(config) {
                super(config);
            }
            getModel(model) {
                var organization = null;
                if (this.config.transaction != null) {
                    organization = {
                        OfficialName: this.config.transaction.BusinessName,
                        OrganizationId: this.config.transaction.OrganizationId
                    };
                }
                if (this.config.transaction.Address == null) {
                    this.config.transaction.Address = {};
                }
                return super.getModel({
                    organizations: enroller.util.filterSource(enroller.core.urls.api("organizations")),
                    transaction: this.config.transaction,
                    organization: organization,
                    changeOrgId: (e) => {
                        var org = this.model.get("organization");
                        if (org === null || typeof org === "string") {
                            var transaction = this.model.get("transaction");
                            if (transaction != null && transaction.OrganizationId > 0) {
                                this.model.set("transaction", {
                                    BusinessName: org,
                                    Address: {}
                                });
                            }
                            this.model.set("transaction.BusinessName", org);
                        }
                        else {
                            this.validator.hideMessages();
                            $.get(enroller.core.urls.api("organizations", org.OrganizationId))
                                .done((data) => {
                                this.model.set("transaction", {
                                    OrganizationId: data.OrganizationId,
                                    BusinessName: data.OfficialName,
                                    Email: data.Email,
                                    Phone: data.PrimaryPhone,
                                    Address: data.MailingAddress
                                });
                            });
                        }
                    },
                    contactEnabled: () => {
                        var org = this.model.get("organization");
                        return typeof org === "string" || org?.OrganizationId == null
                            || this.config.otherIds.indexOf(org?.OrganizationId) > -1;
                    },
                });
            }
        }
        payment.PurchaseOrderForm = PurchaseOrderForm;
    })(payment = enroller.payment || (enroller.payment = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var files;
    (function (files) {
        class FileMapperView extends kendo.Layout {
            constructor(element, options) {
                super(element, {
                    tagName: options.tagName,
                    evalTemplate: options.evalTemplate,
                    wrap: options.wrap ?? false,
                    init: (e) => {
                        this.validator = e.sender.element.kendoValidator().data("kendoValidator");
                        if ($("#FileMapper-FileOptions").length) {
                        }
                        this.upload = this.getUploader();
                        this.grid = this.getGrid();
                        this.options.init?.call(this, e);
                    },
                    show: (e) => {
                        this.validator?.hideMessages();
                        this.options.show?.call(this, e);
                        ;
                    },
                    hide: options.hide,
                });
                this.options = options;
                let Field = kendo.data.Model.define({
                    id: "name",
                    fields: {
                        name: { type: "string" },
                        title: { type: "string" },
                        column: { type: "string", defaultValue: null },
                        required: { type: "boolean", defaultValue: false },
                        description: { type: "string" },
                        icon: { type: "string" },
                    },
                });
                this.fields = new kendo.data.ObservableArray(this.options.fields.map(f => {
                    let field = new Field(f);
                    return field;
                }));
                this.initModel();
            }
            fieldsChange(e) {
                if (e.field) {
                    for (let i = 0; i < e.items.length; i++) {
                        let item = e.items[i];
                        this.model.set(`mapping.${item.get("name")}`, item.get("column"));
                        this.fields.forEach(f => {
                            if (f.id !== item.id && f.get("column") && f.get("column") == item.get("column")) {
                                f.set("column", null);
                            }
                        });
                    }
                }
                this.resetGrid();
            }
            resetGrid() {
                if (!this.resetGridTimeout) {
                    this.resetGridTimeout = window.setTimeout(() => {
                        this.resetGridTimeout = null;
                        this.grid.setOptions({});
                    }, 50);
                }
            }
            getUploader() {
                let options = {
                    ...{
                        multiple: false,
                        async: {
                            saveUrl: this.options.upload.url,
                            autoUpload: this.options.upload.autoUpload ?? true
                        },
                        validation: {
                            allowedExtensions: [".csv", ".xlsx", ".xls"]
                        },
                        localization: {
                            select: "Select Excel or CSV file..."
                        },
                        success: (e) => {
                            this.raw = e.response.data;
                            this.refreshData(this.model.get("hasHeaders"));
                            this.model.set("file", e.files[0]);
                            if (this.options.upload.success) {
                                this.options.upload.success(e);
                            }
                        },
                        error: (e) => {
                            this.model.set("errors.upload", enroller.util.extractModelStateErrors(e));
                        },
                        upload: (e) => {
                            this.model.set("errors.upload", []);
                            if (e.files && e.files.length > 1) {
                                this.model.set("errors.upload", ["Only one file is allowed."]);
                                e.preventDefault();
                            }
                            let fileOptions = this.model.get("fileOptions");
                            if (fileOptions) {
                                this.saveFileOptions(fileOptions);
                                if (fileOptions) {
                                    e.data = enroller.util.jsonToForm(fileOptions, e.formData);
                                }
                            }
                        },
                    },
                    ...this.options.upload.options
                };
                return $(this.options.upload.element || "#FileMapper-File").kendoUpload(options).data("kendoUpload");
            }
            getGrid() {
                let columns = this.fields.map(f => {
                    return {
                        field: f.get("name"),
                        title: f.get("title")
                    };
                });
                if (this.options.grid?.options?.editable !== false) {
                    columns.push({ command: "destroy" });
                }
                return $(this.options.grid?.element || "#FileMapper-Grid").kendoGrid({
                    ...{
                        columns: columns,
                        editable: true,
                        dataSource: this.source,
                        sortable: true,
                        filterable: true,
                        reorderable: true,
                        resizable: true,
                        toolbar: ["search"],
                        columnMenu: true,
                        pageable: {
                            pageSize: 10,
                            pageSizes: [10, 30, 50],
                            alwaysVisible: false
                        },
                        noRecords: {
                            template: () => {
                                if (this.model.get("file")) {
                                    return "No data could be extracted from the file.";
                                }
                                else {
                                    return "Upload a file to preview data.";
                                }
                            }
                        }
                    },
                    ...this.options.grid?.options
                }).data("kendoGrid");
            }
            initModel() {
                var _a;
                this.source = new kendo.data.DataSource({
                    schema: { model: { id: "uid" } },
                    batch: true,
                    page: 1,
                    pageSize: 10
                });
                (_a = this.options).model ?? (_a.model = {});
                this.model = kendo.observable({
                    ...this.options.model,
                    ...{
                        errors: {
                            upload: [],
                            validation: [],
                        },
                        fileOptions: this.getFileOptions(this.options.model?.fileOptions),
                        columns: [],
                        mapping: {},
                        fields: {
                            required: this.fields.filter(f => f.get("required")),
                            optional: this.fields.filter(f => !f.get("required")),
                        },
                        data: this.source,
                        file: null,
                        hasHeaders: this.options.headersFromServer,
                        fileSize: function () {
                            return enroller.format.bytes(this.get("file.size"));
                        },
                        canSubmit: () => {
                            return this.model.get("file") && this.source.total() > 0;
                        },
                        hideHeaderRowToggle: this.options.hideHeaderRowToggle ?? false,
                        toggleHeaders: (e) => {
                            this.refreshData(e.currentTarget.checked);
                        },
                        reset: (e) => {
                            e.preventDefault();
                            this.reset();
                        },
                        submit: (e) => {
                            if (!this.validator.validate()) {
                                this.model.set("errors.validation", this.validator.errors());
                                return;
                            }
                            let columns = this.grid.columns.slice(0);
                            for (var key in columns) {
                                columns[key].hidden = false;
                            }
                            let exporter = new kendo.ExcelExporter({
                                columns: columns,
                                dataSource: this.source,
                                allPages: true,
                                filterable: true,
                                hierarchy: false,
                            });
                            exporter.workbook().then((book, records) => {
                                if (this.validateData(records)) {
                                    let data = this.model.get("input")?.toJSON() || {};
                                    let mapping = this.model.get("mapping").toJSON();
                                    data[this.options.dataFieldName] = [];
                                    for (let i = 0; i < records.length; i++) {
                                        let record = {};
                                        let row = records[i].toJSON();
                                        if (this.options.includeAllData) {
                                            for (let c = 0; c < this.grid.columns.length; c++) {
                                                let f = this.grid.columns[c].title || this.grid.columns[c].field;
                                                if (f) {
                                                    record[f] = row[this.grid.columns[c].field];
                                                }
                                            }
                                        }
                                        for (let k in mapping) {
                                            if (mapping.hasOwnProperty(k)) {
                                                record[k] = row[mapping[k]];
                                            }
                                        }
                                        data[this.options.dataFieldName].push(record);
                                    }
                                    if (this.options.events.setData?.call(this, data) === false) {
                                        return;
                                    }
                                    let url = $.isFunction(this.options.url)
                                        ? this.options.url(data)
                                        : this.options.url;
                                    this.model.set("saving", true);
                                    enroller.util.processing(e.delegateTarget, true);
                                    kendo.ui.progress(this.element, false);
                                    $.ajax({
                                        method: "POST",
                                        url: url,
                                        data: data
                                    })
                                        .then(this.options.events.dataSent)
                                        .fail(r => {
                                        let errors = enroller.util.extractModelStateErrors(r);
                                        this.model.set("errors.validation", errors);
                                    })
                                        .always(() => {
                                        this.model.set("saving", false);
                                        enroller.util.processing(e.delegateTarget, false);
                                        kendo.ui.progress(this.element, false);
                                    });
                                }
                            });
                        }
                    }
                });
            }
            reset() {
                this.upload?.clearAllFiles();
                this.validator?.hideMessages();
                this.model.set("errors", {});
                this.model.set("data", {});
                this.model.set("file", null);
                this.model.set("columns", []);
                this.source.data([]);
                this.raw = [];
            }
            refreshData(hasHeaders) {
                let columns = [];
                if (!this.raw) {
                    return;
                }
                let row1 = this.raw[0];
                let data = this.raw;
                let headersInData = hasHeaders && !this.options.headersFromServer;
                if (headersInData) {
                    data = data.slice(1);
                }
                for (let i in row1) {
                    if (row1.hasOwnProperty(i)) {
                        columns.push({
                            field: i,
                            title: headersInData ? row1[i] : i,
                            hidden: false
                        });
                    }
                }
                this.model.set("columns", columns);
                if (hasHeaders) {
                    let mapping = this.model.get("mapping").toJSON();
                    for (let i = 0; i < this.fields.length; i++) {
                        let field = this.fields[i];
                        if (mapping[field.get("name")] == null) {
                            let column = columns.find(c => field.get("search")?.some(s => `${c.title}`.toLowerCase().indexOf(s) > -1));
                            if (column) {
                            }
                            field.set("column", column?.field);
                            mapping[field.get("name")] = column?.field;
                        }
                    }
                    this.model.set("mapping", mapping);
                }
                for (let i = 0; i < columns.length; i++) {
                    columns[i].headerTemplate = this.gridHeaderTemplate(columns[i]);
                    columns[i].template = this.gridTemplate(columns[i]);
                }
                if (this.grid.options.editable !== false) {
                    columns.push({
                        command: [{ name: "destroy", text: "Remove" }],
                        attributes: { "class": "text-center" },
                        width: 100
                    });
                }
                this.source.page(1);
                this.source.data([]);
                this.grid.setOptions({
                    columns: columns,
                });
                this.source.data(data);
                this.fields.bind("change", this.fieldsChange.bind(this));
            }
            gridHeaderTemplate(column) {
                return () => {
                    let mapping = this.model.get("mapping");
                    for (let i = 0; i < this.fields.length; i++) {
                        let field = this.fields[i];
                        if (mapping[field.get("name")] === column.field) {
                            return `<div class="text-success">${enroller.util.icon("circle-check")} ${this.fields[i].get("title")}</div><small class="text-muted">${column.title || column.field}</small>`;
                        }
                    }
                    return column.title || column.field;
                };
            }
            gridTemplate(column) {
                return (data) => {
                    let emailColumn = this.model.get("mapping.Email");
                    if (column.field != emailColumn) {
                        return data[column.field];
                    }
                    let email = data[column.field] || "";
                    return !enroller.util.isEmail(email.toString().trim())
                        ? `<span class="text-danger">${data[column.field]}</span>`
                        : data[column.field];
                };
            }
            validateData(data) {
                let errors = this.validator.errors() || [];
                this.validator.validate();
                if (this.options.validation?.email !== false) {
                    let emailColumn = this.model.get("mapping.Email");
                    if (!emailColumn) {
                        return false;
                    }
                    for (let i = 0; i < data.length; i++) {
                        let email = data[i][emailColumn] || "";
                        if (!enroller.util.isEmail(email)) {
                            errors.push(`Invalid email: "${email}"`);
                        }
                    }
                }
                if (this.options.validateData) {
                    this.options.validateData(data, errors);
                }
                this.model.set("errors.validation", errors);
                return errors.length == 0;
            }
            saveFileOptions(options) {
                localStorage.setItem(`${document.location}.FileMapper`, kendo.stringify(options));
            }
            getFileOptions(options) {
                let stored = localStorage.getItem(`${document.location}.FileMapper`);
                if (stored) {
                    return typeof stored === "string" ? JSON.parse(stored) : stored;
                }
                return options;
            }
        }
        FileMapperView.defaultFields = [
            { name: "Email", title: "Email", required: true, search: ["email", "e_mail", "e-mail"], icon: "envelope" },
            { name: "FirstName", title: "First Name", required: true, search: ["first", "fname"] },
            { name: "LastName", title: "Last Name", required: true, search: ["last", "lname"] },
        ];
        files.FileMapperView = FileMapperView;
    })(files = enroller.files || (enroller.files = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var files;
    (function (files) {
        class FileManager extends enroller.ModalSpa {
            constructor(options) {
                super({
                    modal: options.modal
                });
                this.uploadList = new files.UploadList({
                    url: options.url,
                    localization: {},
                    allowedFileTypes: ["pdf", "doc", "docx", "xls", "xlsx", "png", "jpg", "jpeg", "tiff"],
                    change: options.change,
                    max: 500
                });
                this.uploadList.source.read();
                const uploadView = new kendo.View(`${options.modal}-Form`, {
                    model: this.uploadList.model,
                    init: (e) => {
                        this.uploadList.initUploadWidget(e.sender.element);
                    }
                });
                this.router.route(`/${options.route}/add`, () => {
                    this.show(uploadView, { animation: 'swap' });
                });
            }
        }
        files.FileManager = FileManager;
    })(files = enroller.files || (enroller.files = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var files;
    (function (files) {
        function uploadList(el, config) {
            if ($(el).length === 0) {
                return;
            }
            var uploadList = new UploadList(config);
            kendo.bind($(el), uploadList.model);
            uploadList.initUploadWidget($(el));
        }
        files.uploadList = uploadList;
        class UploadList {
            constructor(config) {
                this.options = $.extend({}, {
                    max: 20,
                    maxSize: 200
                }, config);
                this._sources = {};
                this.source = this.getSource(this.options.url);
                var that = this;
                this.model = kendo.observable({
                    url: config.url,
                    files: this.source,
                    errors: [],
                    allowUpload: function () {
                        return this.get("files").total() < that.options.max;
                    },
                    remove: (e) => {
                        var message = `Are you sure you wish to delete '${e.data.OriginalFileName}'?`;
                        if (confirm(message)) {
                            this.source.remove(e.data);
                            this.source.sync();
                        }
                    },
                });
                if (config.container) {
                    this.initUploadWidget(config.container);
                }
            }
            getSource(url) {
                if (this._sources[url] == undefined) {
                    this._sources[url] = new kendo.data.DataSource({
                        schema: {
                            model: enroller.kendoui.data.ParsedModel.define({
                                id: "FileName",
                                fields: [
                                    { field: "LastModified", type: "date" }
                                ],
                                url: function () {
                                    return `${url}?f=${encodeURIComponent(this.get("FileName"))}`;
                                }
                            })
                        },
                        transport: {
                            read: {
                                url: url
                            },
                            destroy: {
                                url: e => `${url}?f=${encodeURIComponent(e.FileName)}`,
                                type: "DELETE"
                            }
                        },
                        change: this.options.change
                    });
                }
                return this._sources[url];
            }
            setUrl(url) {
                this.options.url = url;
                this.source = this.getSource(url);
                this.model.set("files", this.source);
                this.model.set("url", url);
                this.uploader?.setOptions({
                    async: { saveUrl: url, autoUpload: true }
                });
            }
            initUploadWidget(el) {
                el = $(el);
                if (el.length === 0) {
                    return;
                }
                this.uploader = el.find("input[type=file]").kendoUpload({
                    async: { saveUrl: this.model.get("url"), autoUpload: true },
                    localization: this.options.localization,
                    error: (e) => {
                        var errors = enroller.util.extractModelStateErrors(e);
                        this.model.set("errors", errors);
                    },
                    success: (e) => {
                        for (var f in e.files) {
                            e.sender.clearFileByUid(e.files[f].uid);
                        }
                        if (e.response !== undefined) {
                            this.source.pushCreate(e.response);
                        }
                    },
                    upload: (e) => {
                        this.model.set('errors', []);
                        if (e.files.length > 0) {
                            if (e.files.length + this.source.total() > this.options.max) {
                                esd.toast.warning(`Maximum of ${this.options.max} files allowed to be uploaded.`);
                                e.preventDefault();
                            }
                            for (var i = 0; i < e.files.length; i++) {
                                if (e.files[i].size > 1024 * 1024 * this.options.maxSize) {
                                    esd.toast.warning(`The file ${e.files[i].name} exceeds the maximum allowed size of ${this.options.maxSize}MB.`);
                                    e.preventDefault();
                                }
                                var ext = e.files[i].extension.toLowerCase().substring(1);
                                if (this.options.allowedFileTypes && this.options.allowedFileTypes.indexOf(ext) == -1) {
                                    esd.toast.warning(`The file ${e.files[i].name}is not of an allowed type.`);
                                    e.preventDefault();
                                }
                            }
                        }
                    }
                }).data("kendoUpload");
                return this.uploader;
            }
        }
        files.UploadList = UploadList;
    })(files = enroller.files || (enroller.files = {}));
})(enroller || (enroller = {}));
var enroller;
(function (enroller) {
    var surveys;
    (function (surveys) {
        function form(container, answers) {
            container = $(container);
            kendo.bind(container, {
                answers: answers
            });
            let active = (el) => {
                el = $(el);
                let c = "active";
                el.addClass(c);
                el.prevAll("label").addClass(c);
                el.nextAll("label").removeClass(c);
            };
            container.find('.enr-rating input').change(e => {
                active($(e.delegateTarget).next("label"));
                e.delegateTarget.parentElement.classList.remove("selecting");
            });
            container.find('.enr-rating label').hover(e => {
                e.delegateTarget.parentElement.classList.add("selecting");
                let target = $(e.delegateTarget);
                let c = "selecting-active";
                target.addClass(c);
                target.prevAll("label").addClass(c);
                target.nextAll("label").removeClass(c);
            });
            container.find('.enr-rating').hover(e => {
                $(e.delegateTarget).addClass("selecting");
            }, e => {
                $(e.delegateTarget).removeClass("selecting");
            });
            container.find(".enr-rating input:checked").each((el) => active($(this)));
            let validator = container.kendoValidator().data("kendoValidator");
        }
        surveys.form = form;
    })(surveys = enroller.surveys || (enroller.surveys = {}));
})(enroller || (enroller = {}));
//# sourceMappingURL=enroller.www.js.map